// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*/
/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/
*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}
::before,
::after {
  --tw-content: '';
}
/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/
html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}
/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/
body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}
/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/
hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}
/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/
abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}
/*
Remove the default font size and weight for headings.
*/
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}
/*
Reset links to optimize for opt-in styling instead of opt-out.
*/
a {
  color: inherit;
  text-decoration: inherit;
}
/*
Add the correct font weight in Edge and Safari.
*/
b,
strong {
  font-weight: bolder;
}
/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/
code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}
/*
Add the correct font size in all browsers.
*/
small {
  font-size: 80%;
}
/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/
table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}
/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/
button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}
/*
Remove the inheritance of text transform in Edge and Firefox.
*/
button,
select {
  text-transform: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/
button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}
/*
Use the modern Firefox focus style for all focusable elements.
*/
:-moz-focusring {
  outline: auto;
}
/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/
:-moz-ui-invalid {
  box-shadow: none;
}
/*
Add the correct vertical alignment in Chrome and Firefox.
*/
progress {
  vertical-align: baseline;
}
/*
Correct the cursor style of increment and decrement buttons in Safari.
*/
::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}
/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/
[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}
/*
Remove the inner padding in Chrome and Safari on macOS.
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/
::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}
/*
Add the correct display in Chrome and Safari.
*/
summary {
  display: list-item;
}
/*
Removes the default spacing and border for appropriate elements.
*/
blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}
fieldset {
  margin: 0;
  padding: 0;
}
legend {
  padding: 0;
}
ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}
/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}
/*
Prevent resizing textareas horizontally by default.
*/
textarea {
  resize: vertical;
}
/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/
input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}
/*
Set the default cursor for buttons.
*/
button,
[role="button"] {
  cursor: pointer;
}
/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}
/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/
img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}
/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/
img,
video {
  max-width: 100%;
  height: auto;
}
/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.\\!container{
  width: 100% !important;
}
.container{
  width: 100%;
}
@media (min-width: 640px){
  .\\!container{
    max-width: 640px !important;
  }
  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){
  .\\!container{
    max-width: 768px !important;
  }
  .container{
    max-width: 768px;
  }
}
@media (min-width: 1024px){
  .\\!container{
    max-width: 1024px !important;
  }
  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1280px){
  .\\!container{
    max-width: 1280px !important;
  }
  .container{
    max-width: 1280px;
  }
}
@media (min-width: 1536px){
  .\\!container{
    max-width: 1536px !important;
  }
  .container{
    max-width: 1536px;
  }
}
.visible{
  visibility: visible;
}
.collapse{
  visibility: collapse;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.hidden{
  display: none;
}
.h-32{
  height: 8rem;
}
.h-full{
  height: 100%;
}
.w-full{
  width: 100%;
}
.max-w-md{
  max-width: 28rem;
}
.flex-shrink{
  flex-shrink: 1;
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.resize{
  resize: both;
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.flex-wrap{
  flex-wrap: wrap;
}
.items-center{
  align-items: center;
}
.justify-center{
  justify-content: center;
}
.gap-2{
  gap: 0.5rem;
}
.gap-4{
  gap: 1rem;
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.rounded{
  border-radius: 0.25rem;
}
.border{
  border-width: 1px;
}
.border-blue-200{
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}
.border-green-200{
  --tw-border-opacity: 1;
  border-color: rgb(187 247 208 / var(--tw-border-opacity, 1));
}
.border-red-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-red-400{
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / var(--tw-border-opacity, 1));
}
.bg-blue-100{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-50{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-500{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-500{
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}
.bg-green-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.bg-green-500{
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.bg-red-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-red-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-red-500{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.p-2{
  padding: 0.5rem;
}
.p-3{
  padding: 0.75rem;
}
.p-4{
  padding: 1rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.text-center{
  text-align: center;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.font-bold{
  font-weight: 700;
}
.font-medium{
  font-weight: 500;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.capitalize{
  text-transform: capitalize;
}
.italic{
  font-style: italic;
}
.text-blue-700{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-gray-500{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-green-600{
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-green-700{
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.text-red-700{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.line-through{
  text-decoration-line: line-through;
}
.outline{
  outline-style: solid;
}
.blur{
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale{
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

body {
  line-height: 1;
}

ol,
ul {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

* {
  box-sizing: border-box;
}
*::before, *::after {
  box-sizing: border-box;
}

a {
  color: inherit;
  text-decoration: none;
  cursor: pointer;
}

button {
  cursor: pointer;
}

/** Break Points **/
/** Break Points **/
html {
  font-size: 0.6944444444vw;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
}
@media (min-width: 1440px) {
  html {
    font-size: 62.5%;
  }
}
@media (max-width: 565px) {
  html {
    font-size: 1.8181818182vw;
  }
}

:root {
  --font-primary: Inter, sans-serif;
}

body {
  font-family: var(--font-primary);
  font-size: 16px;
  color: #000000;
}

.main {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.inner {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 1440px;
  width: 100%;
  margin: auto;
}
@media (max-width: 565px) {
  .inner {
    margin: 0 auto;
  }
}

.hidden-scroll-bar::-webkit-scrollbar {
  display: none;
}

.pointer {
  cursor: pointer;
}

.confetti {
  margin-top: 4rem;
}
@media (max-width: 565px) {
  .confetti {
    display: none;
  }
}

.team {
  width: 100%;
  padding: 80px 0 80px 200px;
}
.team__title {
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding-right: 20px;
  font-size: 10vw;
  margin-bottom: 20px;
  font-weight: 800;
}
.team__subtitle {
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding-right: 20px;
  font-size: 20px;
  margin-bottom: 100px;
  line-height: 140%;
}
.team__slide {
  display: flex;
  align-items: start;
  gap: 20px;
  overflow-x: auto;
}
.team__slide::-webkit-scrollbar {
  display: none;
}
.team__slide > :nth-child(odd) .team__slide__card__bg {
  background: rgb(186, 201, 154);
}
.team__slide__card {
  min-width: 350px;
}
.team__slide__card__bg {
  height: fit-content;
  background: rgb(177, 154, 177);
  margin-bottom: 20px;
  padding: 64px;
  border-radius: 12px;
  height: 350px;
}
.team__slide__card__bg__img {
  word-wrap: 100%;
  height: 100%;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
}
.team__slide__card__title {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 18px;
  line-height: 120%;
}
.team__slide__card__role {
  font-weight: 400;
  line-height: 120%;
}

.sidebar {
  width: 100%;
  height: auto;
  background-color: #ffffff;
  border-bottom: 1px solid #e5e7eb;
  padding: 16px;
}
@media (min-width: 769px) {
  .sidebar {
    width: 250px;
    height: 100vh;
    border-right: 1px solid #e5e7eb;
    border-bottom: none;
    padding: 24px;
  }
}
.sidebar__logo {
  width: 100%;
  height: auto;
  padding-bottom: 16px;
  border-bottom: 1px solid #e5e7eb;
  text-align: center;
}
@media (min-width: 769px) {
  .sidebar__logo {
    padding-bottom: 24px;
    text-align: left;
  }
}
.sidebar__title {
  color: #111827;
  font-size: 20px;
  font-weight: 600;
}
@media (min-width: 769px) {
  .sidebar__title {
    font-size: 24px;
  }
}
.sidebar__nav {
  margin-top: 16px;
}
@media (min-width: 769px) {
  .sidebar__nav {
    margin-top: 24px;
  }
}
.sidebar__menu {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
@media (min-width: 769px) {
  .sidebar__menu {
    flex-direction: column;
    gap: 8px;
  }
}
.sidebar__menu-item {
  flex: 1 1;
  min-width: 80px;
  margin: 0;
}
@media (min-width: 769px) {
  .sidebar__menu-item {
    flex: none;
    margin-bottom: 8px;
  }
}
.sidebar__menu-item--active .sidebar__link {
  background-color: #FA9411;
  color: #ffffff;
}
.sidebar__menu-item--active .sidebar__link .sidebar__icon {
  stroke: #ffffff;
  min-width: 20px;
}
.sidebar__menu-item--active .sidebar__link:hover {
  background-color: #FA9411;
}
.sidebar__link {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px;
  color: #4b5563;
  text-decoration: none;
  border-radius: 6px;
  transition: all 0.2s;
  text-align: center;
}
@media (min-width: 769px) {
  .sidebar__link {
    flex-direction: row;
    justify-content: flex-start;
    gap: 12px;
    padding: 12px 16px;
    text-align: left;
  }
}
.sidebar__link:hover {
  background-color: #f9fafb;
  color: #111827;
}
.sidebar__link:hover .sidebar__icon {
  stroke: #111827;
}
.sidebar__link span {
  font-size: 10px;
}
@media (min-width: 769px) {
  .sidebar__link span {
    font-size: 16px;
  }
}
.sidebar__icon {
  stroke: #4b5563;
  transition: stroke 0.2s;
  flex-shrink: 0;
}
.sidebar__group {
  margin-bottom: 8px;
}
@media (min-width: 769px) {
  .sidebar__group {
    margin-bottom: 12px;
  }
}
.sidebar__group-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px 16px;
  background-color: #f9fafb;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  color: #374151;
  font-size: 11px;
}
@media (min-width: 769px) {
  .sidebar__group-header {
    padding: 10px 12px;
    font-size: 12px;
  }
}
.sidebar__group-header:hover {
  background-color: #e5e7eb;
  color: #111827;
}
.sidebar__group-header--expanded {
  background-color: #e5e7eb;
  color: #111827;
}
.sidebar__group-header .sidebar__icon {
  width: 14px;
  height: 14px;
  stroke: currentColor;
  flex-shrink: 0;
}
.sidebar__group-items {
  margin-top: 4px;
  padding-left: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
@media (min-width: 769px) {
  .sidebar__group-items {
    margin-top: 6px;
    gap: 4px;
  }
}
.sidebar__group-items .sidebar__menu-item {
  margin-bottom: 0;
}
.sidebar__group-items .sidebar__link {
  padding: 10px 16px;
  font-size: 14px;
}
@media (min-width: 769px) {
  .sidebar__group-items .sidebar__link {
    padding: 10px 16px 10px 48px;
  }
}

.id-generator {
  min-height: 100vh;
  background-color: #f9fafb;
  padding: 48px 16px;
}
@media (max-width: 565px) {
  .id-generator {
    padding: 0;
  }
}
.id-generator__container {
  max-width: 448px;
  margin: 0 auto;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  padding: 32px;
}
@media (min-width: 768px) {
  .id-generator__container {
    max-width: 900px;
  }
}
.id-generator__header {
  margin-bottom: 32px;
  text-align: center;
}
.id-generator__header-title {
  font-size: 24px;
  font-weight: 700;
  color: #111827;
  text-transform: capitalize;
}
@media (max-width: 565px) {
  .id-generator__header-title {
    font-size: 16px;
  }
}
.id-generator__header-subtitle {
  margin-top: 8px;
  font-size: 14px;
  color: #4b5563;
}
.id-generator__header-subtitle-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: 8px;
  flex-wrap: wrap;
}
.id-generator__generate-btn {
  padding: 6px 16px;
  background-color: #FA9411;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  white-space: nowrap;
}
.id-generator__generate-btn:hover:not(:disabled) {
  background-color: #FA9411;
}
.id-generator__generate-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.id-generator__content {
  display: flex;
  flex-direction: column;
  gap: 32px;
}
.id-generator__photo {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}
.id-generator__photo-preview {
  position: relative;
  width: 160px;
}
.id-generator__photo-preview-container {
  width: 160px;
  height: 160px;
  border-radius: 8px;
  overflow: hidden;
  border: 2px solid #e5e7eb;
}
.id-generator__photo-preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.id-generator__photo-preview-loading {
  position: absolute;
  inset: 0;
  background-color: rgba(255, 255, 255, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
}
.id-generator__photo-preview-loading-spinner {
  width: 24px;
  height: 24px;
  border: 2px solid #e5e7eb;
  border-top-color: #FA9411;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
.id-generator__photo-remove {
  position: absolute;
  top: -8px;
  right: -8px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 12px;
  color: #4b5563;
}
.id-generator__photo-remove:hover {
  background-color: #f9fafb;
}
.id-generator__photo-button {
  display: inline-flex;
  align-items: center;
  padding: 8px 16px;
  border: 1px solid transparent;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  color: #ffffff;
  background-color: #FA9411;
  transition: background-color 0.2s;
}
.id-generator__photo-button:hover {
  background-color: #FA9411;
}
.id-generator__photo-button:focus {
  outline: none;
  ring: 2px;
  ring-offset: 2px;
  ring-color: #FA9411;
}
.id-generator__photo-button:disabled {
  background-color: #d1d5db;
  cursor: not-allowed;
}
.id-generator__form-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
}
@media (min-width: 640px) {
  .id-generator__form-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (min-width: 1024px) {
  .id-generator__form-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
.id-generator__form-group {
  margin-bottom: 0;
}
.id-generator__form-group--full {
  grid-column: 1/-1;
}
@media (min-width: 768px) {
  .id-generator__form__container {
    max-width: 900px;
  }
}
@media (min-width: 1024px) {
  .id-generator__form__container {
    max-width: 1200px;
  }
}
.id-generator__form-label {
  font-size: 14px;
  font-weight: 500;
  color: #4b5563;
  margin-bottom: 4px;
  display: block;
}
.id-generator__form-value {
  font-size: 16px;
  color: #111827;
}
.id-generator__form-input {
  width: 100%;
  padding: 8px 12px;
  background-color: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}
.id-generator__form-input:focus {
  outline: none;
  border-color: #FA9411;
  ring: 2px;
  ring-color: #FA9411;
}
.id-generator__form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.id-generator__form-prescription {
  margin-bottom: 16px;
}
.id-generator__form-prescription-inputs {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr auto;
  gap: 12px;
  align-items: start;
}
.id-generator__form-group--full {
  grid-column: 1/-1;
}
.id-generator__past-appointments {
  margin-top: 32px;
}
.id-generator__appointment-card {
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  margin-bottom: 12px;
}
.id-generator__appointment-header {
  width: 100%;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
}
.id-generator__appointment-header:hover {
  background-color: #f9fafb;
}
.id-generator__appointment-content {
  padding: 16px;
  border-top: 1px solid #e5e7eb;
}
.id-generator__appointment-section {
  margin-bottom: 16px;
}
.id-generator__appointment-section:last-child {
  margin-bottom: 0;
}
.id-generator__appointment-prescription {
  padding: 8px 0;
  border-bottom: 1px solid #e5e7eb;
}
.id-generator__appointment-prescription:last-child {
  border-bottom: none;
}
.id-generator__appointment-toggle {
  font-size: 12px;
  color: #4b5563;
}
.id-generator__actions {
  margin-top: 32px;
  display: flex;
  justify-content: center;
  gap: 16px;
}
.id-generator__actions-register {
  display: inline-flex;
  align-items: center;
  padding: 8px 16px;
  border: 1px solid transparent;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  color: #ffffff;
  background-color: #FA9411;
  transition: background-color 0.2s;
}
.id-generator__actions-register:hover {
  background-color: #FA9411;
}
.id-generator__actions-register:focus {
  outline: none;
  ring: 2px;
  ring-offset: 2px;
  ring-color: #FA9411;
}
.id-generator__actions-register:disabled {
  background-color: #d1d5db;
  cursor: not-allowed;
}
.id-generator__actions-register-big {
  display: inline-flex;
  align-items: center;
  padding: 8px 16px;
  border: 1px solid transparent;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  color: #ffffff;
  background-color: #FA9411;
  transition: background-color 0.2s;
  padding-left: 70px;
  padding-right: 70px;
}
.id-generator__actions-register-big:hover {
  background-color: #FA9411;
}
.id-generator__actions-register-big:focus {
  outline: none;
  ring: 2px;
  ring-offset: 2px;
  ring-color: #FA9411;
}
.id-generator__actions-register-big:disabled {
  background-color: #d1d5db;
  cursor: not-allowed;
}
.id-generator__actions-download {
  display: inline-flex;
  align-items: center;
  padding: 8px 16px;
  border: 1px solid transparent;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  color: #ffffff;
  background-color: #FA9411;
  transition: background-color 0.2s;
}
.id-generator__actions-download:hover {
  background-color: #FA9411;
}
.id-generator__actions-download:focus {
  outline: none;
  ring: 2px;
  ring-offset: 2px;
  ring-color: #FA9411;
}
.id-generator__actions-download:disabled {
  background-color: #d1d5db;
  cursor: not-allowed;
}
.id-generator__actions-remove {
  padding: 8px 16px;
  background-color: #e5e7eb;
  color: #374151;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
}
.id-generator__actions-remove:hover {
  background-color: #d1d5db;
}
.id-generator__credentials-form {
  display: flex;
  align-items: center;
  gap: 10px;
}
.id-generator__credentials-form__button {
  white-space: nowrap;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.id-display__container {
  margin: 0 auto;
  padding: 24px 16px;
  max-width: 1200px;
}
@media (min-width: 768px) {
  .id-display__container {
    padding: 24px;
  }
}
@media (min-width: 1024px) {
  .id-display__container {
    padding: 32px;
  }
}
.id-display__card {
  max-width: 768px;
  margin: 0 auto;
  background-color: #ffffff;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
}
@media (min-width: 768px) {
  .id-display__card {
    padding: 24px;
  }
}
.id-display__content {
  background-color: #f9fafb;
  border-radius: 12px;
  padding: 16px;
  border: 2px solid #e5e7eb;
}
@media (min-width: 768px) {
  .id-display__content {
    padding: 32px;
  }
}
.id-display__header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 16px;
  margin-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}
@media (min-width: 768px) {
  .id-display__header {
    flex-direction: row;
    padding-bottom: 24px;
    margin-bottom: 24px;
  }
}
.id-display__header-title {
  font-size: 24px;
  font-weight: 700;
  color: #2563eb;
  margin-bottom: 8px;
  text-align: center;
  width: 100%;
}
@media (min-width: 768px) {
  .id-display__header-title {
    font-size: 30px;
    margin-bottom: 0;
    text-align: left;
  }
}
.id-display__info {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 16px;
}
@media (min-width: 768px) {
  .id-display__info {
    flex-direction: row;
    gap: 32px;
    margin-bottom: 32px;
  }
}
.id-display__photo {
  width: 100%;
  display: flex;
  justify-content: center;
}
@media (min-width: 768px) {
  .id-display__photo {
    width: 33.333%;
    justify-content: flex-start;
  }
}
.id-display__photo-image {
  width: 144px;
  height: 144px;
  object-fit: cover;
  border-radius: 8px;
  border: 4px solid #e5e7eb;
}
@media (min-width: 768px) {
  .id-display__photo-image {
    width: 192px;
    height: 192px;
  }
}
.id-display__details {
  width: 100%;
  text-align: center;
}
@media (min-width: 768px) {
  .id-display__details {
    width: 66.666%;
    text-align: left;
  }
}
.id-display__details-group {
  margin-bottom: 12px;
}
@media (min-width: 768px) {
  .id-display__details-group {
    margin-bottom: 16px;
  }
}
.id-display__details-label {
  display: block;
  font-size: 12px;
  color: #6b7280;
}
@media (min-width: 768px) {
  .id-display__details-label {
    font-size: 14px;
  }
}
.id-display__details-value {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  text-transform: capitalize;
}
@media (min-width: 768px) {
  .id-display__details-value {
    font-size: 20px;
  }
}
.id-display__footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding-top: 16px;
  border-top: 2px solid #e5e7eb;
}
@media (min-width: 768px) {
  .id-display__footer {
    flex-direction: row;
  }
}
.id-display__footer-text {
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 16px;
  text-align: center;
  width: 100%;
}
@media (min-width: 768px) {
  .id-display__footer-text {
    font-size: 14px;
    margin-bottom: 0;
    text-align: left;
  }
}
.id-display__footer-qr {
  display: flex;
  justify-content: center;
  width: 100%;
}
@media (min-width: 768px) {
  .id-display__footer-qr {
    justify-content: flex-end;
  }
}
.id-display__footer-qr-code {
  width: 96px;
  height: 96px;
}

.fingerprint-grid {
  width: 100%;
  display: flex;
  gap: 20px;
  align-items: center;
  justify-content: center;
}

.fingerprint__container {
  width: 100%;
  max-width: 1024px;
  margin: 0 auto;
  padding: 20px;
}
.fingerprint__nav {
  background-color: #2c3e50;
  padding: 15px;
  margin-bottom: 20px;
}
.fingerprint__nav-brand {
  color: white;
  font-weight: bold;
  font-size: 1.2rem;
}
.fingerprint__nav-tabs {
  display: flex;
  gap: 20px;
  margin-top: 10px;
}
.fingerprint__nav-tab {
  color: white;
  padding: 8px 16px;
  cursor: pointer;
  border: none;
  background: none;
}
.fingerprint__nav-tab--active {
  background-color: #34495e;
  border-radius: 4px;
}
.fingerprint__quality {
  margin-bottom: 20px;
}
.fingerprint__quality-input {
  background-color: #f5f5f5;
  text-align: center;
  padding: 5px;
  border: 1px solid #ddd;
}
.fingerprint__status {
  color: #e74c3c;
  text-align: center;
  margin-bottom: 15px;
}
.fingerprint__card {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 20px;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.fingerprint__card-title {
  font-size: 1.5rem;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}
.fingerprint__image {
  display: block;
  margin: 0 auto 20px;
  max-width: 100%;
  height: auto;
}
.fingerprint__controls {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-bottom: 20px;
}
.fingerprint__button {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  background-color: #3498db;
  color: white;
  cursor: pointer;
}
.fingerprint__button:hover {
  background-color: #2980b9;
}
.fingerprint__button:disabled {
  background-color: #bdc3c7;
  cursor: not-allowed;
}
.fingerprint__gallery {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 15px;
  margin-top: 20px;
}
.fingerprint__gallery-image {
  width: 100%;
  height: auto;
  border-radius: 4px;
}
.fingerprint__reader-select {
  width: 100%;
  padding: 8px;
  margin-bottom: 20px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.meal-status {
  margin-top: 2rem;
  padding: 1rem;
  border-radius: 8px;
  background-color: #f8f9fa;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.meal-status h2 {
  margin-bottom: 1rem;
  color: #333;
  font-size: 1.25rem;
}

.meal-records {
  display: grid;
  gap: 1rem;
}

.meal-record {
  display: flex;
  justify-content: space-between;
  padding: 0.5rem;
  border-bottom: 1px solid #e9ecef;
}

.recorded {
  color: #28a745;
  font-weight: bold;
}

.not-recorded {
  color: #dc3545;
  font-weight: bold;
}

.alert {
  padding: 1rem;
  margin-bottom: 1rem;
  border-radius: 4px;
}

.alert-success {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.alert-error {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.loading {
  text-align: center;
  padding: 2rem;
  font-size: 1.25rem;
  color: #666;
}

/* Add to your existing stylesheet */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 90%;
  animation: slideIn 0.3s ease-out;
}

.modal-status {
  text-align: center;
}

.modal-status.success .modal-icon {
  background-color: #28a745;
}

.modal-status.error .modal-icon {
  background-color: #dc3545;
}

.modal-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
  color: white;
  font-size: 2rem;
}

.modal-title {
  margin-bottom: 1rem;
  color: #333;
  font-size: 1.5rem;
}

.modal-title-big {
  margin-bottom: 2.4rem;
  color: #333;
  font-size: 2.4rem;
  font-weight: 700;
}

.modal-message {
  margin-bottom: 1.5rem;
  color: #666;
  line-height: 1.4;
}

.modal-close {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 0.5rem 1.5rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.2s;
}

.modal-close:hover {
  background-color: #0056b3;
}

@keyframes slideIn {
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
/** Break Points **/
/** Break Points **/
.issue-report {
  min-height: 100vh;
  background-color: #f9fafb;
  padding: 48px 16px;
}
@media (max-width: 565px) {
  .issue-report {
    padding: 24px 16px;
  }
}
.issue-report__container {
  max-width: 900px;
  margin: 0 auto;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  padding: 32px;
}
@media (max-width: 565px) {
  .issue-report__container {
    padding: 24px 16px;
    border-radius: 8px;
  }
}
.issue-report__header {
  margin-bottom: 32px;
  text-align: center;
}
.issue-report__header-title {
  font-size: 28px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 16px;
}
@media (max-width: 565px) {
  .issue-report__header-title {
    font-size: 20px;
  }
}
.issue-report__header-subtitle {
  font-size: 16px;
  color: #4b5563;
  line-height: 1.6;
  margin-bottom: 16px;
}
@media (max-width: 565px) {
  .issue-report__header-subtitle {
    font-size: 14px;
  }
}
.issue-report__header-warning {
  background-color: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 8px;
  padding: 16px;
  font-size: 14px;
  color: #856404;
  text-align: left;
  margin-top: 16px;
}
.issue-report__header-warning a {
  color: #856404;
  text-decoration: underline;
  font-weight: 600;
}
.issue-report__header-warning strong {
  font-weight: 700;
}
.issue-report__type-selection {
  text-align: center;
  padding: 32px 0;
}
.issue-report__type-selection-title {
  font-size: 20px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 24px;
}
.issue-report__type-buttons {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
}
@media (max-width: 565px) {
  .issue-report__type-buttons {
    flex-direction: column;
  }
}
.issue-report__type-button {
  padding: 16px 32px;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  background-color: #FA9411;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 200px;
}
.issue-report__type-button:hover {
  background-color: #FA9411;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}
.issue-report__type-button:active {
  transform: translateY(0);
}
@media (max-width: 565px) {
  .issue-report__type-button {
    width: 100%;
    min-width: unset;
  }
}
.issue-report__back {
  margin-bottom: 24px;
}
.issue-report__back-button {
  background: none;
  border: none;
  color: #FA9411;
  font-size: 14px;
  cursor: pointer;
  padding: 8px 0;
  font-weight: 500;
  transition: color 0.2s ease;
}
.issue-report__back-button:hover {
  color: #FA9411;
  text-decoration: underline;
}
.issue-report__form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.issue-report__form-section {
  margin-bottom: 8px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}
.issue-report__form-section:last-of-type {
  border-bottom: none;
  margin-top: 24px;
}
.issue-report__section-title {
  font-size: 22px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 8px;
}
.issue-report__section-description {
  font-size: 14px;
  color: #4b5563;
  line-height: 1.6;
  margin-top: 8px;
}
.issue-report__form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.issue-report__form-group--full {
  grid-column: 1/-1;
}
.issue-report__form-label {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  display: block;
}
.issue-report__form-label .required {
  color: #ff0000;
  margin-left: 4px;
}
.issue-report__form-note {
  font-size: 12px;
  color: #4b5563;
  font-style: italic;
  margin-top: 4px;
  line-height: 1.5;
}
.issue-report__form-input {
  width: 100%;
  padding: 10px 12px;
  background-color: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  color: #111827;
  transition: border-color 0.2s ease;
}
.issue-report__form-input:focus {
  outline: none;
  border-color: #FA9411;
  box-shadow: 0 0 0 3px rgba(250, 148, 17, 0.1);
}
.issue-report__form-input:disabled {
  background-color: #f9fafb;
  cursor: not-allowed;
}
.issue-report__form-textarea {
  width: 100%;
  padding: 10px 12px;
  background-color: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  color: #111827;
  font-family: inherit;
  resize: vertical;
  transition: border-color 0.2s ease;
}
.issue-report__form-textarea:focus {
  outline: none;
  border-color: #FA9411;
  box-shadow: 0 0 0 3px rgba(250, 148, 17, 0.1);
}
.issue-report__form-radio-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 8px;
}
.issue-report__form-radio {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #374151;
}
.issue-report__form-radio input[type=radio] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #FA9411;
}
.issue-report__form-radio span {
  -webkit-user-select: none;
          user-select: none;
}
.issue-report__form-radio:hover {
  color: #111827;
}
.issue-report__form-checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 8px;
  padding: 16px;
  background-color: #f9fafb;
  border-radius: 6px;
}
.issue-report__form-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #374151;
}
.issue-report__form-checkbox input[type=checkbox] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #FA9411;
}
.issue-report__form-checkbox span {
  -webkit-user-select: none;
          user-select: none;
}
.issue-report__form-checkbox:hover {
  color: #111827;
}
.issue-report__form-actions {
  margin-top: 32px;
  display: flex;
  justify-content: center;
  padding-top: 24px;
  border-top: 1px solid #e5e7eb;
}
.issue-report__form-submit {
  padding: 14px 48px;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  background-color: #FA9411;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 180px;
}
.issue-report__form-submit:hover:not(:disabled) {
  background-color: #FA9411;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}
.issue-report__form-submit:active:not(:disabled) {
  transform: translateY(0);
}
.issue-report__form-submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/** Break Points **/
/** Break Points **/
.qrcode-display {
  min-height: 100vh;
  background-color: #f9fafb;
  padding: 48px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 565px) {
  .qrcode-display {
    padding: 24px 16px;
  }
}
.qrcode-display__container {
  max-width: 600px;
  width: 100%;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  padding: 48px 32px;
}
@media (max-width: 565px) {
  .qrcode-display__container {
    padding: 32px 24px;
    border-radius: 8px;
  }
}
.qrcode-display__header {
  text-align: center;
  margin-bottom: 40px;
}
.qrcode-display__header-title {
  font-size: 28px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 12px;
}
@media (max-width: 565px) {
  .qrcode-display__header-title {
    font-size: 22px;
  }
}
.qrcode-display__header-subtitle {
  font-size: 16px;
  color: #4b5563;
  line-height: 1.6;
}
@media (max-width: 565px) {
  .qrcode-display__header-subtitle {
    font-size: 14px;
  }
}
.qrcode-display__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
}
.qrcode-display__qr-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background-color: #ffffff;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.qrcode-display__qr-image {
  width: 100%;
  max-width: 400px;
  height: auto;
  display: block;
}
.qrcode-display__qr-loading {
  padding: 40px;
  color: #4b5563;
  font-size: 16px;
  text-align: center;
}
.qrcode-display__info {
  text-align: center;
  width: 100%;
}
.qrcode-display__info-text {
  font-size: 14px;
  color: #374151;
  margin-bottom: 12px;
  word-break: break-all;
}
.qrcode-display__info-text strong {
  font-weight: 600;
  color: #111827;
}
.qrcode-display__info-link {
  color: #FA9411;
  text-decoration: none;
  word-break: break-all;
}
.qrcode-display__info-link:hover {
  text-decoration: underline;
}
.qrcode-display__info-instruction {
  font-size: 14px;
  color: #4b5563;
  font-style: italic;
  margin-top: 8px;
}
.qrcode-display__actions {
  width: 100%;
  display: flex;
  justify-content: center;
}
.qrcode-display__actions-button {
  padding: 14px 32px;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  background-color: #FA9411;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 200px;
}
.qrcode-display__actions-button:hover {
  background-color: #FA9411;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}
.qrcode-display__actions-button:active {
  transform: translateY(0);
}
@media (max-width: 565px) {
  .qrcode-display__actions-button {
    width: 100%;
    min-width: unset;
  }
}

.food-poll-management {
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}
.food-poll-management__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #e9ecef;
}
.food-poll-management__title {
  font-size: 1.75rem;
  font-weight: 600;
  color: #333;
  margin: 0;
}
.food-poll-management__subtitle {
  color: #666;
  margin: 0.5rem 0 0;
}
.food-poll-management__create-btn {
  background-color: #FA9411;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s;
}
.food-poll-management__create-btn:hover {
  background-color: #e8840f;
}
.food-poll-management__filters {
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
}
.food-poll-management__filter {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.food-poll-management__filter span {
  font-weight: 500;
  color: #333;
}
.food-poll-management__filter input,
.food-poll-management__filter select {
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
}
.food-poll-management__error {
  background-color: #f8d7da;
  color: #721c24;
  padding: 1rem;
  border-radius: 4px;
  margin-bottom: 1rem;
}
.food-poll-management__loading {
  text-align: center;
  padding: 2rem;
  color: #666;
}
.food-poll-management__empty {
  text-align: center;
  padding: 3rem;
  color: #666;
  background-color: #f8f9fa;
  border-radius: 8px;
}
.food-poll-management__polls {
  display: grid;
  gap: 1.5rem;
}
.food-poll-management__poll-card {
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.food-poll-management__poll-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e9ecef;
}
.food-poll-management__poll-header h3 {
  margin: 0;
  font-size: 1.25rem;
  color: #333;
}
.food-poll-management__status {
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 0.875rem;
  font-weight: 500;
}
.food-poll-management__status.active {
  background-color: #d4edda;
  color: #155724;
}
.food-poll-management__status.inactive {
  background-color: #f8d7da;
  color: #721c24;
}
.food-poll-management__poll-actions {
  display: flex;
  gap: 0.5rem;
}
.food-poll-management__btn {
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s;
}
.food-poll-management__btn.results {
  background-color: #007bff;
  color: white;
}
.food-poll-management__btn.results:hover {
  background-color: #0056b3;
}
.food-poll-management__btn.toggle {
  background-color: #6c757d;
  color: white;
}
.food-poll-management__btn.toggle:hover {
  background-color: #5a6268;
}
.food-poll-management__btn.delete {
  background-color: #dc3545;
  color: white;
}
.food-poll-management__btn.delete:hover {
  background-color: #c82333;
}
.food-poll-management__poll-options h4 {
  margin: 0 0 0.5rem;
  font-size: 1rem;
  color: #333;
}
.food-poll-management__poll-options ul {
  list-style: none;
  padding: 0;
  margin: 0 0 1rem;
}
.food-poll-management__poll-options ul li {
  padding: 0.5rem 0;
  border-bottom: 1px solid #f0f0f0;
  color: #666;
}
.food-poll-management__total-votes {
  margin: 1rem 0 0;
  font-weight: 600;
  color: #333;
}
.food-poll-management__modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.food-poll-management__modal {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  max-width: 600px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
}
.food-poll-management__modal.large {
  max-width: 900px;
}
.food-poll-management__modal h3 {
  margin: 0 0 1.5rem;
  font-size: 1.5rem;
  color: #333;
}
.food-poll-management__modal label {
  display: block;
  margin-bottom: 1rem;
}
.food-poll-management__modal label span {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #333;
}
.food-poll-management__modal label input,
.food-poll-management__modal label select {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
}
.food-poll-management__options-section {
  margin: 1.5rem 0;
}
.food-poll-management__option-input {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}
.food-poll-management__option-input input {
  flex: 1 1;
}
.food-poll-management__add-option, .food-poll-management__remove-option {
  padding: 0.5rem 1rem;
  border: 1px solid #ddd;
  background-color: #f8f9fa;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.875rem;
  transition: all 0.2s;
}
.food-poll-management__add-option:hover, .food-poll-management__remove-option:hover {
  background-color: #e9ecef;
}
.food-poll-management__add-option {
  margin-top: 0.5rem;
  color: #007bff;
  border-color: #007bff;
}
.food-poll-management__remove-option {
  color: #dc3545;
  border-color: #dc3545;
}
.food-poll-management__modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
}
.food-poll-management__modal-actions button {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s;
}
.food-poll-management__modal-actions button[type=button] {
  background-color: #6c757d;
  color: white;
}
.food-poll-management__modal-actions button[type=button]:hover {
  background-color: #5a6268;
}
.food-poll-management__modal-actions button[type=submit] {
  background-color: #FA9411;
  color: white;
}
.food-poll-management__modal-actions button[type=submit]:hover:not(:disabled) {
  background-color: #e8840f;
}
.food-poll-management__modal-actions button[type=submit]:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.food-poll-management__results {
  margin-top: 1.5rem;
}
.food-poll-management__results-summary {
  margin-bottom: 2rem;
}
.food-poll-management__results-summary h4 {
  margin: 0 0 1rem;
  font-size: 1.125rem;
  color: #333;
}
.food-poll-management__results-summary ul {
  list-style: none;
  padding: 0;
  margin: 0 0 1rem;
}
.food-poll-management__results-summary ul li {
  padding: 0.5rem 0;
  border-bottom: 1px solid #f0f0f0;
}
.food-poll-management__results-votes table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
}
.food-poll-management__results-votes table th,
.food-poll-management__results-votes table td {
  padding: 0.75rem;
  text-align: left;
  border-bottom: 1px solid #e9ecef;
}
.food-poll-management__results-votes table th {
  background-color: #f8f9fa;
  font-weight: 600;
  color: #333;
}
.food-poll-management__results-votes table td {
  color: #666;
}

.food-poll-voting {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 2rem 1rem;
}
.food-poll-voting__container {
  max-width: 800px;
  margin: 0 auto;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  padding: 2rem;
}
.food-poll-voting__header {
  text-align: center;
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 2px solid #e9ecef;
}
.food-poll-voting__title {
  font-size: 2rem;
  font-weight: 700;
  color: #333;
  margin: 0 0 0.5rem;
}
.food-poll-voting__subtitle {
  color: #666;
  font-size: 1.125rem;
  margin: 0;
}
.food-poll-voting__filters {
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
  flex-wrap: wrap;
}
.food-poll-voting__filter {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex: 1 1;
  min-width: 150px;
}
.food-poll-voting__filter span {
  font-weight: 500;
  color: #333;
}
.food-poll-voting__filter input,
.food-poll-voting__filter select {
  padding: 0.75rem;
  border: 2px solid #e9ecef;
  border-radius: 6px;
  font-size: 1rem;
  transition: border-color 0.2s;
}
.food-poll-voting__filter input:focus,
.food-poll-voting__filter select:focus {
  outline: none;
  border-color: #FA9411;
}
.food-poll-voting__user-input {
  margin-bottom: 2rem;
}
.food-poll-voting__user-label {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.food-poll-voting__user-label span {
  font-weight: 500;
  color: #333;
}
.food-poll-voting__user-label input {
  padding: 0.75rem;
  border: 2px solid #e9ecef;
  border-radius: 6px;
  font-size: 1rem;
  transition: border-color 0.2s;
}
.food-poll-voting__user-label input:focus {
  outline: none;
  border-color: #FA9411;
}
.food-poll-voting__user-label input:disabled {
  background-color: #f8f9fa;
  cursor: not-allowed;
}
.food-poll-voting__error {
  background-color: #f8d7da;
  color: #721c24;
  padding: 1rem;
  border-radius: 6px;
  margin-bottom: 1rem;
}
.food-poll-voting__loading {
  text-align: center;
  padding: 3rem;
  color: #666;
  font-size: 1.125rem;
}
.food-poll-voting__no-poll {
  text-align: center;
  padding: 3rem;
  color: #666;
  background-color: #f8f9fa;
  border-radius: 8px;
}
.food-poll-voting__poll {
  margin-top: 2rem;
}
.food-poll-voting__poll-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #e9ecef;
}
.food-poll-voting__poll-header h2 {
  margin: 0;
  font-size: 1.5rem;
  color: #333;
}
.food-poll-voting__total-votes {
  color: #666;
  font-size: 0.875rem;
}
.food-poll-voting__voted-message {
  background-color: #d4edda;
  color: #155724;
  padding: 1.5rem;
  border-radius: 8px;
  margin-bottom: 2rem;
  text-align: center;
}
.food-poll-voting__voted-message p {
  margin: 0.5rem 0;
  font-size: 1.125rem;
}
.food-poll-voting__voted-message p strong {
  color: #0f5132;
}
.food-poll-voting__options {
  margin-bottom: 2rem;
}
.food-poll-voting__options h3 {
  margin: 0 0 1.5rem;
  font-size: 1.25rem;
  color: #333;
}
.food-poll-voting__options-list {
  display: grid;
  gap: 1rem;
  margin-bottom: 2rem;
}
.food-poll-voting__option {
  display: flex;
  align-items: center;
  padding: 1.25rem;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  background-color: white;
}
.food-poll-voting__option:hover:not(.selected) {
  border-color: #FA9411;
  background-color: #fff9f0;
}
.food-poll-voting__option.selected {
  border-color: #FA9411;
  background-color: #fff9f0;
}
.food-poll-voting__option input[type=radio] {
  margin-right: 1rem;
  width: 20px;
  height: 20px;
  cursor: pointer;
}
.food-poll-voting__option-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1 1;
}
.food-poll-voting__option-name {
  font-size: 1.125rem;
  font-weight: 500;
  color: #333;
}
.food-poll-voting__option-votes {
  font-size: 0.875rem;
  color: #666;
}
.food-poll-voting__submit-btn {
  width: 100%;
  padding: 1rem;
  background-color: #FA9411;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1.125rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}
.food-poll-voting__submit-btn:hover:not(:disabled) {
  background-color: #e8840f;
}
.food-poll-voting__submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.food-poll-voting__results {
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 2px solid #e9ecef;
}
.food-poll-voting__results h3 {
  margin: 0 0 1.5rem;
  font-size: 1.25rem;
  color: #333;
}
.food-poll-voting__results-list {
  display: grid;
  gap: 1rem;
}
.food-poll-voting__result-item {
  margin-bottom: 1rem;
}
.food-poll-voting__result-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}
.food-poll-voting__result-name {
  font-weight: 500;
  color: #333;
}
.food-poll-voting__result-count {
  font-size: 0.875rem;
  color: #666;
}
.food-poll-voting__result-bar {
  height: 24px;
  background-color: #e9ecef;
  border-radius: 12px;
  overflow: hidden;
}
.food-poll-voting__result-fill {
  height: 100%;
  background: linear-gradient(90deg, #FA9411 0%, #e8840f 100%);
  transition: width 0.3s ease;
}

.food-page__tabs {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 2rem;
  border-bottom: 2px solid #e9ecef;
}

.food-page__tab {
  padding: 0.75rem 1.5rem;
  background: none;
  border: none;
  border-bottom: 3px solid transparent;
  font-size: 1rem;
  font-weight: 500;
  color: #666;
  cursor: pointer;
  transition: all 0.2s;
}
.food-page__tab:hover {
  color: #FA9411;
}
.food-page__tab.active {
  color: #FA9411;
  border-bottom-color: #FA9411;
}

.admin-login {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f9fafb;
  padding: 16px;
}
.admin-login__container {
  width: 100%;
  max-width: 400px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}
.admin-login__header {
  padding: 32px 24px;
  text-align: center;
  border-bottom: 1px solid #e5e7eb;
}
.admin-login__header-logo {
  width: 48px;
  height: 48px;
  margin: 0 auto 16px;
  color: #FA9411;
}
.admin-login__header-title {
  font-size: 24px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 8px;
}
.admin-login__header-subtitle {
  font-size: 14px;
  color: #4b5563;
}
.admin-login__form {
  padding: 24px;
}
.admin-login__form-group {
  margin-bottom: 20px;
}
.admin-login__form-label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 8px;
}
.admin-login__form-input {
  width: 100%;
  padding: 10px 12px;
  font-size: 14px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background-color: #ffffff;
  transition: all 0.2s;
}
.admin-login__form-input:focus {
  outline: none;
  border-color: #FA9411;
  box-shadow: 0 0 0 2px rgba(250, 148, 17, 0.1);
}
.admin-login__form-input::placeholder {
  color: #4b5563;
}
.admin-login__form-input--error {
  border-color: #ff0000;
  background-color: rgba(255, 0, 0, 0.05);
}
.admin-login__form-error {
  color: #ff0000;
  font-size: 12px;
  margin-top: 4px;
}
.admin-login__form-forgot {
  display: block;
  text-align: right;
  font-size: 14px;
  color: #FA9411;
  text-decoration: none;
  margin-bottom: 24px;
}
.admin-login__form-forgot:hover {
  text-decoration: underline;
}
.admin-login__form-submit {
  width: 100%;
  padding: 12px;
  background-color: #FA9411;
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s;
}
.admin-login__form-submit:hover {
  background-color: #FA9411;
}
.admin-login__form-submit:disabled {
  background-color: #d1d5db;
  cursor: not-allowed;
}
.admin-login__alert {
  margin: 0 24px 16px;
  padding: 12px;
  border-radius: 6px;
  font-size: 14px;
}
.admin-login__alert--error {
  background-color: rgba(255, 0, 0, 0.1);
  color: #ff0000;
}
.admin-login__alert--success {
  background-color: rgba(250, 148, 17, 0.1);
  color: #FA9411;
}

.users-list {
  padding: 32px;
}
@media (max-width: 565px) {
  .users-list {
    padding: 32px 0;
  }
}
.users-list__header {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 32px;
}
.users-list__title {
  font-size: 24px;
  font-weight: 600;
  color: #2d3748;
}
.users-list__subtitle {
  margin-top: 4px;
  font-size: 14px;
  color: #718096;
}
.users-list__error {
  margin-bottom: 16px;
  padding: 12px 16px;
  background-color: rgba(229, 62, 62, 0.08);
  border: 1px solid rgba(229, 62, 62, 0.24);
  border-radius: 6px;
  color: #c53030;
}
.users-list__registered {
  font-size: 20px;
  font-weight: 600;
  color: #2d3748;
}
.users-list__registered > span {
  color: #FA9411;
}
.users-list__search-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}
.users-list__search-wrapper {
  width: 100%;
  display: flex;
  gap: 8px;
  flex: 1 1;
  max-width: 600px;
  align-items: center;
  flex-wrap: wrap;
}
.users-list__search-wrapper-filters {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
  max-width: 100%;
}
.users-list__search-input {
  flex: 1 1;
  padding: 8px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.15s ease-in-out;
}
.users-list__search-input:focus {
  outline: none;
  border-color: #FA9411;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.15);
}
.users-list__search-type {
  padding: 8px 32px 8px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background-color: white;
  font-size: 14px;
  cursor: pointer;
  transition: border-color 0.15s ease-in-out;
}
.users-list__search-type:focus {
  outline: none;
  border-color: #FA9411;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.15);
}
.users-list__add-button {
  padding: 8px 16px;
  background-color: #FA9411;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.15s ease-in-out;
}
.users-list__add-button:hover {
  background-color: rgb(221.5456790123, 126.5975308642, 4.6543209877);
}
.users-list__table-container {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow-x: auto;
  height: 600px;
  overflow-y: auto;
}
.users-list__table {
  width: 100%;
  border-collapse: collapse;
}
.users-list__table th, .users-list__table td {
  padding: 16px;
  text-align: left;
  border-bottom: 1px solid #e2e8f0;
}
.users-list__table th {
  background-color: #f7fafc;
  font-weight: 600;
  color: #4a5568;
}
.users-list__table tr:hover {
  background-color: #f7fafc;
}
.users-list__loading {
  padding: 32px;
  text-align: center;
  color: #4a5568;
}
.users-list__dropdown {
  position: relative;
}
.users-list__dropdown-trigger {
  padding: 4px 8px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 20px;
  color: #4a5568;
  transition: color 0.15s ease-in-out;
}
.users-list__dropdown-trigger:hover {
  color: #2d3748;
}
.users-list__dropdown-menu {
  position: absolute;
  right: 0;
  top: 100%;
  width: 200px;
  background-color: white;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  z-index: 10;
}
.users-list__dropdown-item {
  display: block;
  padding: 12px 16px;
  color: #4a5568;
  text-decoration: none;
  transition: background-color 0.15s ease-in-out;
}
.users-list__dropdown-item:hover {
  background-color: #f7fafc;
  color: #2d3748;
}
.users-list__dropdown-item:not(:last-child) {
  border-bottom: 1px solid #e2e8f0;
}
.users-list__pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border-top: 1px solid #e2e8f0;
  background-color: #f7fafc;
  border-radius: 0 0 8px 8px;
}
.users-list__pagination-button {
  padding: 8px 16px;
  background-color: white;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 14px;
  color: #4a5568;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
}
.users-list__pagination-button:hover:not(:disabled) {
  background-color: #f7fafc;
  border-color: #FA9411;
  color: #FA9411;
}
.users-list__pagination-button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.15);
}
.users-list__pagination-button:disabled {
  background-color: #edf2f7;
  color: #a0aec0;
  cursor: not-allowed;
}
.users-list__pagination-button:not(:last-child) {
  margin-right: 8px;
}
.users-list__pagination-info {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #4a5568;
  margin: 0 16px;
}
.users-list__pagination-total {
  font-size: 14px;
  color: #718096;
}
.users-list__meals {
  display: flex;
  gap: 20px;
  font-weight: 500;
}
.users-list__meals > div > span {
  color: #FA9411;
  font-weight: 700;
}

.camp-status-badge {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border: 1px solid transparent;
  margin-bottom: 14px;
}
.camp-status-badge--in {
  background-color: rgba(56, 161, 105, 0.15);
  color: #22543d;
  border-color: rgba(56, 161, 105, 0.3);
}
.camp-status-badge--out {
  background-color: rgba(229, 62, 62, 0.15);
  color: #742a2a;
  border-color: rgba(229, 62, 62, 0.3);
}

.users-list__camp-summary {
  margin-bottom: 32px;
  padding: 24px;
  background-color: #ffffff;
  border-radius: 12px;
  border: 1px solid #edf2f7;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}
.users-list__camp-summary-header {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
}
.users-list__camp-summary-date {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 13px;
  color: #4a5568;
}
.users-list__camp-summary-date input {
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  transition: border-color 0.15s ease-in-out;
}
.users-list__camp-summary-date input:focus {
  outline: none;
  border-color: #fa9411;
  box-shadow: 0 0 0 3px rgba(250, 148, 17, 0.15);
}
.users-list__camp-summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}
.users-list__camp-summary-card {
  padding: 16px;
  background-color: #f7fafc;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.users-list__camp-summary-label {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  color: #718096;
  letter-spacing: 0.4px;
}
.users-list__camp-summary-value {
  font-size: 24px;
  font-weight: 700;
  color: #2d3748;
}
.users-list__camp-summary-value--in {
  color: #22543d;
}
.users-list__camp-summary-value--out {
  color: #9b2c2c;
}

.camp-status-summary {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
  padding: 16px;
  background-color: #f7fafc;
  border-radius: 8px;
  border: 1px solid #edf2f7;
  margin-bottom: 20px;
}
.camp-status-summary__item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.camp-status-summary__label {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  color: #718096;
  letter-spacing: 0.4px;
}
.camp-status-summary__value {
  font-size: 14px;
  font-weight: 500;
  color: #2d3748;
}
.camp-status-summary__value--in {
  color: #22543d;
}
.camp-status-summary__value--out {
  color: #742a2a;
}

.camp-timeline {
  margin-top: 24px;
  padding: 16px;
  background-color: #fff;
  border: 1px solid #edf2f7;
  border-radius: 8px;
}
.camp-timeline__title {
  font-size: 14px;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 12px;
}
.camp-timeline__list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.camp-timeline__item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border: 1px solid #edf2f7;
  border-radius: 8px;
}
.camp-timeline__item--checkin {
  background-color: rgba(56, 161, 105, 0.08);
  border-color: rgba(56, 161, 105, 0.2);
}
.camp-timeline__item--checkout {
  background-color: rgba(66, 153, 225, 0.08);
  border-color: rgba(66, 153, 225, 0.2);
}
.camp-timeline__icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  background-color: #fff;
  border: 1px solid currentColor;
}
.camp-timeline__label {
  font-size: 13px;
  font-weight: 600;
  color: #2d3748;
}
.camp-timeline__type {
  font-size: 12px;
  font-weight: 500;
  color: #4a5568;
}

.camp-daily-checkins {
  margin-top: 16px;
}

.meal-history-modal {
  max-height: 400px;
  overflow-y: auto;
}
.meal-history-modal p {
  margin: 0;
  color: #4a5568;
}
.meal-history-modal__table {
  width: 100%;
  border-collapse: collapse;
}
.meal-history-modal__table th,
.meal-history-modal__table td {
  padding: 8px 12px;
  border-bottom: 1px solid #e2e8f0;
  text-align: left;
  font-size: 13px;
}
.meal-history-modal__table th {
  background-color: #f7fafc;
  font-weight: 600;
  color: #2d3748;
}
.meal-history-modal__table tr:nth-child(even) {
  background-color: #ffffff;
}

.modal-message--custom {
  width: 100%;
}

.accommodation {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.accommodation__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}
.accommodation__title {
  font-size: 24px;
  font-weight: 600;
  color: #2d3748;
}
.accommodation__subtitle {
  font-size: 14px;
  color: #718096;
  margin-top: 4px;
}
.accommodation__notice {
  padding: 20px;
  border-radius: 12px;
  background-color: rgba(237, 137, 54, 0.12);
  border: 1px solid rgba(237, 137, 54, 0.3);
  color: #b45309;
}
.accommodation__overview {
  background-color: #fff;
  border: 1px solid #edf2f7;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.accommodation__overview-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  flex-wrap: wrap;
}
.accommodation__overview-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #2d3748;
}
.accommodation__overview-header p {
  margin: 4px 0 0;
  font-size: 13px;
  color: #4a5568;
}
.accommodation__overview-refresh {
  padding: 8px 14px;
  border-radius: 8px;
  border: 1px solid #cbd5f5;
  background-color: #fff;
  cursor: pointer;
  font-size: 13px;
  color: #2d3748;
  transition: background-color 0.15s ease;
}
.accommodation__overview-refresh:hover:not(:disabled) {
  background-color: #edf2f7;
}
.accommodation__overview-refresh:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.accommodation__overview-error {
  padding: 12px;
  border-radius: 10px;
  background-color: rgba(229, 62, 62, 0.12);
  border: 1px solid rgba(229, 62, 62, 0.3);
  color: #9b2c2c;
  font-size: 13px;
}
.accommodation__overview-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 16px;
}
.accommodation__overview-card {
  padding: 18px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background-color: #f7fafc;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.accommodation__overview-card strong {
  font-size: 24px;
  font-weight: 700;
  color: #2d3748;
}
.accommodation__overview-label {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #718096;
}
.accommodation__rooms-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: #fff;
  border: 1px solid #edf2f7;
  border-radius: 12px;
  padding: 20px;
}
.accommodation__rooms-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  font-size: 14px;
  color: #4a5568;
}
.accommodation__rooms-header h3 {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
}
.accommodation__rooms-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
  gap: 16px;
}
.accommodation__room-seat {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 18px;
  border-radius: 16px;
  border: 1px solid rgba(203, 213, 224, 0.7);
  background: linear-gradient(145deg, #f8fafc 0%, #ffffff 100%);
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.08);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}
.accommodation__room-seat:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.12);
  border-color: #FA9411;
}
.accommodation__room-seat--active {
  border-color: #FA9411;
  box-shadow: 0 12px 28px rgba(250, 148, 17, 0.25);
  background: linear-gradient(150deg, rgba(250, 148, 17, 0.18), rgba(255, 255, 255, 0.95));
}
.accommodation__room-seat--empty {
  border-color: rgba(56, 161, 105, 0.35);
}
.accommodation__room-seat--partial {
  border-color: rgba(237, 137, 54, 0.35);
}
.accommodation__room-seat--full {
  border-color: rgba(229, 62, 62, 0.4);
  background: linear-gradient(150deg, rgba(254, 215, 215, 0.5), rgba(255, 255, 255, 0.95));
}
.accommodation__room-seat-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}
.accommodation__room-seat-name {
  font-size: 16px;
  font-weight: 600;
  color: #1a202c;
}
.accommodation__room-seat-delete {
  background: none;
  border: none;
  color: #c53030;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  padding: 0 4px;
  border-radius: 6px;
}
.accommodation__room-seat-delete:hover {
  background-color: rgba(229, 62, 62, 0.12);
}
.accommodation__room-seat-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #4a5568;
}
.accommodation__room-seat-description {
  font-size: 12px;
  color: #718096;
}
.accommodation__content {
  display: grid;
  grid-template-columns: minmax(0, 2.5fr) minmax(260px, 1fr);
  gap: 24px;
}
@media (max-width: 1024px) {
  .accommodation__content {
    grid-template-columns: 1fr;
  }
}
.accommodation__detail {
  background-color: #fff;
  border: 1px solid #edf2f7;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.accommodation__detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.accommodation__detail-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #2d3748;
}
.accommodation__detail-header span {
  font-size: 14px;
  color: #4a5568;
}
.accommodation__loading, .accommodation__empty {
  padding: 16px;
  border-radius: 10px;
  background-color: #f8fafc;
  color: #4a5568;
  text-align: center;
}
.accommodation__assignment {
  margin-top: 0;
  padding: 20px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background-color: #f8fafc;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.accommodation__assignment-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}
.accommodation__assignment-header h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #2d3748;
}
.accommodation__assignment-header p {
  margin: 4px 0 0;
  font-size: 13px;
  color: #4a5568;
}
.accommodation__assignment-search {
  display: flex;
  gap: 12px;
}
.accommodation__assignment-search input {
  flex: 1 1;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #cbd5f5;
  font-size: 14px;
}
.accommodation__assignment-search button {
  padding: 10px 16px;
  border-radius: 8px;
  border: none;
  background-color: #FA9411;
  color: #fff;
  font-weight: 600;
  cursor: pointer;
}
.accommodation__assignment-search button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.accommodation__assignment-error {
  padding: 10px 12px;
  border-radius: 8px;
  background-color: rgba(229, 62, 62, 0.1);
  border: 1px solid rgba(229, 62, 62, 0.4);
  color: #9b2c2c;
  font-size: 13px;
}
.accommodation__assignment-results {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.accommodation__assignment-results li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background-color: #fff;
}
.accommodation__assignment-results li div {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.accommodation__assignment-results li div strong {
  font-size: 14px;
  color: #2d3748;
}
.accommodation__assignment-results li div span {
  font-size: 12px;
  color: #4a5568;
}
.accommodation__assignment-results li button {
  padding: 8px 12px;
  border-radius: 8px;
  border: none;
  background-color: #2f855a;
  color: #fff;
  font-size: 13px;
  cursor: pointer;
}
.accommodation__assignment-results li button:hover {
  background-color: #276749;
}
.accommodation__current-assignments {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background-color: #fff;
}
.accommodation__current-assignments-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}
.accommodation__current-assignments-header h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #2d3748;
}
.accommodation__current-assignments-header p {
  margin: 0;
  font-size: 13px;
  color: #4a5568;
}
.accommodation__assignment-status {
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.accommodation__assignment-status--available {
  background-color: rgba(56, 161, 105, 0.12);
  color: #276749;
  border: 1px solid rgba(56, 161, 105, 0.4);
}
.accommodation__assignment-status--full {
  background-color: rgba(229, 62, 62, 0.12);
  color: #9b2c2c;
  border: 1px solid rgba(229, 62, 62, 0.4);
}
.accommodation__assignment-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
}
.accommodation__assignment-card {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 14px;
  padding: 16px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background-color: #fefefe;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.05);
}
.accommodation__assignment-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgb(250.8395061728, 165.9654320988, 56.9604938272), rgb(252.9382716049, 210.8790123457, 156.8617283951));
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  color: #fff;
  font-size: 16px;
  flex-shrink: 0;
}
.accommodation__assignment-info {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.accommodation__assignment-name {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}
.accommodation__assignment-name span:first-child {
  font-size: 16px;
  font-weight: 600;
  color: #1a202c;
}
.accommodation__assignment-tag {
  padding: 4px 8px;
  border-radius: 6px;
  background-color: rgba(49, 130, 206, 0.12);
  color: #2b6cb0;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.accommodation__assignment-meta {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  color: #4a5568;
}
.accommodation__assignment-remove {
  align-self: flex-start;
  background: none;
  border: 1px solid rgba(229, 62, 62, 0.4);
  color: #c53030;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}
.accommodation__assignment-remove:hover {
  background-color: rgba(229, 62, 62, 0.08);
  color: #9b2c2c;
}
.accommodation__assignment-empty {
  padding: 18px;
  border-radius: 12px;
  border: 1px dashed #cbd5f5;
  background-color: #f8fafc;
  color: #4a5568;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.accommodation__assignment-empty strong {
  font-size: 14px;
  color: #2d3748;
}
.accommodation__form {
  padding: 20px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background-color: #f8fafc;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.accommodation__form h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #2d3748;
}
.accommodation__form form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.accommodation__form label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 13px;
  color: #4a5568;
}
.accommodation__form label input,
.accommodation__form label textarea {
  border: 1px solid #cbd5f5;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 14px;
}
.accommodation__form label textarea {
  resize: vertical;
}
.accommodation__create-button {
  padding: 10px 16px;
  border: none;
  border-radius: 8px;
  background-color: #FA9411;
  color: #fff;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease;
}
.accommodation__create-button:hover:not(:disabled) {
  background-color: rgb(221.5456790123, 126.5975308642, 4.6543209877);
}
.accommodation__create-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.food-page__controls {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}
.food-page__date {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 14px;
  color: #4a5568;
}
.food-page__date input {
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 14px;
}
.food-page__date input:focus {
  outline: none;
  border-color: #FA9411;
  box-shadow: 0 0 0 3px rgba(250, 148, 17, 0.15);
}
.food-page__total {
  font-size: 14px;
  color: #4a5568;
}

.user-accommodation {
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: #ffffff;
  border: 1px solid #edf2f7;
  border-radius: 12px;
  padding: 20px;
}
.user-accommodation__summary {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  flex-wrap: wrap;
}
.user-accommodation__label {
  display: block;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #718096;
  margin-bottom: 4px;
}
.user-accommodation__room-name {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #2d3748;
}
.user-accommodation__metrics {
  display: flex;
  gap: 16px;
}
.user-accommodation__metrics > div {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-end;
}
.user-accommodation__metric-label {
  font-size: 12px;
  color: #718096;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}
.user-accommodation__metric-value {
  font-size: 18px;
  font-weight: 600;
  color: #2d3748;
}
.user-accommodation__metric-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 48px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
}
.user-accommodation__metric-chip--available {
  background-color: rgba(56, 161, 105, 0.12);
  color: #276749;
  border: 1px solid rgba(56, 161, 105, 0.3);
}
.user-accommodation__metric-chip--full {
  background-color: rgba(229, 62, 62, 0.12);
  color: #c53030;
  border: 1px solid rgba(229, 62, 62, 0.3);
}
.user-accommodation__assigned-at, .user-accommodation__description, .user-accommodation__note {
  font-size: 14px;
  color: #4a5568;
}
.user-accommodation__passengers {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 14px;
}
.user-accommodation__passenger {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 12px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background-color: #f7fafc;
}
.user-accommodation__passenger--current {
  border-color: #FA9411;
  background-color: rgba(250, 148, 17, 0.12);
}
.user-accommodation__passenger-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgb(250.8395061728, 165.9654320988, 56.9604938272), rgb(252.9382716049, 210.8790123457, 156.8617283951));
  color: #fff;
  font-weight: 700;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.user-accommodation__passenger-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.user-accommodation__passenger-name {
  display: flex;
  align-items: center;
  gap: 8px;
}
.user-accommodation__passenger-name span:first-child {
  font-size: 15px;
  font-weight: 600;
  color: #1a202c;
}
.user-accommodation__assignment-tag {
  padding: 2px 8px;
  border-radius: 6px;
  background-color: rgba(49, 130, 206, 0.12);
  color: #2b6cb0;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.user-accommodation__badge {
  padding: 2px 8px;
  border-radius: 6px;
  background-color: rgba(246, 173, 85, 0.2);
  color: #b7791f;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
}
.user-accommodation__passenger-contact, .user-accommodation__passenger-time {
  font-size: 12px;
  color: #4a5568;
}
.user-accommodation__actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.user-accommodation__button {
  padding: 10px 16px;
  border-radius: 8px;
  border: none;
  background-color: #FA9411;
  color: #fff;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease;
}
.user-accommodation__button:hover:not(:disabled) {
  background-color: rgb(221.5456790123, 126.5975308642, 4.6543209877);
}
.user-accommodation__button:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}
.user-accommodation__button--secondary {
  background-color: #e53e3e;
}
.user-accommodation__button--secondary:hover:not(:disabled) {
  background-color: #c53030;
}
.user-accommodation__empty {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  color: #4a5568;
}
.user-accommodation__empty strong {
  font-size: 15px;
  color: #2d3748;
}

.user-accommodation-modal {
  background-color: #fff;
  border-radius: 16px;
  padding: 24px;
  width: min(720px, 90vw);
  max-height: 82vh;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow: hidden;
}

.user-accommodation-modal__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}
.user-accommodation-modal__header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #2d3748;
}

.user-accommodation-modal__close {
  background: none;
  border: none;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  color: #4a5568;
}
.user-accommodation-modal__close:hover {
  color: #1a202c;
}

.user-accommodation-modal__loading,
.user-accommodation-modal__empty,
.user-accommodation-modal__error {
  padding: 16px;
  border-radius: 12px;
  font-size: 14px;
  text-align: center;
}

.user-accommodation-modal__error {
  background-color: rgba(229, 62, 62, 0.1);
  color: #9b2c2c;
  border: 1px solid rgba(229, 62, 62, 0.3);
}

.user-accommodation-modal__empty {
  background-color: #f8fafc;
  color: #4a5568;
}

.user-accommodation-modal__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  overflow-y: auto;
  padding-right: 4px;
}

.user-accommodation-modal__card {
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background-color: #fefefe;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.user-accommodation-modal__card--empty {
  border-color: rgba(56, 161, 105, 0.3);
}
.user-accommodation-modal__card--partial {
  border-color: rgba(237, 137, 54, 0.3);
}
.user-accommodation-modal__card--full {
  border-color: rgba(229, 62, 62, 0.3);
  background-color: rgba(254, 215, 215, 0.35);
}
.user-accommodation-modal__card--current {
  border-color: #FA9411;
  box-shadow: 0 8px 20px rgba(250, 148, 17, 0.25);
  background-color: rgba(250, 148, 17, 0.18);
}

.user-accommodation-modal__card-header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 8px;
}
.user-accommodation-modal__card-header h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #2d3748;
}
.user-accommodation-modal__card-header span {
  font-size: 13px;
  color: #4a5568;
}

.user-accommodation-modal__card-description {
  font-size: 12px;
  color: #4a5568;
}

.user-accommodation-modal__card-meta {
  font-size: 12px;
  color: #2f855a;
  font-weight: 600;
}

.user-accommodation-modal__card-actions button {
  width: 100%;
  padding: 10px 14px;
  border-radius: 8px;
  border: none;
  background-color: #FA9411;
  color: #fff;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease;
}
.user-accommodation-modal__card-actions button:disabled {
  background-color: #a0aec0;
  cursor: not-allowed;
}
.user-accommodation-modal__card-actions button:hover:not(:disabled) {
  background-color: rgb(221.5456790123, 126.5975308642, 4.6543209877);
}

.camp-status {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.camp-status__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 16px;
}
.camp-status__header h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #2d3748;
}
.camp-status__header p {
  margin: 6px 0 0;
  font-size: 14px;
  color: #4a5568;
  max-width: 420px;
}
.camp-status__controls {
  display: flex;
  gap: 12px;
  align-items: end;
  flex-wrap: wrap;
}
.camp-status__controls button {
  padding: 10px 16px;
  border-radius: 8px;
  border: 1px solid #cbd5f5;
  background-color: #FA9411;
  color: #fff;
  font-weight: 600;
  cursor: pointer;
}
.camp-status__controls button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.camp-status__controls button:hover:not(:disabled) {
  background-color: rgb(221.5456790123, 126.5975308642, 4.6543209877);
}
.camp-status__date-picker {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  color: #4a5568;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}
.camp-status__date-picker input {
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #cbd5f5;
  font-size: 14px;
}
.camp-status__error {
  padding: 12px;
  border-radius: 10px;
  background-color: rgba(229, 62, 62, 0.12);
  border: 1px solid rgba(229, 62, 62, 0.3);
  color: #9b2c2c;
  font-size: 13px;
}
.camp-status__summary {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 16px;
}
.camp-status__summary-card {
  padding: 18px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background-color: #f8fafc;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.camp-status__summary-card strong {
  font-size: 24px;
  font-weight: 700;
  color: #2d3748;
}
.camp-status__summary-label {
  font-size: 12px;
  color: #718096;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}
.camp-status__lists {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 20px;
}
.camp-status__list {
  background-color: #fff;
  border: 1px solid #edf2f7;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.camp-status__list h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #2d3748;
}
.camp-status__list-loading, .camp-status__list-empty {
  padding: 16px;
  border-radius: 10px;
  background-color: #f8fafc;
  text-align: center;
  font-size: 14px;
  color: #4a5568;
}
.camp-status__list-items {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.camp-status__list-card {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background-color: #fefefe;
}
.camp-status__list-header {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}
.camp-status__list-header h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #1a202c;
}
.camp-status__list-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 8px;
  border-radius: 6px;
  background-color: rgba(49, 130, 206, 0.12);
  color: #2b6cb0;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
}
.camp-status__list-time {
  font-size: 12px;
  color: #4a5568;
}
.camp-status__list-meta {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 13px;
  color: #4a5568;
}
.camp-status__list-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}
.camp-status__badge {
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.camp-status__badge--in {
  background-color: rgba(56, 161, 105, 0.12);
  color: #276749;
  border: 1px solid rgba(56, 161, 105, 0.3);
}
.camp-status__badge--out {
  background-color: rgba(237, 137, 54, 0.12);
  color: #b7791f;
  border: 1px solid rgba(237, 137, 54, 0.3);
}
.camp-status__badge--decamp {
  background-color: rgba(197, 48, 48, 0.12);
  color: #c53030;
  border: 1px solid rgba(197, 48, 48, 0.3);
}
.camp-status__list-role {
  font-size: 12px;
  color: #4a5568;
  font-weight: 600;
}
.camp-status--restricted {
  padding: 24px;
  border-radius: 12px;
  background-color: #f8fafc;
  color: #4a5568;
  text-align: center;
}

.audit-trail {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.audit-trail__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 12px;
}
.audit-trail__header h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #2d3748;
}
.audit-trail__header p {
  margin: 6px 0 0;
  font-size: 14px;
  color: #4a5568;
  max-width: 420px;
}
.audit-trail__filters {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  border-radius: 12px;
  border: 1px solid #edf2f7;
  background-color: #fff;
}
.audit-trail__filters label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #4a5568;
}
.audit-trail__filters label input,
.audit-trail__filters label select {
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #cbd5f5;
  font-size: 14px;
  background-color: #fff;
}
.audit-trail__filters button {
  align-self: flex-start;
  padding: 10px 16px;
  border-radius: 8px;
  border: none;
  background-color: #FA9411;
  color: #fff;
  font-weight: 600;
  cursor: pointer;
}
.audit-trail__filters button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.audit-trail__filters-row {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: space-between;
  align-items: flex-end;
}
.audit-trail__filters-dates {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}
.audit-trail__filters-actions {
  display: flex;
  gap: 10px;
}
.audit-trail__clear {
  background-color: rgba(45, 55, 72, 0.08);
  color: #2d3748;
  border: none;
}
.audit-trail__filters-selects {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
}
.audit-trail__select-wrapper {
  position: relative;
}
.audit-trail__select-wrapper select {
  width: 100%;
  appearance: none;
  background-image: linear-gradient(45deg, transparent 50%, #4a5568 50%), linear-gradient(135deg, #4a5568 50%, transparent 50%);
  background-position: calc(100% - 18px) 1.1em, calc(100% - 13px) 1.1em;
  background-size: 5px 5px;
  background-repeat: no-repeat;
}
.audit-trail__table-wrapper {
  background-color: #fff;
  border-radius: 12px;
  border: 1px solid #edf2f7;
  overflow-x: auto;
}
.audit-trail__table {
  width: 100%;
  border-collapse: collapse;
}
.audit-trail__table th,
.audit-trail__table td {
  padding: 12px 16px;
  border-bottom: 1px solid #e2e8f0;
  text-align: left;
  font-size: 14px;
  color: #2d3748;
}
.audit-trail__table th {
  background-color: #f7fafc;
  font-weight: 600;
  color: #2d3748;
  text-transform: uppercase;
  font-size: 12px;
}
.audit-trail__table tbody tr:hover {
  background-color: #f8fafc;
}
.audit-trail__loading, .audit-trail__empty, .audit-trail__error {
  padding: 16px;
  border-radius: 12px;
  text-align: center;
  font-size: 14px;
}
.audit-trail__error {
  background-color: rgba(229, 62, 62, 0.12);
  color: #9b2c2c;
  border: 1px solid rgba(229, 62, 62, 0.3);
}
.audit-trail__pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}
.audit-trail__pagination button {
  padding: 8px 14px;
  border-radius: 8px;
  border: 1px solid #cbd5f5;
  background-color: #fff;
  cursor: pointer;
}
.audit-trail__pagination button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.audit-trail--restricted {
  padding: 24px;
  border-radius: 12px;
  background-color: #f8fafc;
  color: #4a5568;
  text-align: center;
}

.admin-layout {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
}
@media (min-width: 769px) {
  .admin-layout {
    flex-direction: row;
  }
}
.admin-layout__content {
  flex: 1 1;
  background-color: #f9fafb;
  padding: 16px;
}
@media (min-width: 769px) {
  .admin-layout__content {
    padding: 32px;
  }
}

.form-flash-toast-container {
  width: min(560px, 100vw - 32px);
  top: 16px !important;
  z-index: 11000;
}
.form-flash-toast-container .form-flash-toast {
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.45;
  min-height: auto;
  padding: 12px 16px;
  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.12);
}
.form-flash-toast-container .Toastify__toast--error {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}
.form-flash-toast-container .Toastify__toast--success {
  background: #f0fdf4;
  color: #15803d;
  border: 1px solid #bbf7d0;
}
.form-flash-toast-container .Toastify__close-button {
  color: inherit;
  opacity: 0.65;
}

.report-alert {
  padding: 12px 16px;
  border-radius: 6px;
  margin-bottom: 16px;
  font-size: 14px;
}
.report-alert--error {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}
.report-alert--success {
  background: #f0fdf4;
  color: #15803d;
  border: 1px solid #bbf7d0;
}

.report-share-feedback {
  padding: 12px 16px;
  margin-bottom: 16px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.5;
  color: #166534;
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
}

.report-share-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.report-share-btn__icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  stroke-width: 2px;
}
.report-share-btn--compact {
  gap: 4px;
}

.report-badge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  text-transform: capitalize;
}
.report-badge--active {
  background: #dcfce7;
  color: #15803d;
}
.report-badge--completed {
  background: #dcfce7;
  color: #15803d;
}
.report-badge--upcoming {
  background: #dbeafe;
  color: #1d4ed8;
}
.report-badge--draft {
  background: #fef3c7;
  color: #92400e;
}
.report-badge--inactive {
  background: #f3f4f6;
  color: #6b7280;
}
.report-badge--count {
  background: #f3f4f6;
  color: #374151;
}
.report-badge--field {
  background: #ede9fe;
  color: #5b21b6;
  font-size: 11px;
  margin: 2px 4px 2px 0;
}
.report-badge--assignees {
  background: #e0f2fe;
  color: #0369a1;
}
.report-badge--rejected {
  background: #fef2f2;
  color: #b91c1c;
}
.report-badge--evidence {
  background: #fef3c7;
  color: #92400e;
  font-size: 11px;
  margin: 2px 4px 2px 0;
}

.btn {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: opacity 0.15s;
}
.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.btn--primary {
  background: #FA9411;
  color: #fff;
}
.btn--primary:hover:not(:disabled) {
  opacity: 0.9;
}
.btn--secondary {
  background: #f3f4f6;
  color: #374151;
  border: 1px solid #d1d5db;
}
.btn--secondary:hover:not(:disabled) {
  background: #e5e7eb;
}
.btn--danger {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}
.btn--danger:hover:not(:disabled) {
  background: #fee2e2;
}
.btn--sm {
  padding: 4px 10px;
  font-size: 12px;
}

.report-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}
.report-modal-overlay--nested {
  z-index: 2000;
}

.report-modal {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
}
.report-modal--wide {
  max-width: 700px;
}
.report-modal h2 {
  margin: 0 0 20px;
  font-size: 20px;
}
.report-modal h3 {
  font-size: 16px;
  font-weight: 600;
}
.report-modal__field {
  margin-bottom: 14px;
}
.report-modal__field label {
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 4px;
}
.report-modal__row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.report-modal__actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #e5e7eb;
}

.report-staff-picker__hint {
  font-size: 12px;
  color: #6b7280;
  margin: 0 0 8px;
  line-height: 1.4;
}
.report-staff-picker__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px;
}
.report-staff-picker__chips--inline {
  margin-bottom: 6px;
  gap: 6px;
}
.report-staff-picker__chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 4px 4px 10px;
  background: #f3f4f6;
  border-radius: 20px;
  font-size: 13px;
  color: #374151;
}
.report-staff-picker__chip-remove {
  border: none;
  background: #e5e7eb;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  color: #4b5563;
}
.report-staff-picker__chip-remove:hover {
  background: #d1d5db;
}
.report-staff-picker__status {
  font-size: 12px;
  color: #6b7280;
  margin: 6px 0 0;
}
.report-staff-picker__results {
  list-style: none;
  margin: 8px 0 0;
  padding: 0;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fafafa;
}
.report-staff-picker__results-empty {
  padding: 10px 12px;
  font-size: 13px;
  color: #6b7280;
}
.report-staff-picker__result-btn {
  display: block;
  width: 100%;
  text-align: left;
  padding: 10px 12px;
  border: none;
  border-bottom: 1px solid #e5e7eb;
  background: transparent;
  cursor: pointer;
  font-size: 14px;
}
.report-staff-picker__result-btn:last-child {
  border-bottom: none;
}
.report-staff-picker__result-btn:hover:not(:disabled) {
  background: #f3f4f6;
}
.report-staff-picker__result-btn:disabled {
  opacity: 0.45;
  cursor: default;
}
.report-staff-picker__result-phone {
  font-weight: 400;
  color: #6b7280;
}

.form-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.15s;
  box-sizing: border-box;
}
.form-input:focus {
  border-color: #FA9411;
  box-shadow: 0 0 0 2px rgba(250, 148, 17, 0.15);
}
.form-input--textarea {
  resize: vertical;
  min-height: 70px;
}

.report-modal-overlay--fullscreen {
  padding: 0;
  align-items: stretch;
  justify-content: stretch;
}

.report-modal--fullscreen {
  max-width: none;
  max-height: none;
  width: 100%;
  height: 100%;
  border-radius: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 0;
}
.report-modal--fullscreen__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 24px;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
  background: #fff;
}
.report-modal--fullscreen__header h2 {
  margin: 0;
  font-size: 20px;
}
.report-modal--fullscreen__header-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}
.report-modal--fullscreen__body {
  flex: 1 1;
  overflow-y: auto;
  padding: 24px 32px 48px;
}

.report-config {
  padding: 24px;
}
.report-config__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}
.report-config__header h1 {
  font-size: 24px;
  font-weight: 700;
  margin: 0;
}
.report-config__sections {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.report-config__section {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}
.report-config__section--inactive {
  opacity: 0.6;
}
.report-config__section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 18px;
  cursor: pointer;
  background: #f9fafb;
  transition: background 0.15s;
}
.report-config__section-header:hover {
  background: #f3f4f6;
}
.report-config__section-info {
  display: flex;
  align-items: center;
  gap: 10px;
}
.report-config__section-info h3 {
  margin: 0;
  font-size: 16px;
}
.report-config__section-order {
  font-weight: 700;
  color: #6b7280;
  min-width: 20px;
}
.report-config__section-actions {
  display: flex;
  gap: 6px;
}
.report-config__tasks {
  padding: 16px 18px;
  border-top: 1px solid #e5e7eb;
}
.report-config__tasks-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.report-config__tasks-header h4 {
  margin: 0;
  font-size: 14px;
  text-transform: uppercase;
  color: #6b7280;
  letter-spacing: 0.5px;
}
.report-config__task {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 12px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  margin-bottom: 8px;
  background: #fff;
}
.report-config__task-info {
  display: flex;
  gap: 10px;
  flex: 1 1;
}
.report-config__task-order {
  font-weight: 600;
  color: #6b7280;
  min-width: 24px;
}
.report-config__task-fields {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 6px;
}
.report-config__task-staff {
  margin-top: 8px;
}
.report-config__task-staff-note {
  display: block;
  font-size: 12px;
  color: #9ca3af;
  font-style: italic;
  line-height: 1.4;
}
.report-config__task-staff-search {
  margin-top: 6px;
  max-width: 360px;
}
.report-config__task-actions {
  display: flex;
  gap: 6px;
  margin-left: 12px;
  flex-shrink: 0;
  align-self: flex-start;
}
.report-config__empty {
  text-align: center;
  color: #9ca3af;
  padding: 20px;
  font-size: 14px;
}

.report-field-builder-section {
  margin-top: 16px;
  margin-bottom: 12px;
}
.report-field-builder-section__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}
.report-field-builder-section__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.report-field-builder-section__count {
  font-size: 12px;
  color: #6b7280;
  margin-right: 4px;
}

.report-field-builder-group {
  margin-bottom: 16px;
  padding: 10px 12px 12px;
  border: 1px dashed #d1d5db;
  border-radius: 10px;
  background: #f9fafb;
}
.report-field-builder-group--ungrouped {
  padding: 0;
  border: none;
  background: transparent;
  margin-bottom: 8px;
}
.report-field-builder-group__questions {
  display: flex;
  flex-direction: column;
  gap: 0;
}
.report-field-builder-group--section-collapsed {
  padding-bottom: 8px;
}
.report-field-builder-group__hint {
  margin: 8px 0 0;
  font-size: 12px;
  color: #9ca3af;
  font-style: italic;
}
.report-field-builder-group__ungrouped-label {
  margin: 0 0 8px;
  padding-top: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #6b7280;
  border-top: 2px solid #e5e7eb;
}

.report-field-builder {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 8px;
  background: #fafafa;
}
.report-field-builder--in-section {
  margin-left: 12px;
  border-left: 3px solid #bae6fd;
}
.report-field-builder__section-tag {
  color: #0369a1;
  font-weight: 500;
}
.report-field-builder--section {
  background: #f0f9ff;
  border-color: #bae6fd;
}
.report-field-builder--section .report-field-builder__index {
  color: #0369a1;
  font-weight: 700;
}
.report-field-builder--subsection {
  margin-left: 18px;
  border-top: 4px solid #9aa3b2;
  background: #fafbfc;
}
.report-field-builder--subsection .report-field-builder__index {
  color: #8b93a1;
  font-weight: 700;
  font-size: 11px;
  letter-spacing: 0.02em;
}
.report-field-builder--collapsed {
  padding: 8px 10px;
  background: #fff;
}
.report-field-builder__header {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}
.report-field-builder__collapse {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  margin-top: 2px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #fff;
  color: #374151;
  cursor: pointer;
}
.report-field-builder__collapse:hover {
  background: #f3f4f6;
  border-color: #d1d5db;
}
.report-field-builder__chevron {
  display: block;
  width: 8px;
  height: 8px;
  border-right: 2px solid currentColor;
  border-bottom: 2px solid currentColor;
  transform: rotate(-45deg);
  transition: transform 0.15s ease;
  margin-top: -2px;
}
.report-field-builder__chevron--open {
  transform: rotate(45deg);
  margin-top: 2px;
}
.report-field-builder__index {
  flex-shrink: 0;
  min-width: 28px;
  margin-top: 6px;
  font-size: 12px;
  font-weight: 700;
  color: #6b7280;
}
.report-field-builder__row {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 0;
  flex: 1 1;
  min-width: 0;
}
.report-field-builder__title {
  flex: 1 1;
  min-width: 0;
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.report-field-builder__summary-meta {
  flex-shrink: 0;
  font-size: 11px;
  color: #6b7280;
  white-space: nowrap;
}
.report-field-builder__body {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #e5e7eb;
}
.report-field-builder__options, .report-field-builder__subfields {
  padding: 8px 0 0 16px;
  border-top: 1px solid #e5e7eb;
  margin-top: 8px;
}
.report-field-builder__options label, .report-field-builder__subfields label {
  font-size: 12px;
  font-weight: 500;
  color: #6b7280;
  margin-bottom: 4px;
  display: block;
}
.report-field-builder__body > .report-field-builder__options:first-child, .report-field-builder__body > .report-field-builder__subfields:first-child {
  border-top: none;
  margin-top: 0;
  padding-top: 0;
}

.report-events {
  padding: 24px;
}
.report-events__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 12px;
}
.report-events__header h1 {
  font-size: 24px;
  font-weight: 700;
  margin: 0;
}
.report-events__share-hint {
  margin: 8px 0 0;
  max-width: 520px;
  font-size: 13px;
  line-height: 1.45;
  color: #6b7280;
}
.report-events__share-hint strong {
  font-weight: 600;
  color: #4b5563;
}
.report-events__header-actions {
  display: flex;
  gap: 8px;
  align-items: center;
  align-self: center;
}
.report-events__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
}
.report-events__card {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 18px;
  background: #fff;
  cursor: pointer;
  transition: box-shadow 0.15s, transform 0.15s;
}
.report-events__card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  transform: translateY(-1px);
}
.report-events__card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
  gap: 10px;
}
.report-events__card-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  min-width: 0;
}
.report-events__card-header-right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.report-events__card-body p {
  margin: 4px 0;
  font-size: 13px;
  color: #4b5563;
}
.report-events__card-actions {
  display: flex;
  gap: 6px;
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid #f3f4f6;
}
.report-events__empty {
  text-align: center;
  padding: 60px 20px;
  color: #9ca3af;
}

.event-reporting {
  padding: 24px;
}
.event-reporting__header {
  margin-bottom: 20px;
}
.event-reporting__header h1 {
  font-size: 24px;
  font-weight: 700;
  margin: 0;
}
.event-reporting__toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}
.event-reporting__share-hint {
  margin: 0 0 12px;
  max-width: 560px;
  font-size: 13px;
  line-height: 1.45;
  color: #6b7280;
}
.event-reporting__meta {
  font-size: 14px;
  color: #6b7280;
  margin: 4px 0 0;
}
.event-reporting__progress {
  margin-bottom: 20px;
}
.event-reporting__progress-bar {
  height: 10px;
  background: #e5e7eb;
  border-radius: 5px;
  overflow: hidden;
  margin-bottom: 6px;
}
.event-reporting__progress-fill {
  height: 100%;
  background: #FA9411;
  border-radius: 5px;
  transition: width 0.4s ease;
}
.event-reporting__progress-text {
  font-size: 13px;
  color: #6b7280;
}
.event-reporting__empty {
  text-align: center;
  padding: 28px 16px;
  color: #6b7280;
  font-size: 14px;
  line-height: 1.5;
  border: 1px dashed #e5e7eb;
  border-radius: 10px;
  background: #fafafa;
}
.event-reporting__sections {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.event-reporting__section {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}
.event-reporting__section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 18px;
  cursor: pointer;
  background: #f9fafb;
  transition: background 0.15s;
}
.event-reporting__section-header:hover {
  background: #f3f4f6;
}
.event-reporting__section-title {
  display: flex;
  align-items: center;
  gap: 10px;
}
.event-reporting__section-title h2 {
  margin: 0;
  font-size: 17px;
  font-weight: 600;
}
.event-reporting__task-list {
  padding: 12px 18px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.event-reporting__task {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
  scroll-margin-top: 88px;
}
.event-reporting__task:focus {
  outline: 2px solid #FA9411;
  outline-offset: 2px;
  box-shadow: 0 0 0 4px rgba(250, 148, 17, 0.15);
}
.event-reporting__task-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  cursor: pointer;
  transition: background 0.15s;
}
.event-reporting__task-header:hover {
  background: #f9fafb;
}
.event-reporting__task-header-right {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 10px;
  flex-shrink: 0;
}
.event-reporting__reject-quick {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 600;
  color: #b91c1c;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, box-shadow 0.15s;
}
.event-reporting__reject-quick:hover {
  background: #fee2e2;
  border-color: #f87171;
  box-shadow: 0 1px 3px rgba(185, 28, 28, 0.12);
}
.event-reporting__reject-quick:focus-visible {
  outline: 2px solid #dc2626;
  outline-offset: 2px;
}
.event-reporting__admin-review-cta {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 16px 18px;
  margin-bottom: 16px;
  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
  border: 1px solid #fcd34d;
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(180, 83, 9, 0.08);
}
@media (min-width: 560px) {
  .event-reporting__admin-review-cta {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
}
.event-reporting__admin-review-cta-text {
  flex: 1 1;
  min-width: 0;
}
.event-reporting__admin-review-cta-text strong {
  display: block;
  font-size: 15px;
  color: #92400e;
  margin-bottom: 4px;
}
.event-reporting__admin-review-cta-text p {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: #78350f;
}
.event-reporting__reject-cta-btn {
  flex-shrink: 0;
  padding: 12px 20px;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  background: #dc2626;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(220, 38, 38, 0.35);
  transition: background 0.15s, transform 0.1s;
}
.event-reporting__reject-cta-btn:hover {
  background: #b91c1c;
}
.event-reporting__reject-cta-btn:active {
  transform: scale(0.98);
}
.event-reporting__reject-cta-btn:focus-visible {
  outline: 2px solid #dc2626;
  outline-offset: 2px;
}
.event-reporting__submitted-note--admin {
  margin-top: 0;
  margin-bottom: 0;
}
.event-reporting__task-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}
.event-reporting__task-order {
  font-weight: 600;
  color: #6b7280;
}
.event-reporting__task-body {
  padding: 16px;
  border-top: 1px solid #e5e7eb;
  background: #fafafa;
}
.event-reporting__task-actions {
  display: flex;
  gap: 8px;
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid #e5e7eb;
}
.event-reporting__submitted-note {
  margin-top: 12px;
  font-size: 13px;
  color: #15803d;
  font-style: italic;
}
.event-reporting__rejection-banner {
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 14px;
  font-size: 14px;
  color: #b91c1c;
  line-height: 1.5;
}
.event-reporting__rejection-banner strong {
  font-weight: 600;
}
.event-reporting__rejection-reason {
  margin: 6px 0 0;
  font-style: italic;
  color: #991b1b;
}
.event-reporting__admin-readonly-hint {
  font-size: 13px;
  color: #6b7280;
  margin: 0 0 14px;
  padding: 10px 12px;
  background: #f3f4f6;
  border-radius: 8px;
  border-left: 3px solid #9ca3af;
}
.event-reporting__rejection-history {
  margin-bottom: 16px;
}
.event-reporting__rejection-history-title {
  margin: 0 0 8px;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.event-reporting__rejection-history-list {
  margin: 0;
  padding: 0 0 0 18px;
  list-style: decimal;
}
.event-reporting__rejection-history-item {
  margin-bottom: 10px;
  padding: 10px 12px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}
.event-reporting__rejection-history-item--current {
  border-color: #fecaca;
  background: #fef2f2;
}
.event-reporting__rejection-history-meta {
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 4px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}
.event-reporting__rejection-history-reason {
  margin: 0;
  font-size: 14px;
  color: #991b1b;
  line-height: 1.45;
}

.dynamic-report-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.dynamic-report-form__section-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.dynamic-report-form__section-header {
  padding: 12px 4px 4px;
  border-bottom: 2px solid #e5e7eb;
}
.dynamic-report-form__section-header--toggle {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  margin: 0;
  padding: 12px 8px 10px;
  text-align: left;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.15s ease;
}
.dynamic-report-form__section-header--toggle:hover {
  background: #f3f4f6;
}
.dynamic-report-form__section-header--toggle:focus-visible {
  outline: 2px solid #FA9411;
  outline-offset: 2px;
}
.dynamic-report-form__section-chevron {
  font-size: 12px;
  color: #6b7280;
  width: 18px;
  flex-shrink: 0;
  line-height: 1.6;
}
.dynamic-report-form__section-header-text {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  flex: 1 1;
}
.dynamic-report-form__section-title {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #111827;
  letter-spacing: -0.01em;
}
.dynamic-report-form__section-desc {
  margin: 0;
  font-size: 13px;
  color: #6b7280;
  line-height: 1.45;
}
.dynamic-report-form__section-fields {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 4px 0 0 12px;
  border-left: 3px solid #e5e7eb;
}
.dynamic-report-form__subsection-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 4px;
}
.dynamic-report-form__subsection-header {
  padding: 8px 4px 2px;
}
.dynamic-report-form__subsection-header--toggle {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  margin: 0;
  padding: 8px 10px;
  text-align: left;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s ease;
}
.dynamic-report-form__subsection-header--toggle:hover {
  background: #eceff3;
}
.dynamic-report-form__subsection-header--toggle:focus-visible {
  outline: 2px solid #FA9411;
  outline-offset: 2px;
}
.dynamic-report-form__subsection-title {
  margin: 0;
  font-size: 14px;
  font-weight: 650;
  color: #1f2937;
}
.dynamic-report-form__subsection-desc {
  margin: 0;
  font-size: 12px;
  color: #6b7280;
  line-height: 1.4;
}
.dynamic-report-form__subsection-fields {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 2px 0 0 10px;
  border-left: 2px solid #d1d5db;
}
.dynamic-report-form__field {
  padding: 14px 14px 12px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  border-radius: 12px;
}
.dynamic-report-form__field label {
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 4px;
}
.dynamic-report-form__label {
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 4px;
}
.dynamic-report-form__required {
  color: #ef4444;
  margin-left: 2px;
}
.dynamic-report-form__accept-types {
  font-size: 12px;
  font-weight: 400;
  color: #6b7280;
}

.report-checkbox-inputs {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}
@media (max-width: 640px) {
  .report-checkbox-inputs {
    grid-template-columns: 1fr;
  }
}
.report-checkbox-inputs__row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fafafa;
  min-width: 0;
}
.report-checkbox-inputs__check {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #111827;
  cursor: pointer;
  flex: 1 1;
  min-width: 0;
}
.report-checkbox-inputs__check input {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}
.report-checkbox-inputs__side {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1 1;
  min-width: 88px;
}
.report-checkbox-inputs__number {
  max-width: 120px;
}
.report-checkbox-inputs__suffix {
  font-size: 14px;
  color: #6b7280;
  font-weight: 500;
}

.report-upload__image-link {
  display: inline-flex;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid rgba(250, 148, 17, 0.35);
  background: #fff;
  box-shadow: 0 1px 2px rgba(250, 148, 17, 0.08);
}

.report-upload input[type=file] {
  margin-top: 6px;
}

.report-toggle {
  display: flex;
  gap: 0;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  overflow: hidden;
  width: fit-content;
}
.report-toggle__btn {
  padding: 8px 20px;
  border: none;
  background: #fff;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.15s;
}
.report-toggle__btn:first-child {
  border-right: 1px solid #d1d5db;
}
.report-toggle__btn--active.report-toggle__btn--yes {
  background: #dcfce7;
  color: #15803d;
}
.report-toggle__btn--active.report-toggle__btn--no {
  background: #fef2f2;
  color: #b91c1c;
}

.report-gps {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.report-gps__btn {
  padding: 8px 14px;
  background: #f3f4f6;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  white-space: nowrap;
}
.report-gps__btn:hover {
  background: #e5e7eb;
}

.report-upload__preview {
  margin-bottom: 8px;
}
.report-upload__status {
  display: inline-block;
  margin-left: 8px;
  font-size: 13px;
  color: #FA9411;
  font-weight: 600;
}
.report-upload--multi {
  padding: 14px;
  border: 1.5px dashed rgba(250, 148, 17, 0.55);
  border-radius: 12px;
  background: linear-gradient(180deg, #fff8ef 0%, #fff4e4 100%);
}
.report-upload__file-list {
  list-style: none;
  padding: 0;
  margin: 0 0 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.report-upload__file-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  padding: 8px 10px;
  background: #fff;
  border: 1px solid rgba(250, 148, 17, 0.28);
  border-radius: 8px;
}
.report-upload__file-index {
  font-size: 13px;
  font-weight: 700;
  color: #9a5b08;
  min-width: 52px;
}
.report-upload__remove {
  margin-left: auto;
}
.report-upload__hint {
  font-size: 12px;
  color: #8a5a1a;
  margin: 0 0 10px;
  font-weight: 500;
}
.report-upload__hint--warn {
  color: #b45309;
  font-weight: 700;
}
.report-upload__picker {
  display: inline-flex;
  cursor: pointer;
}
.report-upload__picker .btn--secondary {
  background: #fff7eb;
  border-color: rgba(250, 148, 17, 0.55);
  color: #9a5b08;
  font-weight: 650;
}
.report-upload__picker .btn--secondary:hover:not(:disabled) {
  background: #ffefd6;
  border-color: #FA9411;
  color: #7a4706;
}
.report-upload__picker input[type=file] {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
.report-upload__empty-cta {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 11px 14px;
  border: 1.5px dashed rgba(250, 148, 17, 0.65);
  border-radius: 10px;
  background: linear-gradient(180deg, #fff9f0 0%, #ffefd6 100%);
  font-size: 13px;
  color: #9a5b08;
  font-weight: 650;
  box-shadow: 0 1px 2px rgba(250, 148, 17, 0.12);
  transition: background 0.15s ease, border-color 0.15s ease;
}
.report-upload__empty-cta:hover {
  background: linear-gradient(180deg, #fff3e0 0%, #ffe4bc 100%);
  border-color: #FA9411;
}
.report-upload__picker--empty {
  display: inline-flex;
  width: fit-content;
}

.report-repeater {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 12px;
  background: #fff;
}
.report-repeater__row {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 10px 12px;
  align-items: start;
  flex-wrap: wrap;
  padding: 12px 0;
  border-bottom: 1px solid #f3f4f6;
}
.report-repeater__row:last-of-type {
  border-bottom: none;
}
.report-repeater__index {
  font-weight: 600;
  font-size: 13px;
  color: #6b7280;
  min-width: 28px;
  padding-top: 6px;
}
.report-repeater__fields-grid {
  grid-column: 1/-1;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 16px;
}
@media (max-width: 720px) {
  .report-repeater__fields-grid {
    grid-template-columns: 1fr;
  }
}
.report-repeater__fields-grid--single {
  grid-template-columns: 1fr;
}
.report-repeater__fields-grid--entry {
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 8px 12px;
}
.report-repeater__field--answer-cell {
  min-width: 0;
  padding: 8px 10px;
  background: #f8fafc;
  border: 1px solid #f1f5f9;
  border-radius: 6px;
}
.report-repeater__field--answer-cell .coop-lookup-answer-block__row:not(.coop-lookup-answer-block__row--answer-only) {
  grid-template-columns: minmax(0, 0.85fr) minmax(0, 1.15fr);
  gap: 8px 14px;
  margin-bottom: 0;
}
.report-repeater__field--with-lookup {
  grid-column: 1/-1;
}
.report-repeater__field--with-lookup .coop-lookup-answer-block__row:not(.coop-lookup-answer-block__row--answer-only) {
  grid-template-columns: minmax(0, 0.85fr) minmax(0, 1.15fr);
  gap: 8px 14px;
}
.report-repeater__entry-histories {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dashed #e2e8f0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px 12px;
}
@media (max-width: 640px) {
  .report-repeater__entry-histories {
    grid-template-columns: 1fr;
  }
}
.report-repeater__entry-histories--single {
  grid-template-columns: 1fr;
}
.report-repeater__entry-histories__item {
  min-width: 0;
}
.report-repeater__entry-histories .coop-answer-history {
  margin-top: 4px;
  padding: 8px 10px;
}
.report-repeater__row:not(.report-repeater__row--readonly) .report-repeater__fields-grid {
  grid-column: 2;
}
.report-repeater__row--readonly {
  display: block;
}
.report-repeater__row--readonly .report-repeater__index {
  display: block;
  margin-bottom: 8px;
  padding-top: 0;
}
.report-repeater__row--readonly .report-repeater__fields-grid {
  grid-column: unset;
}
.report-repeater--sub-fields {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px 16px;
  border: none;
  padding: 0;
  background: transparent;
}
@media (max-width: 720px) {
  .report-repeater--sub-fields {
    grid-template-columns: 1fr;
  }
}
.report-repeater--sub-fields.report-repeater--sub-fields-single {
  grid-template-columns: 1fr;
}
.report-repeater__field {
  flex: 1 1;
  min-width: 0;
  grid-column: auto;
}
.report-repeater__label {
  font-size: 11px;
  color: #6b7280;
  margin-bottom: 4px;
  display: block;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.report-repeater__remove {
  grid-column: 1/-1;
  justify-self: end;
  padding: 4px 10px;
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
}
.report-repeater__remove:hover {
  background: #fee2e2;
}
.report-repeater__add {
  padding: 6px 14px;
  background: #f3f4f6;
  border: 1px dashed #d1d5db;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  margin-top: 8px;
  width: 100%;
  text-align: center;
}
.report-repeater__add:hover {
  background: #e5e7eb;
}

.report-evidence-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
}
.report-evidence-list__item {
  display: flex;
  align-items: center;
  gap: 4px;
  background: #f3f4f6;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 13px;
}
.report-evidence-list__item a {
  color: #1d4ed8;
}
.report-evidence-list__remove {
  background: none;
  border: none;
  color: #b91c1c;
  cursor: pointer;
  font-size: 14px;
  padding: 0 2px;
}

.report-dashboard {
  padding: 24px;
}
.report-dashboard__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 12px;
}
.report-dashboard__header h1 {
  font-size: 24px;
  font-weight: 700;
  margin: 0;
}
.report-dashboard__filters {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}
.report-dashboard__overview {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}
.report-dashboard__stat {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 20px;
  text-align: center;
}
.report-dashboard__stat-value {
  display: block;
  font-size: 28px;
  font-weight: 700;
  color: #FA9411;
}
.report-dashboard__stat-label {
  display: block;
  font-size: 13px;
  color: #6b7280;
  margin-top: 4px;
}
.report-dashboard__sections {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.report-dashboard__section {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}
.report-dashboard__section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 18px;
  cursor: pointer;
  background: #f9fafb;
  transition: background 0.15s;
}
.report-dashboard__section-header:hover {
  background: #f3f4f6;
}
.report-dashboard__section-header h3 {
  margin: 0;
  font-size: 16px;
}
.report-dashboard__tasks {
  padding: 0;
  border-top: 1px solid #e5e7eb;
}
.report-dashboard__table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}
.report-dashboard__table th {
  background: #f9fafb;
  padding: 10px 14px;
  text-align: left;
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  color: #6b7280;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #e5e7eb;
}
.report-dashboard__table td {
  padding: 10px 14px;
  border-bottom: 1px solid #f3f4f6;
  vertical-align: top;
}
.report-dashboard__task-row:hover {
  background: #f9fafb;
}
.report-dashboard__submission-detail {
  padding: 14px 16px;
  background: #f3f4f6;
}
.report-dashboard__submission-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 12px;
}
.report-dashboard__submission-card:last-child {
  margin-bottom: 0;
}
.report-dashboard__submission-head {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  background: #fafafa;
  border-bottom: 1px solid #e5e7eb;
}
.report-dashboard__submission-head-main {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: #6b7280;
}
.report-dashboard__submission-head-main strong {
  color: #111827;
  font-size: 14px;
}
.report-dashboard__submission-dates {
  color: #9ca3af;
  font-size: 12px;
}
.report-dashboard__event-link {
  flex-shrink: 0;
  text-decoration: none;
  white-space: nowrap;
}
.report-dashboard__submission-body {
  padding: 16px;
  background: #fafafa;
  border-top: none;
}
.report-dashboard__rejection-banner--compact {
  margin-bottom: 16px;
}
.report-dashboard__no-responses {
  margin: 0;
  font-size: 13px;
  color: #9ca3af;
  font-style: italic;
}
.report-dashboard__submission-meta {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
  font-size: 13px;
  color: #6b7280;
}
.report-dashboard__submission-meta strong {
  color: #111827;
}
.report-dashboard__submission-values {
  font-size: 13px;
  color: #374151;
  line-height: 1.6;
  padding: 8px 0;
}
.report-dashboard__submission-values div {
  margin-bottom: 2px;
}
.report-dashboard__evidence {
  font-size: 13px;
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid #e5e7eb;
}
.report-dashboard__evidence strong {
  display: block;
  margin-bottom: 8px;
  color: #374151;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.report-dashboard__evidence-link {
  display: inline-block;
  margin-right: 12px;
  margin-bottom: 4px;
  color: #1d4ed8;
  font-size: 13px;
}
.report-dashboard__rejection-info {
  font-size: 13px;
  color: #b91c1c;
  background: #fef2f2;
  border-radius: 6px;
  padding: 8px 10px;
  margin-top: 6px;
}
.report-dashboard__rejection-history {
  font-size: 13px;
  margin-top: 8px;
}
.report-dashboard__rejection-history strong {
  display: block;
  margin-bottom: 6px;
  color: #374151;
}
.report-dashboard__rejection-history-list {
  margin: 0;
  padding-left: 18px;
  color: #374151;
  line-height: 1.5;
}
.report-dashboard__rejection-history-list li {
  margin-bottom: 8px;
}
.report-dashboard__rejection-history-meta {
  font-size: 12px;
  color: #6b7280;
  display: block;
  margin-bottom: 2px;
}

.coop-tabs {
  display: flex;
  gap: 0;
  margin-bottom: 20px;
  border-bottom: 2px solid #e5e7eb;
}
.coop-tabs__tab {
  padding: 10px 24px;
  border: none;
  background: none;
  font-size: 14px;
  font-weight: 500;
  color: #6b7280;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  transition: color 0.15s, border-color 0.15s;
}
.coop-tabs__tab:hover {
  color: #374151;
}
.coop-tabs__tab--active {
  color: #FA9411;
  border-bottom-color: #FA9411;
}

.coop-management__toolbar {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
}

.coop-management__cluster-filter-row {
  margin-bottom: 16px;
}

.coop-management__cluster-filter {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 200px;
}

.coop-management__cluster-filter-label {
  font-size: 13px;
  font-weight: 500;
  color: #374151;
}

.coop-management__cluster-filter-select {
  max-width: 280px;
}

.coop-assignment__search {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  align-items: center;
}
.coop-assignment__checklist {
  max-height: 350px;
  overflow-y: auto;
  margin-bottom: 16px;
}
.coop-assignment__check-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid #f3f4f6;
  cursor: pointer;
  font-size: 14px;
}
.coop-assignment__check-item input[type=checkbox] {
  width: 18px;
  height: 18px;
}

.coop-lookup-field-wrap {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 12px;
  align-items: start;
}
@media (max-width: 720px) {
  .coop-lookup-field-wrap {
    grid-template-columns: 1fr;
  }
}
.coop-lookup-field-wrap--solo {
  grid-template-columns: 1fr;
}
.coop-lookup-field-wrap__input, .coop-lookup-field-wrap__details {
  min-width: 0;
}

.coop-lookup-details {
  padding: 10px 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  height: fit-content;
}
.coop-lookup-details__title {
  font-size: 11px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 8px;
}
.coop-lookup-details__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px 12px;
}
@media (max-width: 480px) {
  .coop-lookup-details__grid {
    grid-template-columns: 1fr;
  }
}
.coop-lookup-details__item {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}
.coop-lookup-details__label {
  font-size: 11px;
  font-weight: 500;
  color: #94a3b8;
  line-height: 1.3;
}
.coop-lookup-details__value {
  font-size: 13px;
  color: #334155;
  word-break: break-word;
  line-height: 1.35;
}
.coop-lookup-details--compact {
  padding: 8px 10px;
  background: #fff;
  border-color: #f1f5f9;
}
.coop-lookup-details--compact .coop-lookup-details__title {
  font-size: 10px;
  margin-bottom: 6px;
}
.coop-lookup-details--compact .coop-lookup-details__grid {
  gap: 4px 10px;
}
.coop-lookup-details--compact .coop-lookup-details__value {
  font-size: 12px;
}

.coop-lookup-answer-block__row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 12px;
  align-items: start;
  margin-bottom: 10px;
}
@media (max-width: 720px) {
  .coop-lookup-answer-block__row {
    grid-template-columns: 1fr;
  }
}
.coop-lookup-answer-block__row--answer-only {
  grid-template-columns: 1fr;
  margin-bottom: 0;
}
.coop-lookup-answer-block__answer {
  min-width: 0;
  font-size: 14px;
  color: #374151;
  line-height: 1.45;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.coop-lookup-answer-block__details {
  min-width: 0;
}

.coop-subfield-answers-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px 16px;
}
@media (max-width: 720px) {
  .coop-subfield-answers-grid {
    grid-template-columns: 1fr;
  }
}
.coop-subfield-answers-grid--single {
  grid-template-columns: 1fr;
}
.coop-subfield-answers-grid__cell {
  min-width: 0;
  padding: 10px 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.coop-answer-value {
  font-size: 14px;
  color: #334155;
  word-break: break-word;
  line-height: 1.45;
}
.coop-answer-value--empty {
  color: #94a3b8;
}
.coop-answer-value__link {
  font-size: 13px;
  font-weight: 500;
  color: #1d4ed8;
  text-decoration: none;
}
.coop-answer-value__link:hover {
  text-decoration: underline;
}

.coop-answer-value-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px 12px;
}
@media (max-width: 480px) {
  .coop-answer-value-grid {
    grid-template-columns: 1fr;
  }
}
.coop-answer-value-grid--inline {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.coop-answer-value-grid__item {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}
.coop-answer-value-grid__label {
  font-size: 11px;
  font-weight: 500;
  color: #94a3b8;
  line-height: 1.3;
}
.coop-answer-value-grid__value {
  font-size: 13px;
  color: #334155;
  word-break: break-word;
}

.coop-bank-details__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 14px;
}
@media (max-width: 640px) {
  .coop-bank-details__grid {
    grid-template-columns: 1fr;
  }
}
.coop-bank-details__field {
  min-width: 0;
}
.coop-bank-details__field--full {
  grid-column: 1/-1;
}
.coop-bank-details__label {
  display: block;
  margin-bottom: 4px;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.coop-bank-details__error {
  margin: 0 0 8px;
  font-size: 12px;
  color: #b91c1c;
}
.coop-bank-details__warning {
  margin: 8px 0 0;
  font-size: 12px;
  line-height: 1.45;
  color: #b45309;
  background: #fffbeb;
  border: 1px solid #fcd34d;
  border-radius: 8px;
  padding: 8px 10px;
}
.coop-bank-details__member-flag {
  display: inline-block;
  margin-left: 8px;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  color: #b45309;
  background: #fffbeb;
  border: 1px solid #fcd34d;
  vertical-align: middle;
}

.coop-answer-badge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
}
.coop-answer-badge--yes {
  background: #dcfce7;
  color: #15803d;
}
.coop-answer-badge--no {
  background: #fef2f2;
  color: #b91c1c;
}

.coop-submitted-answer__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 6px;
}
.coop-submitted-answer--compact .coop-submitted-answer__row {
  justify-content: flex-end;
  margin-bottom: 4px;
}
.coop-submitted-answer--compact .coop-answer-history {
  margin-top: 6px;
  padding: 8px 10px;
}
.coop-submitted-answer__label {
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.coop-submitted-answer__value {
  font-size: 15px;
  color: #0f172a;
  word-break: break-word;
}
.coop-submitted-answer__correction {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px dashed #e5e7eb;
}

.coop-answer-history {
  margin-top: 8px;
  padding: 10px 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}
.coop-answer-history__title {
  margin: 0 0 8px;
  font-size: 11px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.coop-answer-history__list {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0;
}
.coop-answer-history__item {
  display: grid;
  grid-template-columns: minmax(0, 0.85fr) minmax(0, 1.15fr);
  gap: 8px 14px;
  align-items: start;
  padding: 8px 0;
  border-bottom: 1px solid #f1f5f9;
}
.coop-answer-history__item:last-child {
  padding-bottom: 0;
  border-bottom: none;
}
.coop-answer-history__item--no-details {
  grid-template-columns: 1fr;
}
.coop-answer-history__main {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.coop-answer-history__details {
  min-width: 0;
}
.coop-answer-history__value {
  font-size: 14px;
  color: #334155;
  word-break: break-word;
  line-height: 1.4;
  min-width: 0;
}
.coop-answer-history__meta {
  font-size: 11px;
  color: #94a3b8;
}

.coop-form-fill__month-panels {
  margin-bottom: 24px;
}
.coop-form-fill__month-panels-title {
  margin: 0 0 12px;
  font-size: 16px;
  font-weight: 600;
  color: #374151;
}
.coop-form-fill__month-accordion {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.coop-form-fill__month-accordion--current {
  margin-bottom: 8px;
}
.coop-form-fill__month-accordion-item {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #fff;
  overflow: hidden;
}
.coop-form-fill__month-accordion-item--collapsed .coop-form-fill__month-accordion-head {
  border-bottom: none;
}
.coop-form-fill__month-accordion-head {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 14px 16px;
  text-align: left;
  background: #f9fafb;
  border: none;
  border-bottom: 1px solid #e5e7eb;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  color: #111827;
}
.coop-form-fill__month-accordion-head:hover {
  background: #f3f4f6;
}
.coop-form-fill__month-accordion-head:focus-visible {
  outline: 2px solid #FA9411;
  outline-offset: -2px;
}
.coop-form-fill__month-accordion-chevron {
  font-size: 12px;
  color: #6b7280;
  width: 18px;
  flex-shrink: 0;
}
.coop-form-fill__month-accordion-title {
  flex: 1 1;
  min-width: 0;
}
.coop-form-fill__month-accordion-body {
  padding: 16px;
  background: #f9fafb;
}
.coop-form-fill__header {
  margin-bottom: 20px;
}
.coop-form-fill__header h2 {
  margin: 0 0 4px;
  font-size: 22px;
}
.coop-form-fill__step {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.coop-form-fill__step-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  flex-wrap: wrap;
}
.coop-form-fill__step-header h2 {
  margin: 0 0 4px;
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
}
.coop-form-fill__step-header p {
  margin: 0;
  color: #6b7280;
  font-size: 14px;
}
.coop-form-fill__year-nav {
  display: flex;
  align-items: center;
  gap: 8px;
}
.coop-form-fill__year-label {
  min-width: 56px;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  color: #0f172a;
}
.coop-form-fill__month-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}
.coop-form-fill__month-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 20px 12px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
  color: #0f172a;
}
.coop-form-fill__month-card:hover {
  border-color: #FA9411;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
.coop-form-fill__month-card:focus-visible {
  outline: 2px solid #FA9411;
  outline-offset: 2px;
}
.coop-form-fill__month-card--current {
  border-color: #FA9411;
  background: #fff7ed;
}
.coop-form-fill__month-short {
  font-size: 18px;
  font-weight: 700;
}
.coop-form-fill__month-full {
  font-size: 12px;
  color: #6b7280;
}
.coop-form-fill__year-type-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}
.coop-form-fill__year-type-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding: 24px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.coop-form-fill__year-type-card h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
}
.coop-form-fill__year-type-card p {
  margin: 0;
  font-size: 14px;
  color: #6b7280;
  line-height: 1.5;
}
.coop-form-fill__year-type-card:hover {
  border-color: #FA9411;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
.coop-form-fill__year-type-card:focus-visible {
  outline: 2px solid #FA9411;
  outline-offset: 2px;
}
.coop-form-fill__coop-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}
.coop-form-fill__coop-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  padding: 16px 18px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.coop-form-fill__coop-card:hover:not(:disabled) {
  border-color: #FA9411;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
.coop-form-fill__coop-card:focus-visible {
  outline: 2px solid #FA9411;
  outline-offset: 2px;
}
.coop-form-fill__coop-card--disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.coop-form-fill__coop-name {
  font-size: 15px;
  font-weight: 600;
  color: #0f172a;
  line-height: 1.4;
}
.coop-form-fill__coop-status {
  font-size: 12px;
  font-weight: 500;
}
.coop-form-fill__coop-status--draft {
  color: #d97706;
}
.coop-form-fill__coop-status--submitted {
  color: #16a34a;
}
@media (max-width: 900px) {
  .coop-form-fill__coop-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .coop-form-fill__month-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 600px) {
  .coop-form-fill__month-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .coop-form-fill__year-type-grid, .coop-form-fill__coop-grid {
    grid-template-columns: 1fr;
  }
}

.coop-progress__summary {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
}
.coop-progress__stat {
  flex: 1 1;
  min-width: 120px;
  padding: 16px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  text-align: center;
}
.coop-progress__stat--success {
  border-color: #86efac;
  background: #f0fdf4;
}
.coop-progress__stat--warning {
  border-color: #fcd34d;
  background: #fffbeb;
}
.coop-progress__stat--muted {
  border-color: #e5e7eb;
  background: #f9fafb;
}
.coop-progress__stat--clickable {
  text-decoration: none;
  color: inherit;
  cursor: pointer;
  transition: box-shadow 0.15s ease, border-color 0.15s ease;
}
.coop-progress__stat--clickable:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
.coop-progress__stat--clickable:focus-visible {
  outline: 2px solid #FA9411;
  outline-offset: 2px;
}
.coop-progress__stat-value {
  display: block;
  font-size: 28px;
  font-weight: 700;
  color: #111827;
}
.coop-progress__stat-label {
  display: block;
  font-size: 12px;
  color: #6b7280;
  margin-top: 4px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.coop-progress__bar {
  width: 100px;
  height: 8px;
  background: #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
}
.coop-progress__bar-fill {
  height: 100%;
  background: #FA9411;
  border-radius: 4px;
  transition: width 0.3s ease;
}
.coop-progress__filters {
  margin-bottom: 20px;
  padding: 14px 16px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
}
.coop-progress__filters-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px 16px;
}
.coop-progress__filter-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 160px;
}
.coop-progress__filter-label {
  font-size: 12px;
  font-weight: 600;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.coop-progress__filters-coops {
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid #e5e7eb;
}
.coop-progress__filters-coops-actions {
  display: flex;
  gap: 8px;
  margin: 8px 0 10px;
  flex-wrap: wrap;
}
.coop-progress__filters-coops-list {
  max-height: 200px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px 10px;
  background: #f9fafb;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}
.coop-progress__filters-coop-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 13px;
  color: #1f2937;
  cursor: pointer;
}
.coop-progress__filters-coop-item input {
  margin-top: 2px;
  flex-shrink: 0;
}
.coop-progress__tree {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
}
.coop-progress__cluster-block {
  padding: 16px 18px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
}
.coop-progress__cluster-link {
  font-size: 17px;
  font-weight: 700;
  color: #FA9411;
  text-decoration: none;
}
.coop-progress__cluster-link:hover {
  text-decoration: underline;
}
.coop-progress__cluster-meta {
  display: block;
  font-size: 12px;
  color: #6b7280;
  margin: 4px 0 12px;
}
.coop-progress__coop-list {
  list-style: none;
  margin: 0;
  padding: 0 0 0 12px;
  border-left: 2px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.coop-progress__coop-list li {
  font-size: 14px;
}
.coop-progress__coop-list a {
  color: #1f2937;
  font-weight: 600;
  text-decoration: none;
}
.coop-progress__coop-list a:hover {
  color: #FA9411;
  text-decoration: underline;
}
.coop-progress__coop-hint {
  font-size: 12px;
  font-weight: 400;
  color: #9ca3af;
  margin-left: 4px;
}
.coop-progress__inline-answers {
  margin-top: 8px;
}
.coop-progress__coop-accordion {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.coop-progress__coop-accordion-item {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #fff;
  overflow: hidden;
}
.coop-progress__coop-accordion-head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 14px 16px;
  text-align: left;
  background: #f9fafb;
  border: none;
  border-bottom: 1px solid #e5e7eb;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  color: #111827;
}
.coop-progress__coop-accordion-head:hover {
  background: #f3f4f6;
}
.coop-progress__coop-accordion-chevron {
  font-size: 12px;
  color: #6b7280;
  width: 18px;
  flex-shrink: 0;
}
.coop-progress__coop-accordion-title {
  flex: 1 1;
  min-width: 0;
}
.coop-progress__coop-accordion-body {
  padding: 16px 18px;
  border-top: 1px solid #f3f4f6;
}
.coop-progress__completed-coop-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.coop-progress__completed-coop-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
}
.coop-progress__completed-coop-link {
  font-size: 15px;
  font-weight: 600;
  color: #FA9411;
  text-decoration: none;
}
.coop-progress__completed-coop-link:hover {
  text-decoration: underline;
}

.coop-progress-detail__back {
  display: inline-block;
  margin-bottom: 12px;
  font-size: 14px;
  color: #4b5563;
  text-decoration: none;
}
.coop-progress-detail__back:hover {
  color: #FA9411;
  text-decoration: underline;
}
.coop-progress-detail__sections {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.coop-progress-detail__card {
  padding: 18px 20px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
}
.coop-progress-detail__card-head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}
.coop-progress-detail__card-head h2 {
  margin: 0;
  font-size: 18px;
}

.coop-select-options {
  margin-top: 8px;
}
.coop-select-options__hint {
  margin: 0 0 10px;
  font-size: 12px;
  color: #6b7280;
  line-height: 1.4;
}
.coop-select-options__row {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 8px;
}
.coop-select-options__row .form-input {
  flex: 1 1;
  min-width: 0;
}
.coop-select-options__glyph {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  display: inline-block;
  border: 1.5px solid #d8dce3;
}
.coop-select-options__glyph--box {
  border-radius: 4px;
}
.coop-select-options--inline .coop-select-options__row {
  margin-bottom: 6px;
}

.coop-members-editor {
  margin-bottom: 20px;
  padding: 16px;
  border: 1px solid #d1fae5;
  border-radius: 10px;
  background: #ecfdf5;
}
.coop-members-editor__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 6px;
}
.coop-members-editor__title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #065f46;
}
.coop-members-editor__count {
  font-size: 13px;
  font-weight: 600;
  color: #047857;
}
.coop-members-editor__hint {
  margin: 0 0 12px;
  font-size: 13px;
  color: #047857;
  line-height: 1.45;
}
.coop-members-editor__list {
  list-style: none;
  margin: 0 0 12px;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.coop-members-editor__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}
.coop-members-editor__info {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.coop-members-editor__meta {
  font-size: 12px;
  color: #6b7280;
}
.coop-members-editor__role {
  font-size: 11px;
  font-weight: 600;
  color: #7c3aed;
  text-transform: capitalize;
}
.coop-members-editor__role-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  min-width: 180px;
}
.coop-members-editor__role-label {
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}
.coop-members-editor__role-select {
  min-width: 180px;
  max-width: 240px;
  padding: 6px 8px;
  font-size: 13px;
}
.coop-members-editor__add-role {
  margin-bottom: 8px;
  max-width: 280px;
}
.coop-members-editor__remove {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}
.coop-members-editor__empty {
  padding: 10px 12px;
  font-size: 13px;
  color: #92400e;
  background: #fffbeb;
  border-radius: 8px;
}
.coop-members-editor__add-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 6px;
}
.coop-members-editor__lookup-status {
  margin: 6px 0 0;
  font-size: 12px;
  color: #6b7280;
}
.coop-members-editor__lookup {
  list-style: none;
  margin: 8px 0 0;
  padding: 0;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fff;
  max-height: 220px;
  overflow-y: auto;
}
.coop-members-editor__lookup-item {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 10px 12px;
  text-align: left;
  border: none;
  border-bottom: 1px solid #f3f4f6;
  background: transparent;
  cursor: pointer;
  font-size: 13px;
}
.coop-members-editor__lookup-item:last-child {
  border-bottom: none;
}
.coop-members-editor__lookup-item:hover:not(:disabled) {
  background: #f9fafb;
}
.coop-members-editor__lookup-item:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.coop-members-editor__already {
  margin-left: auto;
  font-size: 11px;
  color: #6b7280;
}
.coop-members-editor__max {
  margin: 0;
  font-size: 13px;
  color: #92400e;
}
.coop-members-editor__past {
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid #d1d5db;
}
.coop-members-editor__past-title {
  margin: 0 0 4px;
  font-size: 14px;
  font-weight: 600;
  color: #4b5563;
}
.coop-members-editor__past-hint {
  margin: 0 0 10px;
  font-size: 12px;
  color: #6b7280;
  line-height: 1.45;
}
.coop-members-editor__past-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.coop-members-editor__past-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 10px;
  background: #f9fafb;
  border: 1px dashed #d1d5db;
  border-radius: 8px;
  opacity: 0.92;
}
.coop-members-editor__past-date {
  font-size: 11px;
  color: #9ca3af;
  flex-shrink: 0;
}
.coop-members-editor__add-actions {
  margin-bottom: 12px;
}
.coop-members-editor__register-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.msp-reg-modal__overlay {
  position: fixed;
  inset: 0;
  z-index: 1200;
  background: rgba(15, 23, 42, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.msp-reg-modal__content {
  width: min(960px, 100%);
  max-height: min(92vh, 900px);
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.msp-reg-modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 20px 24px 12px;
  border-bottom: 1px solid #e5e7eb;
}
.msp-reg-modal__title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #111827;
}
.msp-reg-modal__subtitle {
  margin: 6px 0 0;
  font-size: 13px;
  color: #6b7280;
}
.msp-reg-modal__close {
  border: none;
  background: transparent;
  font-size: 28px;
  line-height: 1;
  color: #6b7280;
  cursor: pointer;
  padding: 0 4px;
}
.msp-reg-modal__form {
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1 1;
}
.msp-reg-modal__body {
  overflow: auto;
  padding: 16px 24px;
}
.msp-reg-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #e5e7eb;
  background: #f9fafb;
}
.msp-reg-modal__error-list {
  margin: 8px 0 0;
  padding-left: 18px;
}
.msp-reg-modal__photo {
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e5e7eb;
}
.msp-reg-modal__photo-hint {
  margin: 0 0 12px;
  font-size: 12px;
  color: #6b7280;
}
.msp-reg-modal__photo-preview {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}
.msp-reg-modal__photo-preview img {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #d1d5db;
}
.msp-reg-modal__photo-upload input[type=file] {
  display: none;
}
.msp-reg-modal__photo-error {
  margin-top: 10px;
}
.msp-reg-modal__role {
  margin-bottom: 16px;
  max-width: 320px;
}

.msp-reg-form__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px 16px;
}
@media (max-width: 768px) {
  .msp-reg-form__grid {
    grid-template-columns: 1fr;
  }
}
.msp-reg-form__group--full {
  grid-column: 1/-1;
}
.msp-reg-form__label {
  display: block;
  margin-bottom: 6px;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
}
.msp-reg-form__input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  background: #fff;
}
.msp-reg-form__input:disabled {
  background: #f3f4f6;
  color: #6b7280;
}

.coop-audit-log {
  padding: 24px 28px 40px;
  max-width: 1600px;
}
.coop-audit-log__header {
  margin-bottom: 20px;
}
.coop-audit-log__title {
  margin: 0 0 6px;
  font-size: 26px;
  font-weight: 700;
  color: #111827;
  display: flex;
  align-items: center;
}
.coop-audit-log__subtitle {
  margin: 0;
  color: #6b7280;
  font-size: 14px;
}
.coop-audit-log__filters {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 12px 16px;
  padding: 16px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  margin-bottom: 20px;
}
.coop-audit-log__field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  color: #6b7280;
}
.coop-audit-log__field select,
.coop-audit-log__field input {
  padding: 8px 10px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  color: #111827;
  background: #fff;
}
.coop-audit-log__filter-actions {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  grid-column: 1/-1;
}
.coop-audit-log__error {
  margin-bottom: 16px;
  padding: 10px 14px;
  background: #fef2f2;
  color: #b91c1c;
  border-radius: 8px;
  font-size: 14px;
}
.coop-audit-log__layout {
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) minmax(280px, 0.9fr);
  gap: 20px;
  align-items: start;
}
.coop-audit-log__table-wrap {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: auto;
}
.coop-audit-log__table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.coop-audit-log__table th,
.coop-audit-log__table td {
  padding: 10px 12px;
  text-align: left;
  border-bottom: 1px solid #f3f4f6;
  vertical-align: top;
}
.coop-audit-log__table th {
  background: #f9fafb;
  font-weight: 600;
  color: #374151;
  white-space: nowrap;
}
.coop-audit-log__table tbody tr {
  cursor: pointer;
}
.coop-audit-log__table tbody tr:hover {
  background: #f9fafb;
}
.coop-audit-log__row--selected {
  background: #fff7ed !important;
}
.coop-audit-log__badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  text-transform: capitalize;
  background: #f3f4f6;
  color: #374151;
}
.coop-audit-log__badge--draft {
  background: #fef3c7;
  color: #92400e;
}
.coop-audit-log__badge--submit {
  background: #dcfce7;
  color: #166534;
}
.coop-audit-log__badge--correction {
  background: #dbeafe;
  color: #1e40af;
}
.coop-audit-log__badge--admin_clear, .coop-audit-log__badge--admin_reopen {
  background: #fce7f3;
  color: #9d174d;
}
.coop-audit-log__pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border-top: 1px solid #e5e7eb;
  font-size: 13px;
  color: #6b7280;
}
.coop-audit-log__detail {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 16px 18px;
  position: sticky;
  top: 16px;
  max-height: calc(100vh - 48px);
  overflow: auto;
}
.coop-audit-log__detail h2 {
  margin: 0 0 12px;
  font-size: 18px;
}
.coop-audit-log__detail h3 {
  margin: 16px 0 8px;
  font-size: 13px;
  color: #374151;
}
.coop-audit-log__meta {
  margin: 0;
  display: grid;
  gap: 10px;
  font-size: 13px;
}
.coop-audit-log__meta div {
  display: grid;
  gap: 2px;
}
.coop-audit-log__meta dt {
  margin: 0;
  color: #9ca3af;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.coop-audit-log__meta dd {
  margin: 0;
  color: #111827;
}
.coop-audit-log__snapshot pre {
  margin: 0;
  padding: 10px 12px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 12px;
  line-height: 1.45;
  white-space: pre-wrap;
  word-break: break-word;
  max-height: 280px;
  overflow: auto;
}
.coop-audit-log__muted {
  margin: 0;
  padding: 24px 16px;
  color: #9ca3af;
  font-size: 14px;
  text-align: center;
}
@media (max-width: 1100px) {
  .coop-audit-log__layout {
    grid-template-columns: 1fr;
  }
  .coop-audit-log__detail {
    position: static;
    max-height: none;
  }
}

.issue-reports {
  padding: 20px;
}
.issue-reports__container {
  max-width: 1200px;
  margin: 0 auto;
}
.issue-reports__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}
.issue-reports__title {
  font-size: 24px;
  font-weight: 700;
  margin: 0;
}
.issue-reports__subtitle {
  margin: 6px 0 0;
  color: #6b7280;
  font-size: 14px;
}
.issue-reports__header-actions {
  display: flex;
  gap: 10px;
}
.issue-reports__filters {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 160px;
  gap: 12px;
  margin: 16px 0;
}
@media (max-width: 900px) {
  .issue-reports__filters {
    grid-template-columns: 1fr;
  }
}
.issue-reports__filter {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.issue-reports__filter--small {
  max-width: 220px;
}
.issue-reports__label {
  font-size: 12px;
  color: #6b7280;
}
.issue-reports__input {
  width: 100%;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 10px 12px;
  background: #fff;
  outline: none;
}
.issue-reports__button {
  border: 1px solid #111827;
  background: #111827;
  color: #fff;
  border-radius: 10px;
  padding: 10px 12px;
  cursor: pointer;
}
.issue-reports__button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.issue-reports__button--secondary {
  background: #fff;
  color: #111827;
}
.issue-reports__error {
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #991b1b;
  padding: 10px 12px;
  border-radius: 12px;
  margin: 12px 0;
}
.issue-reports__table-wrap {
  overflow: auto;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  background: #fff;
}
.issue-reports__table {
  width: 100%;
  border-collapse: collapse;
  min-width: 900px;
}
.issue-reports__table th,
.issue-reports__table td {
  padding: 12px 14px;
  border-bottom: 1px solid #f3f4f6;
  font-size: 14px;
  vertical-align: top;
}
.issue-reports__table th {
  text-align: left;
  font-size: 12px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #6b7280;
  background: #fafafa;
  position: sticky;
  top: 0;
  z-index: 1;
}
.issue-reports__table tr:hover td {
  background: #fcfcfd;
}
.issue-reports__empty {
  text-align: center;
  color: #6b7280;
  padding: 24px 14px !important;
}
.issue-reports__mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.issue-reports__link {
  background: transparent;
  border: 0;
  color: #2563eb;
  cursor: pointer;
  font-weight: 600;
}
.issue-reports__pill {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  text-transform: capitalize;
  border: 1px solid transparent;
}
.issue-reports__pill--whistleblowing {
  background: #fff7ed;
  color: #9a3412;
  border-color: #fed7aa;
}
.issue-reports__pill--safety {
  background: #eff6ff;
  color: #1d4ed8;
  border-color: #bfdbfe;
}
.issue-reports__pill--status-pending {
  background: #fefce8;
  color: #854d0e;
  border-color: #fde68a;
  text-transform: none;
}
.issue-reports__pill--status-under-review {
  background: #eef2ff;
  color: #3730a3;
  border-color: #c7d2fe;
  text-transform: none;
}
.issue-reports__pill--status-resolved {
  background: #ecfdf5;
  color: #065f46;
  border-color: #a7f3d0;
  text-transform: none;
}
.issue-reports__pill--status-dismissed {
  background: #f3f4f6;
  color: #374151;
  border-color: #e5e7eb;
  text-transform: none;
}
.issue-reports__pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0 2px;
  color: #6b7280;
  font-size: 13px;
}

.issue-report-detail {
  padding: 20px;
}
.issue-report-detail__container {
  max-width: 1200px;
  margin: 0 auto;
}
.issue-report-detail__topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}
.issue-report-detail__back {
  color: #2563eb;
  text-decoration: none;
  font-weight: 600;
}
.issue-report-detail__loading {
  color: #6b7280;
  padding: 12px 0;
}
.issue-report-detail__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin: 12px 0 16px;
}
.issue-report-detail__title {
  margin: 0;
  font-size: 22px;
  font-weight: 800;
}
.issue-report-detail__meta {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.issue-report-detail__grid {
  display: grid;
  grid-template-columns: 420px 1fr;
  gap: 14px;
}
@media (max-width: 1000px) {
  .issue-report-detail__grid {
    grid-template-columns: 1fr;
  }
}
.issue-report-detail__card {
  border: 1px solid #e5e7eb;
  background: #fff;
  border-radius: 14px;
  padding: 14px;
}
.issue-report-detail__card-title {
  margin: 0 0 10px;
  font-size: 14px;
  color: #111827;
  font-weight: 800;
}
.issue-report-detail__fields {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
}
.issue-report-detail__field {
  display: grid;
  grid-template-columns: 140px 1fr;
  gap: 10px;
  align-items: start;
}
@media (max-width: 520px) {
  .issue-report-detail__field {
    grid-template-columns: 1fr;
    gap: 4px;
  }
}
.issue-report-detail__label {
  font-size: 12px;
  color: #6b7280;
}
.issue-report-detail__value {
  font-size: 14px;
  color: #111827;
}
.issue-report-detail__value--mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.issue-report-detail__value--pre {
  white-space: pre-wrap;
  word-break: break-word;
  background: #fafafa;
  border: 1px solid #f3f4f6;
  padding: 10px 12px;
  border-radius: 12px;
}
.disabled\\:bg-gray-300:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}`, "",{"version":3,"sources":["webpack://./src/styles/index.scss","webpack://./src/styles/base/_reset.scss","webpack://./src/styles/utils/_variables.scss","webpack://./src/styles/base/_global.scss","webpack://./src/styles/shared/_svgs.scss","webpack://./src/styles/components/_team.scss","webpack://./src/styles/components/admin/_sidebar.scss","webpack://./src/styles/pages/_home.scss","webpack://./src/styles/shared/_buttons.scss","webpack://./src/styles/pages/_userId.scss","webpack://./src/styles/pages/_fingerprint.scss","webpack://./src/styles/pages/_meal.scss","webpack://./src/styles/pages/_issue-report.scss","webpack://./src/styles/pages/_qrcode-display.scss","webpack://./src/styles/pages/_food-poll.scss","webpack://./src/styles/pages/admin/_login.scss","webpack://./src/styles/shared/_fields.scss","webpack://./src/styles/pages/admin/_users.scss","webpack://./src/styles/pages/admin/_layout.scss","webpack://./src/styles/pages/admin/_reporting.scss","webpack://./src/styles/pages/admin/_issue-reports.scss","webpack://./src/styles/base/_fonts.scss"],"names":[],"mappings":"AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;;CAAA;AAAA;;;CAAA;AAAA;;;EAAA,sBAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,mBAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;AAAA;;EAAA,gBAAA;AAAA;AAAA;;;;;;;;CAAA;AAAA;;EAAA,gBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA,EAAA,MAAA;EAAA,WAAA,EAAA,MAAA;EAAA,+HAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,wCAAA,EAAA,MAAA;AAAA;AAAA;;;CAAA;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;AAAA;;;;CAAA;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,yCAAA;UAAA,iCAAA;AAAA;AAAA;;CAAA;AAAA;;;;;;EAAA,kBAAA;EAAA,oBAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,cAAA;EAAA,wBAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,mBAAA;AAAA;AAAA;;;;;CAAA;AAAA;;;;EAAA,+GAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,cAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,cAAA;EAAA,cAAA;EAAA,kBAAA;EAAA,wBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,WAAA;AAAA;AAAA;;;;CAAA;AAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;EAAA,yBAAA,EAAA,MAAA;AAAA;AAAA;;;;CAAA;AAAA;;;;;EAAA,oBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gCAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,uBAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,SAAA,EAAA,MAAA;EAAA,UAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,oBAAA;AAAA;AAAA;;;CAAA;AAAA;;;;EAAA,0BAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,aAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,wBAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,YAAA;AAAA;AAAA;;;CAAA;AAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,wBAAA;AAAA;AAAA;;;CAAA;AAAA;EAAA,0BAAA,EAAA,MAAA;EAAA,aAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;;CAAA;AAAA;;;;;;;;;;;;;EAAA,SAAA;AAAA;AAAA;EAAA,SAAA;EAAA,UAAA;AAAA;AAAA;EAAA,UAAA;AAAA;AAAA;;;EAAA,gBAAA;EAAA,SAAA;EAAA,UAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,UAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;;;CAAA;AAAA;;EAAA,UAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,eAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,eAAA;AAAA;AAAA;;;;CAAA;AAAA;;;;;;;;EAAA,cAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,eAAA;EAAA,YAAA;AAAA;AAAA,wEAAA;AAAA;EAAA,aAAA;AAAA;AACA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AACA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,4DAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,wJAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA;AAAA;ACFA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAiFE,SAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,wBAAA;ADKF;;ACFA;;;;;;;;;;;EAWE,cAAA;ADKF;;ACFA;EACE,cAAA;ADKF;;ACFA;;EAEE,gBAAA;ADKF;;ACFA;;EAEE,YAAA;ADKF;;ACFA;;;;EAIE,WAAA;EACA,aAAA;ADKF;;ACFA;EACE,yBAAA;EACA,iBAAA;ADKF;;ACFA;EACE,sBAAA;ADKF;ACHE;EAEE,sBAAA;ADIJ;;ACAA;EACE,cAAA;EACA,qBAAA;EACA,eAAA;ADGF;;ACAA;EACE,eAAA;ADGF;;AEjIA,mBAAA;AAQA,mBAAA;ACzBA;EAEE,yBAAA;EACA,kCAAA;EACA,mCAAA;AHsJF;AGpJE;EANF;IAOI,gBAAA;EHuJF;AACF;AGrJE;EAVF;IAWI,yBAAA;EHwJF;AACF;;AGrJA;EACE,iCAAA;AHwJF;;AGtJA;EACE,gCAAA;EACE,eDLU;ECMV,cDrBS;AF8Kb;;AGrJE;EAEE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AHuJJ;;AGpJE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;AHuJJ;AGrJI;EARF;IASI,cAAA;EHwJJ;AACF;;AGnJI;EACE,aAAA;AHsJN;;AGlJE;EACE,eAAA;AHqJJ;;AI9MA;EAKI,gBAAA;AJ6MJ;AI3MI;EAPJ;IAQQ,aAAA;EJ8MN;AACF;;AKvNA;EACE,WAAA;EACA,0BAAA;AL0NF;AKxNE;EACE,WAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AL0NJ;AKvNE;EACE,WAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,iBAAA;ALyNJ;AKtNE;EACE,aAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;ALwNJ;AKtNI;EACE,aAAA;ALwNN;AKpNM;EACE,8BAAA;ALsNR;AKlNI;EACE,gBAAA;ALoNN;AKlNM;EACE,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;ALoNR;AKlNQ;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;ALoNV;AKhNM;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;ALkNR;AKhNM;EACE,gBAAA;EACA,iBAAA;ALkNR;;AMtRA;EACE,WAAA;EACA,YAAA;EACA,yBJYY;EIXZ,gCAAA;EACA,aAAA;ANyRF;AMvRE;EAPF;IAQI,YJkBY;IIjBZ,aAAA;IACA,+BAAA;IACA,mBAAA;IACA,aAAA;EN0RF;AACF;AMxRE;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,gCAAA;EACA,kBAAA;AN0RJ;AMxRI;EAPF;IAQI,oBAAA;IACA,gBAAA;EN2RJ;AACF;AMxRE;EACE,cJfa;EIgBb,eAAA;EACA,gBAAA;AN0RJ;AMxRI;EALF;IAMI,eAAA;EN2RJ;AACF;AMxRE;EACE,gBAAA;AN0RJ;AMxRI;EAHF;IAII,gBAAA;EN2RJ;AACF;AMxRE;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;EACA,QAAA;AN0RJ;AMxRI;EARF;IASI,sBAAA;IACA,QAAA;EN2RJ;AACF;AMxRE;EACE,SAAA;EACA,eAAA;EACA,SAAA;AN0RJ;AMxRI;EALF;IAMI,UAAA;IACA,kBAAA;EN2RJ;AACF;AMxRM;EACE,yBJpEQ;EIqER,cJ1DM;AFoVd;AMxRQ;EACE,eJ7DI;EI8DJ,eAAA;AN0RV;AMvRQ;EACE,yBJ5EW;AFqWrB;AMnRE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,aAAA;EACA,cJlFa;EImFb,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;ANqRJ;AMnRI;EAbF;IAcI,mBAAA;IACA,2BAAA;IACA,SAAA;IACA,kBAAA;IACA,gBAAA;ENsRJ;AACF;AMpRI;EACE,yBJpGU;EIqGV,cJhGW;AFsXjB;AMpRM;EACE,eJnGS;AFyXjB;AMlRI;EACE,eAAA;ANoRN;AMlRM;EAHF;IAII,eAAA;ENqRN;AACF;AMjRE;EACE,eJnHa;EIoHb,uBAAA;EACA,cAAA;ANmRJ;AM/QE;EACE,kBAAA;ANiRJ;AM/QI;EAHF;IAII,mBAAA;ENkRJ;AACF;AM/QE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,kBAAA;EACA,yBJ1IY;EI2IZ,YAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,cJ3Ia;EI4Ib,eAAA;ANiRJ;AM/QI;EAdF;IAeI,kBAAA;IACA,eAAA;ENkRJ;AACF;AMhRI;EACE,yBJvJW;EIwJX,cJpJW;AFsajB;AM/QI;EACE,yBJ5JW;EI6JX,cJzJW;AF0ajB;AM9QI;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,cAAA;ANgRN;AM5QE;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AN8QJ;AM5QI;EARF;IASI,eAAA;IACA,QAAA;EN+QJ;AACF;AM7QI;EACE,gBAAA;AN+QN;AM5QI;EACE,kBAAA;EACA,eAAA;AN8QN;AM5QM;EAJF;IAKI,4BAAA;EN+QN;AACF;;AOtdA;EACE,iBAAA;EACA,yBLKc;EKJd,kBAAA;APydF;AOvdE;EALF;IAMI,UAAA;EP0dF;AACF;AOxdE;EACE,gBAAA;EACA,cAAA;EACA,yBLCU;EKAV,mBAAA;EACA,0CAAA;EACA,aAAA;AP0dJ;AOxdI;EARF;IASI,gBAAA;EP2dJ;AACF;AOxdE;EACE,mBAAA;EACA,kBAAA;AP0dJ;AOxdI;EACE,eAAA;EACA,gBAAA;EACA,cLjBW;EKkBX,0BAAA;AP0dN;AOxdM;EANF;IAOI,eAAA;EP2dN;AACF;AOxdI;EACE,eAAA;EACA,eAAA;EACA,cL9BW;AFwfjB;AOvdI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;APydN;AOrdE;EACE,iBAAA;EACA,yBLrDY;EKsDZ,cL3CU;EK4CV,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;EACA,mBAAA;APudJ;AOrdI;EACE,yBL/De;AFshBrB;AOpdI;EACE,YAAA;EACA,mBAAA;APsdN;AOldE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;APodJ;AOjdE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;APmdJ;AOjdI;EACE,kBAAA;EACA,YAAA;APmdN;AOjdM;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;APmdR;AOhdM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;APkdR;AO/cM;EACE,kBAAA;EACA,QAAA;EACA,2CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;APidR;AO9cM;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBLpHQ;EKqHR,kBAAA;EACA,kCAAA;APgdR;AO5cI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBLtHQ;EKuHR,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,cLhIW;AF8kBjB;AO5cM;EACE,yBLtIQ;AFolBhB;AO1cI;EClJF,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,2CAAA;EACA,cNMY;EMLZ,yBNJc;EMKd,iCAAA;AR+lBF;AQ7lBE;EACE,yBNPiB;AFsmBrB;AQ5lBE;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,mBNfY;AF6mBhB;AQ3lBE;EACE,yBNda;EMeb,mBAAA;AR6lBJ;AO9dI;EACE,aAAA;EACA,0BAAA;EACA,SAAA;APgeN;AO9dM;EALF;IAMI,qCAAA;EPieN;AACF;AO/dM;EATF;IAUI,qCAAA;EPkeN;AACF;AO/dI;EAEE,gBAAA;APgeN;AO9dM;EACE,iBAAA;APgeR;AOrdM;EADF;IAEI,gBAAA;EPwdN;AACF;AOtdM;EALF;IAMI,iBAAA;EPydN;AACF;AOtdI;EACE,eAAA;EACA,gBAAA;EACA,cLvLW;EKwLX,kBAAA;EACA,cAAA;APwdN;AOrdI;EACE,eAAA;EACA,cL5LW;AFmpBjB;AOpdI;EACE,WAAA;EACA,iBAAA;EACA,yBLjMQ;EKkMR,yBAAA;EACA,kBAAA;EACA,2CAAA;APsdN;AOpdM;EACE,aAAA;EACA,qBLnNQ;EKoNR,SAAA;EACA,mBLrNQ;AF2qBhB;AOldI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;APodN;AOjdI;EACE,mBAAA;APmdN;AOjdM;EACE,aAAA;EACA,uCAAA;EACA,SAAA;EACA,kBAAA;APmdR;AO9cM;EACE,iBAAA;APgdR;AOzcE;EACE,gBAAA;AP2cJ;AOvcI;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;APycN;AOtcI;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;APwcN;AOtcM;EACE,yBLtQQ;AF8sBhB;AOpcI;EACE,aAAA;EACA,6BAAA;APscN;AOncI;EACE,mBAAA;APqcN;AOncM;EACE,gBAAA;APqcR;AOjcI;EACE,cAAA;EACA,gCAAA;APmcN;AOjcM;EACE,mBAAA;APmcR;AO/bI;EACE,eAAA;EACA,cL/RW;AFguBjB;AO7bE;EACE,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;AP+bJ;AO5bI;ECrTF,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,2CAAA;EACA,cNMY;EMLZ,yBNJc;EMKd,iCAAA;ARovBF;AQlvBE;EACE,yBNPiB;AF2vBrB;AQjvBE;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,mBNfY;AFkwBhB;AQhvBE;EACE,yBNda;EMeb,mBAAA;ARkvBJ;AOndI;ECxTF,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,2CAAA;EACA,cNMY;EMLZ,yBNJc;EMKd,iCAAA;EDgTI,kBAAA;EACA,mBAAA;AP+dN;AQ9wBE;EACE,yBNPiB;AFuxBrB;AQ7wBE;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,mBNfY;AF8xBhB;AQ5wBE;EACE,yBNda;EMeb,mBAAA;AR8wBJ;AO1eI;EC7TF,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,2CAAA;EACA,cNMY;EMLZ,yBNNc;EMOd,iCAAA;AR0yBF;AQxyBE;EACE,yBNTiB;AFmzBrB;AQvyBE;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,mBNjBY;AF0zBhB;AQtyBE;EACE,yBNda;EMeb,mBAAA;ARwyBJ;AOhgBI;EACE,iBAAA;EACA,yBL1TW;EK2TX,cLxTW;EKyTX,kBAAA;EACA,eAAA;EACA,eAAA;APkgBN;AOhgBM;EACE,yBLhUS;AFk0BjB;AO7fE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AP+fJ;AO7fI;EACE,mBAAA;AP+fN;;AO1fA;EACE;IACE,uBAAA;EP6fF;EO3fA;IACE,yBAAA;EP6fF;AACF;ASr1BE;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;ATu1BJ;ASr1BI;EALF;IAMI,aAAA;ETw1BJ;AACF;ASt1BI;EATF;IAUI,aAAA;ETy1BJ;AACF;ASt1BE;EACE,gBAAA;EACA,cAAA;EACA,yBAzBU;EA0BV,aAAA;EACA,kBAAA;EACA,+CAAA;ATw1BJ;ASt1BI;EARF;IASI,aAAA;ETy1BJ;AACF;ASt1BE;EACE,yBAlCY;EAmCZ,mBAAA;EACA,aAAA;EACA,yBAAA;ATw1BJ;ASt1BI;EANF;IAOI,aAAA;ETy1BJ;AACF;ASt1BE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;EACA,mBAAA;EACA,gCAAA;ATw1BJ;ASt1BI;EATF;IAUI,mBAAA;IACA,oBAAA;IACA,mBAAA;ETy1BJ;AACF;ASv1BI;EACE,eAAA;EACA,gBAAA;EACA,cA/DW;EAgEX,kBAAA;EACA,kBAAA;EACA,WAAA;ATy1BN;ASv1BM;EARF;IASI,eAAA;IACA,gBAAA;IACA,gBAAA;ET01BN;AACF;ASt1BE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;ATw1BJ;ASt1BI;EANF;IAOI,mBAAA;IACA,SAAA;IACA,mBAAA;ETy1BJ;AACF;ASt1BE;EACE,WAAA;EACA,aAAA;EACA,uBAAA;ATw1BJ;ASt1BI;EALF;IAMI,cAAA;IACA,2BAAA;ETy1BJ;AACF;ASv1BI;EACE,YAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;ATy1BN;ASv1BM;EAPF;IAQI,YAAA;IACA,aAAA;ET01BN;AACF;ASt1BE;EACE,WAAA;EACA,kBAAA;ATw1BJ;ASt1BI;EAJF;IAKI,cAAA;IACA,gBAAA;ETy1BJ;AACF;ASv1BI;EACE,mBAAA;ATy1BN;ASv1BM;EAHF;IAII,mBAAA;ET01BN;AACF;ASv1BI;EACE,cAAA;EACA,eAAA;EACA,cAlIW;AT29BjB;ASv1BM;EALF;IAMI,eAAA;ET01BN;AACF;ASv1BI;EACE,eAAA;EACA,gBAAA;EACA,cA3IW;EA4IX,0BAAA;ATy1BN;ASv1BM;EANF;IAOI,eAAA;ET01BN;AACF;ASt1BE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,6BAAA;ATw1BJ;ASt1BI;EARF;IASI,mBAAA;ETy1BJ;AACF;ASv1BI;EACE,eAAA;EACA,cAnKW;EAoKX,mBAAA;EACA,kBAAA;EACA,WAAA;ATy1BN;ASv1BM;EAPF;IAQI,eAAA;IACA,gBAAA;IACA,gBAAA;ET01BN;AACF;ASv1BI;EACE,aAAA;EACA,uBAAA;EACA,WAAA;ATy1BN;ASv1BM;EALF;IAMI,yBAAA;ET01BN;AACF;ASx1BM;EACE,WAAA;EACA,YAAA;AT01BR;;AUzhCA;EACQ,WAAA;EACJ,aAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;AV4hCJ;;AUxhCI;EACE,WAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;AV2hCN;AUxhCI;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;AV0hCN;AUxhCM;EACE,YAAA;EACA,iBAAA;EACA,iBAAA;AV0hCR;AUvhCM;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AVyhCR;AUthCM;EACE,YAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;AVwhCR;AUthCQ;EACE,yBAAA;EACA,kBAAA;AVwhCV;AUnhCI;EACE,mBAAA;AVqhCN;AUnhCM;EACE,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;AVqhCR;AUjhCI;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;AVmhCN;AUhhCI;EACE,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,wCAAA;AVkhCN;AUhhCM;EACE,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,6BAAA;AVkhCR;AU9gCI;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AVghCN;AU7gCI;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AV+gCN;AU5gCI;EACE,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;AV8gCN;AU5gCM;EACE,yBAAA;AV8gCR;AU3gCM;EACE,yBAAA;EACA,mBAAA;AV6gCR;AUzgCI;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,gBAAA;AV2gCN;AUzgCM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AV2gCR;AUtgCM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;AVwgCR;;AW1oCA;EACI,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,wCAAA;AX6oCJ;;AW1oCE;EACE,mBAAA;EACA,WAAA;EACA,kBAAA;AX6oCJ;;AW1oCE;EACE,aAAA;EACA,SAAA;AX6oCJ;;AW1oCE;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,gCAAA;AX6oCJ;;AW1oCE;EACE,cAAA;EACA,iBAAA;AX6oCJ;;AW1oCE;EACE,cAAA;EACA,iBAAA;AX6oCJ;;AW1oCE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AX6oCJ;;AW1oCE;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AX6oCJ;;AW1oCE;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AX6oCJ;;AW1oCE;EACE,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;AX6oCJ;;AW1oCE,oCAAA;AAEF;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AX4oCJ;;AWzoCE;EACE,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,yCAAA;EACA,gBAAA;EACA,UAAA;EACA,gCAAA;AX4oCJ;;AWzoCE;EACE,kBAAA;AX4oCJ;;AWzoCE;EACE,yBAAA;AX4oCJ;;AWzoCE;EACE,yBAAA;AX4oCJ;;AWzoCE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;AX4oCJ;;AWzoCE;EACE,mBAAA;EACA,WAAA;EACA,iBAAA;AX4oCJ;;AW1oCE;EACE,qBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;AX6oCJ;;AW1oCE;EACE,qBAAA;EACA,WAAA;EACA,gBAAA;AX6oCJ;;AW1oCE;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,iCAAA;AX6oCJ;;AW1oCE;EACE,yBAAA;AX6oCJ;;AW1oCE;EACE;IACE,4BAAA;IACA,UAAA;EX6oCJ;EW3oCE;IACE,wBAAA;IACA,UAAA;EX6oCJ;AACF;AEhxCA,mBAAA;AAQA,mBAAA;AU1BA;EACE,iBAAA;EACA,yBVKc;EUJd,kBAAA;AZsyCF;AYpyCE;EALF;IAMI,kBAAA;EZuyCF;AACF;AYryCE;EACE,gBAAA;EACA,cAAA;EACA,yBVCU;EUAV,mBAAA;EACA,0CAAA;EACA,aAAA;AZuyCJ;AYryCI;EARF;IASI,kBAAA;IACA,kBAAA;EZwyCJ;AACF;AYryCE;EACE,mBAAA;EACA,kBAAA;AZuyCJ;AYryCI;EACE,eAAA;EACA,gBAAA;EACA,cVlBW;EUmBX,mBAAA;AZuyCN;AYryCM;EANF;IAOI,eAAA;EZwyCN;AACF;AYryCI;EACE,eAAA;EACA,cV9BW;EU+BX,gBAAA;EACA,mBAAA;AZuyCN;AYryCM;EANF;IAOI,eAAA;EZwyCN;AACF;AYryCI;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AZuyCN;AYryCM;EACE,cAAA;EACA,0BAAA;EACA,gBAAA;AZuyCR;AYpyCM;EACE,gBAAA;AZsyCR;AYjyCE;EACE,kBAAA;EACA,eAAA;AZmyCJ;AYjyCI;EACE,eAAA;EACA,gBAAA;EACA,cVlEW;EUmEX,mBAAA;AZmyCN;AY/xCE;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;AZiyCJ;AY/xCI;EANF;IAOI,sBAAA;EZkyCJ;AACF;AY/xCE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cVrFU;EUsFV,yBVjGY;EUkGZ,YAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AZiyCJ;AY/xCI;EACE,yBVxGe;EUyGf,2BAAA;EACA,yCAAA;AZiyCN;AY9xCI;EACE,wBAAA;AZgyCN;AY7xCI;EAtBF;IAuBI,WAAA;IACA,gBAAA;EZgyCJ;AACF;AY7xCE;EACE,mBAAA;AZ+xCJ;AY5xCE;EACE,gBAAA;EACA,YAAA;EACA,cV/HY;EUgIZ,eAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,2BAAA;AZ8xCJ;AY5xCI;EACE,cVtIe;EUuIf,0BAAA;AZ8xCN;AY1xCE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AZ4xCJ;AYzxCE;EACE,kBAAA;EACA,oBAAA;EACA,gCAAA;AZ2xCJ;AYzxCI;EACE,mBAAA;EACA,gBAAA;AZ2xCN;AYvxCE;EACE,eAAA;EACA,gBAAA;EACA,cVtJa;EUuJb,kBAAA;AZyxCJ;AYtxCE;EACE,eAAA;EACA,cV9Ja;EU+Jb,gBAAA;EACA,eAAA;AZwxCJ;AYrxCE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AZuxCJ;AYrxCI;EACE,iBAAA;AZuxCN;AYnxCE;EACE,eAAA;EACA,gBAAA;EACA,cV/Ka;EUgLb,cAAA;AZqxCJ;AYnxCI;EACE,cVxLS;EUyLT,gBAAA;AZqxCN;AYjxCE;EACE,eAAA;EACA,cV3La;EU4Lb,kBAAA;EACA,eAAA;EACA,gBAAA;AZmxCJ;AYhxCE;EACE,WAAA;EACA,kBAAA;EACA,yBVjMU;EUkMV,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,cVtMa;EUuMb,kCAAA;AZkxCJ;AYhxCI;EACE,aAAA;EACA,qBVrNU;EUsNV,6CAAA;AZkxCN;AY/wCI;EACE,yBVrNU;EUsNV,mBAAA;AZixCN;AY7wCE;EACE,WAAA;EACA,kBAAA;EACA,yBVvNU;EUwNV,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,cV5Na;EU6Nb,oBAAA;EACA,gBAAA;EACA,kCAAA;AZ+wCJ;AY7wCI;EACE,aAAA;EACA,qBV7OU;EU8OV,6CAAA;AZ+wCN;AY3wCE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;AZ6wCJ;AY1wCE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,cVtPa;AFkgDjB;AY1wCI;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,qBVrQU;AFihDhB;AYzwCI;EACE,yBAAA;UAAA,iBAAA;AZ2wCN;AYxwCI;EACE,cVnQW;AF6gDjB;AYtwCE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,yBVlRY;EUmRZ,kBAAA;AZwwCJ;AYrwCE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,cVxRa;AF+hDjB;AYrwCI;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,qBVvSU;AF8iDhB;AYpwCI;EACE,yBAAA;UAAA,iBAAA;AZswCN;AYnwCI;EACE,cVrSW;AF0iDjB;AYjwCE;EACE,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,6BAAA;AZmwCJ;AYhwCE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cVpTU;EUqTV,yBVhUY;EUiUZ,YAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AZkwCJ;AYhwCI;EACE,yBVvUe;EUwUf,2BAAA;EACA,yCAAA;AZkwCN;AY/vCI;EACE,wBAAA;AZiwCN;AY9vCI;EACE,YAAA;EACA,mBAAA;AZgwCN;;AEnkDA,mBAAA;AAQA,mBAAA;AW1BA;EACE,iBAAA;EACA,yBXKc;EWJd,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;Ab0lDF;AaxlDE;EARF;IASI,kBAAA;Eb2lDF;AACF;AazlDE;EACE,gBAAA;EACA,WAAA;EACA,yBXFU;EWGV,mBAAA;EACA,0CAAA;EACA,kBAAA;Ab2lDJ;AazlDI;EARF;IASI,kBAAA;IACA,kBAAA;Eb4lDJ;AACF;AazlDE;EACE,kBAAA;EACA,mBAAA;Ab2lDJ;AazlDI;EACE,eAAA;EACA,gBAAA;EACA,cXrBW;EWsBX,mBAAA;Ab2lDN;AazlDM;EANF;IAOI,eAAA;Eb4lDN;AACF;AazlDI;EACE,eAAA;EACA,cXjCW;EWkCX,gBAAA;Ab2lDN;AazlDM;EALF;IAMI,eAAA;Eb4lDN;AACF;AaxlDE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;Ab0lDJ;AavlDE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,yBXnDU;EWoDV,yBAAA;EACA,mBAAA;EACA,wCAAA;AbylDJ;AatlDE;EACE,WAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;AbwlDJ;AarlDE;EACE,aAAA;EACA,cXrEa;EWsEb,eAAA;EACA,kBAAA;AbulDJ;AaplDE;EACE,kBAAA;EACA,WAAA;AbslDJ;AanlDE;EACE,eAAA;EACA,cXhFa;EWiFb,mBAAA;EACA,qBAAA;AbqlDJ;AanlDI;EACE,gBAAA;EACA,cXrFW;AF0qDjB;AajlDE;EACE,cXpGY;EWqGZ,qBAAA;EACA,qBAAA;AbmlDJ;AajlDI;EACE,0BAAA;AbmlDN;Aa/kDE;EACE,eAAA;EACA,cXvGa;EWwGb,kBAAA;EACA,eAAA;AbilDJ;Aa9kDE;EACE,WAAA;EACA,aAAA;EACA,uBAAA;AbglDJ;Aa7kDE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cXnHU;EWoHV,yBX/HY;EWgIZ,YAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;Ab+kDJ;Aa7kDI;EACE,yBXtIe;EWuIf,2BAAA;EACA,yCAAA;Ab+kDN;Aa5kDI;EACE,wBAAA;Ab8kDN;Aa3kDI;EAtBF;IAuBI,WAAA;IACA,gBAAA;Eb8kDJ;AACF;;AcpuDA;EACE,aAAA;EACA,iBAAA;EACA,cAAA;AduuDF;AcruDE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;AduuDJ;AcpuDE;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,SAAA;AdsuDJ;AcnuDE;EACE,WAAA;EACA,kBAAA;AdquDJ;AcluDE;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,iCAAA;AdouDJ;AcluDI;EACE,yBAAA;AdouDN;AchuDE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AdkuDJ;Ac/tDE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AdiuDJ;Ac/tDI;EACE,gBAAA;EACA,WAAA;AdiuDN;Ac9tDI;;EAEE,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AdguDN;Ac5tDE;EACE,yBAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;Ad8tDJ;Ac3tDE;EACE,kBAAA;EACA,aAAA;EACA,WAAA;Ad6tDJ;Ac1tDE;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;Ad4tDJ;AcztDE;EACE,aAAA;EACA,WAAA;Ad2tDJ;AcxtDE;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,wCAAA;Ad0tDJ;AcvtDE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;AdytDJ;AcvtDI;EACE,SAAA;EACA,kBAAA;EACA,WAAA;AdytDN;AcrtDE;EACE,wBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AdutDJ;AcrtDI;EACE,yBAAA;EACA,cAAA;AdutDN;AcptDI;EACE,yBAAA;EACA,cAAA;AdstDN;AcltDE;EACE,aAAA;EACA,WAAA;AdotDJ;AcjtDE;EACE,oBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;AdmtDJ;AcjtDI;EACE,yBAAA;EACA,YAAA;AdmtDN;AcjtDM;EACE,yBAAA;AdmtDR;Ac/sDI;EACE,yBAAA;EACA,YAAA;AditDN;Ac/sDM;EACE,yBAAA;AditDR;Ac7sDI;EACE,yBAAA;EACA,YAAA;Ad+sDN;Ac7sDM;EACE,yBAAA;Ad+sDR;AczsDI;EACE,kBAAA;EACA,eAAA;EACA,WAAA;Ad2sDN;AcxsDI;EACE,gBAAA;EACA,UAAA;EACA,gBAAA;Ad0sDN;AcxsDM;EACE,iBAAA;EACA,gCAAA;EACA,WAAA;Ad0sDR;AcrsDE;EACE,gBAAA;EACA,gBAAA;EACA,WAAA;AdusDJ;AcpsDE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AdssDJ;AcnsDE;EACE,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,0CAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;AdqsDJ;AcnsDI;EACE,gBAAA;AdqsDN;AclsDI;EACE,kBAAA;EACA,iBAAA;EACA,WAAA;AdosDN;AcjsDI;EACE,cAAA;EACA,mBAAA;AdmsDN;AcjsDM;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,WAAA;AdmsDR;AchsDM;;EAEE,WAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AdksDR;Ac7rDE;EACE,gBAAA;Ad+rDJ;Ac5rDE;EACE,aAAA;EACA,WAAA;EACA,qBAAA;Ad8rDJ;Ac5rDI;EACE,SAAA;Ad8rDN;Ac1rDE;EAEE,oBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;Ad2rDJ;AczrDI;EACE,yBAAA;Ad2rDN;AcvrDE;EACE,kBAAA;EACA,cAAA;EACA,qBAAA;AdyrDJ;ActrDE;EACE,cAAA;EACA,qBAAA;AdwrDJ;AcrrDE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;AdurDJ;AcrrDI;EACE,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,oBAAA;AdurDN;AcrrDM;EACE,yBAAA;EACA,YAAA;AdurDR;AcrrDQ;EACE,yBAAA;AdurDV;AcnrDM;EACE,yBAAA;EACA,YAAA;AdqrDR;AcnrDQ;EACE,yBAAA;AdqrDV;AclrDQ;EACE,YAAA;EACA,mBAAA;AdorDV;Ac9qDE;EACE,kBAAA;AdgrDJ;Ac7qDE;EACE,mBAAA;Ad+qDJ;Ac7qDI;EACE,gBAAA;EACA,mBAAA;EACA,WAAA;Ad+qDN;Ac5qDI;EACE,gBAAA;EACA,UAAA;EACA,gBAAA;Ad8qDN;Ac5qDM;EACE,iBAAA;EACA,gCAAA;Ad8qDR;AcxqDI;EACE,WAAA;EACA,yBAAA;EACA,gBAAA;Ad0qDN;AcxqDM;;EAEE,gBAAA;EACA,gBAAA;EACA,gCAAA;Ad0qDR;AcvqDM;EACE,yBAAA;EACA,gBAAA;EACA,WAAA;AdyqDR;ActqDM;EACE,WAAA;AdwqDR;;AcjqDA;EACE,iBAAA;EACA,6DAAA;EACA,kBAAA;AdoqDF;AclqDE;EACE,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,yCAAA;EACA,aAAA;AdoqDJ;AcjqDE;EACE,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gCAAA;AdmqDJ;AchqDE;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AdkqDJ;Ac/pDE;EACE,WAAA;EACA,mBAAA;EACA,SAAA;AdiqDJ;Ac9pDE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AdgqDJ;Ac7pDE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;Ad+pDJ;Ac7pDI;EACE,gBAAA;EACA,WAAA;Ad+pDN;Ac5pDI;;EAEE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;Ad8pDN;Ac5pDM;;EACE,aAAA;EACA,qBAAA;Ad+pDR;Ac1pDE;EACE,mBAAA;Ad4pDJ;AczpDE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;Ad2pDJ;AczpDI;EACE,gBAAA;EACA,WAAA;Ad2pDN;AcxpDI;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;Ad0pDN;AcxpDM;EACE,aAAA;EACA,qBAAA;Ad0pDR;AcvpDM;EACE,yBAAA;EACA,mBAAA;AdypDR;AcppDE;EACE,yBAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;AdspDJ;AcnpDE;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;AdqpDJ;AclpDE;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;AdopDJ;AcjpDE;EACE,gBAAA;AdmpDJ;AchpDE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;AdkpDJ;AchpDI;EACE,SAAA;EACA,iBAAA;EACA,WAAA;AdkpDN;Ac9oDE;EACE,WAAA;EACA,mBAAA;AdgpDJ;Ac7oDE;EACE,yBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;Ad+oDJ;Ac7oDI;EACE,gBAAA;EACA,mBAAA;Ad+oDN;Ac7oDM;EACE,cAAA;Ad+oDR;Ac1oDE;EACE,mBAAA;Ad4oDJ;AczoDE;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;Ad2oDJ;AcxoDE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;Ad0oDJ;AcvoDE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,uBAAA;AdyoDJ;AcvoDI;EACE,qBAAA;EACA,yBAAA;AdyoDN;ActoDI;EACE,qBAAA;EACA,yBAAA;AdwoDN;AcroDI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AduoDN;AcnoDE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AdqoDJ;AcloDE;EACE,mBAAA;EACA,gBAAA;EACA,WAAA;AdooDJ;AcjoDE;EACE,mBAAA;EACA,WAAA;AdmoDJ;AchoDE;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;AdkoDJ;AchoDI;EACE,yBAAA;AdkoDN;Ac/nDI;EACE,YAAA;EACA,mBAAA;AdioDN;Ac7nDE;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;Ad+nDJ;Ac7nDI;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;Ad+nDN;Ac3nDE;EACE,aAAA;EACA,SAAA;Ad6nDJ;Ac1nDE;EACE,mBAAA;Ad4nDJ;AcznDE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;Ad2nDJ;AcxnDE;EACE,gBAAA;EACA,WAAA;Ad0nDJ;AcvnDE;EACE,mBAAA;EACA,WAAA;AdynDJ;ActnDE;EACE,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AdwnDJ;AcrnDE;EACE,YAAA;EACA,4DAAA;EACA,2BAAA;AdunDJ;;AclnDA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,gCAAA;AdqnDF;;AclnDA;EACE,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,oCAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,oBAAA;AdqnDF;AcnnDE;EACE,cAAA;AdqnDJ;AclnDE;EACE,cAAA;EACA,4BAAA;AdonDJ;;Ae3zEA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBbCc;EaAd,aAAA;Af8zEF;Ae5zEE;EACE,WAAA;EACA,gBAAA;EACA,yBbCU;EaAV,kBAAA;EACA,6CAAA;Af8zEJ;Ae3zEE;EACE,kBAAA;EACA,kBAAA;EACA,gCAAA;Af6zEJ;Ae3zEI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cbxBU;AFq1EhB;Ae1zEI;EACE,eAAA;EACA,gBAAA;EACA,cbpBW;EaqBX,kBAAA;Af4zEN;AezzEI;EACE,eAAA;EACA,cb5BW;AFu1EjB;AevzEE;EACE,aAAA;AfyzEJ;AevzEI;EACE,mBAAA;AfyzEN;AetzEI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cb1CW;Ea2CX,kBAAA;AfwzEN;AerzEI;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBblDQ;EamDR,oBAAA;AfuzEN;AerzEM;ECnEJ,aAAA;EACA,qBdEc;EcDd,6CAAA;AhB23EF;AetzEM;EACE,cb7DS;AFq3EjB;AerzEM;EACE,qBbrEO;EasEP,uCAAA;AfuzER;AenzEI;EACE,cb3ES;Ea4ET,eAAA;EACA,eAAA;AfqzEN;AelzEI;EACE,cAAA;EACA,iBAAA;EACA,eAAA;EACA,cbxFU;EayFV,qBAAA;EACA,mBAAA;AfozEN;AelzEM;EACE,0BAAA;AfozER;AehzEI;EACE,WAAA;EACA,aAAA;EACA,yBbpGU;EaqGV,cb1FQ;Ea2FR,eAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iCAAA;AfkzEN;AehzEM;EACE,yBb7Ga;AF+5ErB;Ae/yEM;EACE,yBb3GS;Ea4GT,mBAAA;AfizER;Ae5yEE;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;Af8yEJ;Ae5yEI;EACE,sCAAA;EACA,cb5HS;AF06Ef;Ae3yEI;EACE,yCAAA;EACA,cbnIU;AFg7EhB;;AiBt7EA;EACE,aAAA;AjBy7EF;AiBx7EE;EAFF;IAGI,eAAA;EjB27EF;AACF;AiBz7EE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AjB27EJ;AiBx7EE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AjB07EJ;AiBv7EE;EACE,eAAA;EACA,eAAA;EACA,cAAA;AjBy7EJ;AiBt7EE;EACE,mBAAA;EACA,kBAAA;EACA,yCAAA;EACA,yCAAA;EACA,kBAAA;EACA,cAAA;AjBw7EJ;AiBt7EE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AjBw7EJ;AiBt7EI;EACE,cfjCU;AFy9EhB;AiBp7EE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AjBs7EJ;AiBn7EE;EACE,WAAA;EACA,aAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AjBq7EJ;AiBn7EE;EACE,aAAA;EACA,sDAAA;EACA,eAAA;AjBq7EJ;AiBl7EE;EACE,SAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,0CAAA;AjBo7EJ;AiBl7EI;EACE,aAAA;EACA,qBAAA;EACA,8CAAA;AjBo7EN;AiBh7EE;EACE,0BAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,0CAAA;AjBk7EJ;AiBh7EI;EACE,aAAA;EACA,qBAAA;EACA,8CAAA;AjBk7EN;AiB96EE;EACE,iBAAA;EACA,yBf/FY;EegGZ,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,8CAAA;AjBg7EJ;AiB96EI;EACE,mEAAA;AjBg7EN;AiB56EE;EACE,uBAAA;EACA,kBAAA;EACA,wCAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;AjB86EJ;AiB36EE;EACE,WAAA;EACA,yBAAA;AjB66EJ;AiB36EI;EACE,aAAA;EACA,gBAAA;EACA,gCAAA;AjB66EN;AiB16EI;EACE,yBAAA;EACA,gBAAA;EACA,cAAA;AjB46EN;AiBz6EI;EACE,yBAAA;AjB26EN;AiBv6EE;EACE,aAAA;EACA,kBAAA;EACA,cAAA;AjBy6EJ;AiBt6EE;EACE,kBAAA;AjBw6EJ;AiBr6EE;EACE,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,mCAAA;AjBu6EJ;AiBr6EI;EACE,cAAA;AjBu6EN;AiBn6EE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,6CAAA;EACA,WAAA;AjBq6EJ;AiBl6EE;EACE,cAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;EACA,8CAAA;AjBo6EJ;AiBl6EI;EACE,yBAAA;EACA,cAAA;AjBo6EN;AiBj6EI;EACE,gCAAA;AjBm6EN;AiB/5EE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,6BAAA;EACA,yBAAA;EACA,0BAAA;AjBi6EJ;AiB95EE;EACE,iBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,iCAAA;AjBg6EJ;AiB95EI;EACE,yBAAA;EACA,qBAAA;EACA,cAAA;AjBg6EN;AiB75EI;EACE,aAAA;EACA,8CAAA;AjB+5EN;AiB55EI;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AjB85EN;AiB35EI;EACE,iBAAA;AjB65EN;AiBz5EE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;AjB25EJ;AiBx5EE;EACE,eAAA;EACA,cAAA;AjB05EJ;AiBv5EE;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AjBy5EJ;AiBt5EM;EACE,cAAA;EACA,gBAAA;AjBw5ER;;AiBl5EA;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,6BAAA;EACA,mBAAA;AjBq5EF;AiBn5EE;EACE,0CAAA;EACA,cAAA;EACA,qCAAA;AjBq5EJ;AiBl5EE;EACE,yCAAA;EACA,cAAA;EACA,oCAAA;AjBo5EJ;;AiBh5EA;EACE,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yCAAA;AjBm5EF;AiBj5EE;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AjBm5EJ;AiBh5EE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;AjBk5EJ;AiBh5EI;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,0CAAA;AjBk5EN;AiBh5EM;EACE,aAAA;EACA,qBAAA;EACA,8CAAA;AjBk5ER;AiB74EE;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AjB+4EJ;AiB54EE;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AjB84EJ;AiB34EE;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,qBAAA;AjB64EJ;AiB14EE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AjB44EJ;AiB14EI;EACE,cAAA;AjB44EN;AiBz4EI;EACE,cAAA;AjB24EN;;AiBt4EA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;AjBy4EF;AiBv4EE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AjBy4EJ;AiBt4EE;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,qBAAA;AjBw4EJ;AiBr4EE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AjBu4EJ;AiBr4EI;EACE,cAAA;AjBu4EN;AiBp4EI;EACE,cAAA;AjBs4EN;;AiBj4EA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;AjBo4EF;AiBl4EE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AjBo4EJ;AiBj4EE;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AjBm4EJ;AiBh4EE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;AjBk4EJ;AiBh4EI;EACE,0CAAA;EACA,qCAAA;AjBk4EN;AiB/3EI;EACE,0CAAA;EACA,qCAAA;AjBi4EN;AiB73EE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,sBAAA;EACA,8BAAA;AjB+3EJ;AiB53EE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AjB83EJ;AiB33EE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AjB63EJ;;AiBz3EA;EACE,gBAAA;AjB43EF;;AiBz3EA;EACE,iBAAA;EACA,gBAAA;AjB43EF;AiB13EE;EACE,SAAA;EACA,cAAA;AjB43EJ;AiBz3EE;EACE,WAAA;EACA,yBAAA;AjB23EJ;AiBz3EI;;EAEE,iBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;AjB23EN;AiBx3EI;EACE,yBAAA;EACA,gBAAA;EACA,cAAA;AjB03EN;AiBv3EI;EACE,yBAAA;AjBy3EN;;AiBp3EA;EACE,WAAA;AjBu3EF;;AiBp3EA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AjBu3EF;AiBr3EE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AjBu3EJ;AiBp3EE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AjBs3EJ;AiBn3EE;EACE,eAAA;EACA,cAAA;EACA,eAAA;AjBq3EJ;AiBl3EE;EACE,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,yCAAA;EACA,cAAA;AjBo3EJ;AiBj3EE;EACE,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AjBm3EJ;AiBh3EE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;AjBk3EJ;AiBh3EI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AjBk3EN;AiB/2EI;EACE,eAAA;EACA,eAAA;EACA,cAAA;AjBi3EN;AiB72EE;EACE,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,uCAAA;AjB+2EJ;AiB72EI;EACE,yBAAA;AjB+2EN;AiB52EI;EACE,YAAA;EACA,mBAAA;AjB82EN;AiB12EE;EACE,aAAA;EACA,mBAAA;EACA,yCAAA;EACA,wCAAA;EACA,cAAA;EACA,eAAA;AjB42EJ;AiBz2EE;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AjB22EJ;AiBx2EE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AjB02EJ;AiBx2EI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AjB02EN;AiBt2EE;EACE,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AjBw2EJ;AiBr2EE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;AjBu2EJ;AiBp2EE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;AjBs2EJ;AiBp2EI;EACE,eAAA;EACA,gBAAA;EACA,SAAA;AjBs2EN;AiBl2EE;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AjBo2EJ;AiBj2EE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,6DAAA;EACA,6CAAA;EACA,eAAA;EACA,6EAAA;AjBm2EJ;AiBj2EI;EACE,2BAAA;EACA,8CAAA;EACA,qBfvqBU;AF0gGhB;AiBh2EI;EACE,qBf3qBU;Ee4qBV,gDAAA;EACA,wFAAA;AjBk2EN;AiB31EI;EACE,sCAAA;AjB61EN;AiB11EI;EACE,sCAAA;AjB41EN;AiBz1EI;EACE,oCAAA;EACA,wFAAA;AjB21EN;AiBv1EE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,QAAA;AjBy1EJ;AiBt1EE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AjBw1EJ;AiBr1EE;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AjBu1EJ;AiBr1EI;EACE,yCAAA;AjBu1EN;AiBn1EE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;AjBq1EJ;AiBl1EE;EACE,eAAA;EACA,cAAA;AjBo1EJ;AiBj1EE;EACE,aAAA;EACA,0DAAA;EACA,SAAA;AjBm1EJ;AiBj1EI;EALF;IAMI,0BAAA;EjBo1EJ;AACF;AiBj1EE;EACE,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AjBm1EJ;AiBh1EE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;AjBk1EJ;AiBh1EI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AjBk1EN;AiB/0EI;EACE,eAAA;EACA,cAAA;AjBi1EN;AiB70EE;EAEE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;AjB80EJ;AiB30EE;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AjB60EJ;AiB10EE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AjB40EJ;AiB10EI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AjB40EN;AiBz0EI;EACE,eAAA;EACA,eAAA;EACA,cAAA;AjB20EN;AiBv0EE;EACE,aAAA;EACA,SAAA;AjBy0EJ;AiBv0EI;EACE,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;AjBy0EN;AiBt0EI;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBf70BU;Ee80BV,WAAA;EACA,gBAAA;EACA,eAAA;AjBw0EN;AiBt0EM;EACE,YAAA;EACA,mBAAA;AjBw0ER;AiBn0EE;EACE,kBAAA;EACA,kBAAA;EACA,wCAAA;EACA,wCAAA;EACA,cAAA;EACA,eAAA;AjBq0EJ;AiBl0EE;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AjBo0EJ;AiBl0EI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AjBo0EN;AiBl0EM;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AjBo0ER;AiBl0EQ;EACE,eAAA;EACA,cAAA;AjBo0EV;AiBj0EQ;EACE,eAAA;EACA,cAAA;AjBm0EV;AiB/zEM;EACE,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;AjBi0ER;AiB/zEQ;EACE,yBAAA;AjBi0EV;AiB3zEE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AjB6zEJ;AiB1zEE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AjB4zEJ;AiB1zEI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AjB4zEN;AiBzzEI;EACE,SAAA;EACA,eAAA;EACA,cAAA;AjB2zEN;AiBvzEE;EACE,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;AjByzEJ;AiBvzEI;EACE,0CAAA;EACA,cAAA;EACA,yCAAA;AjByzEN;AiBtzEI;EACE,yCAAA;EACA,cAAA;EACA,wCAAA;AjBwzEN;AiBpzEE;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AjBszEJ;AiBnzEE;EACE,aAAA;EACA,uBAAA;EACA,eAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,6CAAA;AjBqzEJ;AiBlzEE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,4IAAA;EAKA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AjBgzEJ;AiB7yEE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AjB+yEJ;AiB5yEE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,QAAA;AjB8yEJ;AiB5yEI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AjB8yEN;AiB1yEE;EACE,gBAAA;EACA,kBAAA;EACA,0CAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;AjB4yEJ;AiBzyEE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;AjB2yEJ;AiBxyEE;EACE,sBAAA;EACA,gBAAA;EACA,wCAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yDAAA;AjB0yEJ;AiBxyEI;EACE,yCAAA;EACA,cAAA;AjB0yEN;AiBtyEE;EACE,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AjBwyEJ;AiBtyEI;EACE,eAAA;EACA,cAAA;AjBwyEN;AiBpyEE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AjBsyEJ;AiBpyEI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AjBsyEN;AiBnyEI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AjBqyEN;AiBlyEI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;AjBoyEN;AiBlyEM;;EAEE,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AjBoyER;AiBjyEM;EACE,gBAAA;AjBmyER;AiB9xEE;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBfpmCY;EeqmCZ,WAAA;EACA,gBAAA;EACA,eAAA;EACA,uCAAA;AjBgyEJ;AiB9xEI;EACE,mEAAA;AjBgyEN;AiB7xEI;EACE,YAAA;EACA,mBAAA;AjB+xEN;;AiBzxEE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AjB4xEJ;AiBzxEE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;AjB2xEJ;AiBzxEI;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AjB2xEN;AiBzxEM;EACE,aAAA;EACA,qBAAA;EACA,8CAAA;AjB2xER;AiBtxEE;EACE,eAAA;EACA,cAAA;AjBwxEJ;;AiBpxEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;AjBuxEF;AiBrxEE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;AjBuxEJ;AiBpxEE;EACE,cAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;AjBsxEJ;AiBnxEE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AjBqxEJ;AiBlxEE;EACE,aAAA;EACA,SAAA;AjBoxEJ;AiBlxEI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,qBAAA;AjBoxEN;AiBhxEE;EACE,eAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;AjBkxEJ;AiB/wEE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AjBixEJ;AiB9wEE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;AjBgxEJ;AiB9wEI;EACE,0CAAA;EACA,cAAA;EACA,yCAAA;AjBgxEN;AiB7wEI;EACE,yCAAA;EACA,cAAA;EACA,wCAAA;AjB+wEN;AiB3wEE;EAGE,eAAA;EACA,cAAA;AjB2wEJ;AiBxwEE;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AjB0wEJ;AiBvwEE;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;AjBywEJ;AiBvwEI;EACE,qBfhwCU;EeiwCV,0CAAA;AjBywEN;AiBrwEE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,4IAAA;EAKA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AjBmwEJ;AiBhwEE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AjBkwEJ;AiB/vEE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AjBiwEJ;AiB/vEI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AjBiwEN;AiB7vEE;EACE,gBAAA;EACA,kBAAA;EACA,0CAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;AjB+vEJ;AiB5vEE;EACE,gBAAA;EACA,kBAAA;EACA,yCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AjB8vEJ;AiB3vEE;EAEE,eAAA;EACA,cAAA;AjB4vEJ;AiBzvEE;EACE,aAAA;EACA,SAAA;EACA,eAAA;AjB2vEJ;AiBxvEE;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBf70CY;Ee80CZ,WAAA;EACA,gBAAA;EACA,eAAA;EACA,uCAAA;AjB0vEJ;AiBxvEI;EACE,mEAAA;AjB0vEN;AiBvvEI;EACE,aAAA;EACA,mBAAA;AjByvEN;AiBtvEI;EACE,yBAAA;AjBwvEN;AiBtvEM;EACE,yBAAA;AjBwvER;AiBnvEE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,uBAAA;EACA,cAAA;AjBqvEJ;AiBnvEI;EACE,eAAA;EACA,cAAA;AjBqvEN;;AiBhvEA;EACE,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AjBmvEF;;AiBhvEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AjBmvEF;AiBjvEE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AjBmvEJ;;AiB/uEA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AjBkvEF;AiBhvEE;EACE,cAAA;AjBkvEJ;;AiB9uEA;;;EAGE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AjBivEF;;AiB9uEA;EACE,wCAAA;EACA,cAAA;EACA,wCAAA;AjBivEF;;AiB9uEA;EACE,yBAAA;EACA,cAAA;AjBivEF;;AiB9uEA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;AjBivEF;;AiB9uEA;EACE,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,yBAAA;EACA,wDAAA;AjBivEF;AiB/uEE;EACE,qCAAA;AjBivEJ;AiB9uEE;EACE,qCAAA;AjBgvEJ;AiB7uEE;EACE,oCAAA;EACA,2CAAA;AjB+uEJ;AiB5uEE;EACE,qBf98CY;Ee+8CZ,+CAAA;EACA,0CAAA;AjB8uEJ;;AiB1uEA;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,QAAA;AjB6uEF;AiB3uEE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AjB6uEJ;AiB1uEE;EACE,eAAA;EACA,cAAA;AjB4uEJ;;AiBxuEA;EACE,eAAA;EACA,cAAA;AjB2uEF;;AiBxuEA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AjB2uEF;;AiBxuEA;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBfv/Cc;Eew/Cd,WAAA;EACA,gBAAA;EACA,eAAA;EACA,uCAAA;AjB2uEF;AiBzuEE;EACE,yBAAA;EACA,mBAAA;AjB2uEJ;AiBxuEE;EACE,mEAAA;AjB0uEJ;;AiBtuEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AjByuEF;AiBvuEE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,eAAA;EACA,SAAA;AjByuEJ;AiBvuEI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AjByuEN;AiBtuEI;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AjBwuEN;AiBpuEE;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;AjBsuEJ;AiBpuEI;EACE,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBf5iDU;Ee6iDV,WAAA;EACA,gBAAA;EACA,eAAA;AjBsuEN;AiBpuEM;EACE,YAAA;EACA,mBAAA;AjBsuER;AiBnuEM;EACE,mEAAA;AjBquER;AiBhuEE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;AjBkuEJ;AiBhuEI;EACE,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;AjBkuEN;AiB9tEE;EACE,aAAA;EACA,mBAAA;EACA,yCAAA;EACA,wCAAA;EACA,cAAA;EACA,eAAA;AjBguEJ;AiB7tEE;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AjB+tEJ;AiB5tEE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AjB8tEJ;AiB5tEI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AjB8tEN;AiB1tEE;EACE,eAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;AjB4tEJ;AiBztEE;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AjB2tEJ;AiBxtEE;EACE,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AjB0tEJ;AiBxtEI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AjB0tEN;AiBttEE;EAEE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AjButEJ;AiBptEE;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AjBstEJ;AiBntEE;EACE,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,yBAAA;AjBqtEJ;AiBltEE;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AjBotEJ;AiBltEI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AjBotEN;AiBhtEE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,0CAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AjBktEJ;AiB/sEE;EACE,eAAA;EACA,cAAA;AjBitEJ;AiB9sEE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;AjBgtEJ;AiB7sEE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AjB+sEJ;AiB5sEE;EACE,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AjB8sEJ;AiB5sEI;EACE,0CAAA;EACA,cAAA;EACA,yCAAA;AjB8sEN;AiB3sEI;EACE,0CAAA;EACA,cAAA;EACA,yCAAA;AjB6sEN;AiB1sEI;EACE,yCAAA;EACA,cAAA;EACA,wCAAA;AjB4sEN;AiBxsEE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AjB0sEJ;AiBvsEE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;AjBysEJ;;AiBrsEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AjBwsEF;AiBtsEE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,eAAA;EACA,SAAA;AjBwsEJ;AiBtsEI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AjBwsEN;AiBrsEI;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AjBusEN;AiBnsEE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AjBqsEJ;AiBnsEI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AjBqsEN;AiBnsEM;;EAEE,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,sBAAA;AjBqsER;AiBjsEI;EACE,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBf3zDU;Ee4zDV,WAAA;EACA,gBAAA;EACA,eAAA;AjBmsEN;AiBjsEM;EACE,YAAA;EACA,mBAAA;AjBmsER;AiB9rEE;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,8BAAA;EACA,qBAAA;AjBgsEJ;AiB7rEE;EACE,aAAA;EACA,SAAA;EACA,eAAA;AjB+rEJ;AiB5rEE;EACE,aAAA;EACA,SAAA;AjB8rEJ;AiB3rEE;EACE,wCAAA;EACA,cAAA;EACA,YAAA;AjB6rEJ;AiB1rEE;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AjB4rEJ;AiBzrEE;EACE,kBAAA;AjB2rEJ;AiBzrEI;EACE,WAAA;EACA,gBAAA;EACA,6HAAA;EAEA,qEAAA;EAEA,wBAAA;EACA,4BAAA;AjByrEN;AiBrrEE;EACE,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AjBurEJ;AiBprEE;EACE,WAAA;EACA,yBAAA;AjBsrEJ;AiBprEI;;EAEE,kBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AjBsrEN;AiBnrEI;EACE,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;AjBqrEN;AiBlrEI;EACE,yBAAA;AjBorEN;AiBhrEE;EAGE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AjBgrEJ;AiB7qEE;EACE,yCAAA;EACA,cAAA;EACA,wCAAA;AjB+qEJ;AiB5qEE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AjB8qEJ;AiB5qEI;EACE,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,eAAA;AjB8qEN;AiB5qEM;EACE,YAAA;EACA,mBAAA;AjB8qER;AiBzqEE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;AjB2qEJ;;AkB7mIA;EACE,aAAA;EACA,iBAAA;EACA,sBAAA;AlBgnIF;AkB9mIE;EALF;IAMI,mBAAA;ElBinIF;AACF;AkB9mIE;EACE,SAAA;EACA,yBhBHY;EgBIZ,aAAA;AlBgnIJ;AkB9mII;EALF;IAMI,aAAA;ElBinIJ;AACF;;AmBhoIA;EACE,+BAAA;EACA,oBAAA;EACA,cAAA;AnBmoIF;AmBjoIE;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,8CAAA;AnBmoIJ;AmBhoIE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AnBkoIJ;AmB/nIE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AnBioIJ;AmB9nIE;EACE,cAAA;EACA,aAAA;AnBgoIJ;;AmB5nIA;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AnB+nIF;AmB7nIE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AnB+nIJ;AmB5nIE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AnB8nIJ;;AmB1nIA;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;AnB6nIF;;AmB1nIA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AnB6nIF;AmB3nIE;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;AnB6nIJ;AmB1nIE;EACE,QAAA;AnB4nIJ;;AmBxnIA;EACE,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;AnB2nIF;AmBznIE;EACE,mBAAA;EACA,cAAA;AnB2nIJ;AmBxnIE;EACE,mBAAA;EACA,cAAA;AnB0nIJ;AmBvnIE;EACE,mBAAA;EACA,cAAA;AnBynIJ;AmBtnIE;EACE,mBAAA;EACA,cAAA;AnBwnIJ;AmBrnIE;EACE,mBAAA;EACA,cAAA;AnBunIJ;AmBpnIE;EACE,mBAAA;EACA,cAAA;AnBsnIJ;AmBnnIE;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;AnBqnIJ;AmBlnIE;EACE,mBAAA;EACA,cAAA;AnBonIJ;AmBjnIE;EACE,mBAAA;EACA,cAAA;AnBmnIJ;AmBhnIE;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;AnBknIJ;;AmB9mIA;EACE,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AnBinIF;AmB/mIE;EACE,YAAA;EACA,mBAAA;AnBinIJ;AmB9mIE;EACE,mBjB5JY;EiB6JZ,WAAA;AnBgnIJ;AmB9mII;EACE,YAAA;AnBgnIN;AmB5mIE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AnB8mIJ;AmB5mII;EACE,mBAAA;AnB8mIN;AmB1mIE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AnB4mIJ;AmB1mII;EACE,mBAAA;AnB4mIN;AmBxmIE;EACE,iBAAA;EACA,eAAA;AnB0mIJ;;AmBrmIA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,aAAA;AnBwmIF;AmBrmIE;EACE,aAAA;AnBumIJ;;AmBnmIA;EACE,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,2CAAA;AnBsmIF;AmBpmIE;EACE,gBAAA;AnBsmIJ;AmBnmIE;EACE,gBAAA;EACA,eAAA;AnBqmIJ;AmBlmIE;EACE,eAAA;EACA,gBAAA;AnBomIJ;AmBjmIE;EACE,mBAAA;AnBmmIJ;AmBjmII;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AnBmmIN;AmB/lIE;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AnBimIJ;AmB9lIE;EACE,aAAA;EACA,yBAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;AnBgmIJ;;AmB3lIE;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AnB8lIJ;AmB3lIE;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;AnB6lIJ;AmB3lII;EACE,kBAAA;EACA,QAAA;AnB6lIN;AmBzlIE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AnB2lIJ;AmBxlIE;EACE,YAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;AnB0lIJ;AmBxlII;EACE,mBAAA;AnB0lIN;AmBtlIE;EACE,eAAA;EACA,cAAA;EACA,eAAA;AnBwlIJ;AmBrlIE;EACE,gBAAA;EACA,eAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AnBulIJ;AmBplIE;EACE,kBAAA;EACA,eAAA;EACA,cAAA;AnBslIJ;AmBnlIE;EACE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,gCAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;AnBqlIJ;AmBnlII;EACE,mBAAA;AnBqlIN;AmBllII;EACE,mBAAA;AnBolIN;AmBjlII;EACE,aAAA;EACA,eAAA;AnBmlIN;AmB/kIE;EACE,gBAAA;EACA,cAAA;AnBilIJ;;AmB5kIA;EACE,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;EACA,sBAAA;AnB+kIF;AmB7kIE;EACE,qBjBvXY;EiBwXZ,8CAAA;AnB+kIJ;AmB5kIE;EACE,gBAAA;EACA,gBAAA;AnB8kIJ;;AmB1kIA;EACE,UAAA;EACA,oBAAA;EACA,wBAAA;AnB6kIF;;AmB1kIA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,UAAA;AnB6kIF;AmB3kIE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;EACA,cAAA;EACA,gBAAA;AnB6kIJ;AmB3kII;EACE,SAAA;EACA,eAAA;AnB6kIN;AmBzkIE;EACE,aAAA;EACA,QAAA;EACA,cAAA;AnB2kIJ;AmBxkIE;EACE,SAAA;EACA,gBAAA;EACA,uBAAA;AnB0kIJ;;AmBrkIA;EACE,aAAA;AnBwkIF;AmBtkIE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AnBwkIJ;AmBtkII;EACE,eAAA;EACA,gBAAA;EACA,SAAA;AnBwkIN;AmBpkIE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AnBskIJ;AmBnkIE;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AnBqkIJ;AmBnkII;EACE,YAAA;AnBqkIN;AmBjkIE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,4BAAA;AnBmkIJ;AmBjkII;EACE,mBAAA;AnBmkIN;AmB/jIE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AnBikIJ;AmB/jII;EACE,SAAA;EACA,eAAA;AnBikIN;AmB7jIE;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AnB+jIJ;AmB5jIE;EACE,aAAA;EACA,QAAA;AnB8jIJ;AmB3jIE;EACE,kBAAA;EACA,6BAAA;AnB6jIJ;AmB1jIE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AnB4jIJ;AmB1jII;EACE,SAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;EACA,qBAAA;AnB4jIN;AmBxjIE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AnB0jIJ;AmBvjIE;EACE,aAAA;EACA,SAAA;EACA,SAAA;AnByjIJ;AmBtjIE;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AnBwjIJ;AmBrjIE;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;AnBujIJ;AmBpjIE;EACE,eAAA;AnBsjIJ;AmBnjIE;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AnBqjIJ;AmBljIE;EACE,eAAA;EACA,gBAAA;AnBojIJ;AmBjjIE;EACE,aAAA;EACA,QAAA;EACA,iBAAA;EACA,cAAA;EACA,sBAAA;AnBmjIJ;AmBhjIE;EACE,kBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;AnBkjIJ;;AmB7iIA;EACE,gBAAA;EACA,mBAAA;AnBgjIF;AmB9iIE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;AnBgjIJ;AmB7iIE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AnB+iIJ;AmB5iIE;EACE,eAAA;EACA,cAAA;EACA,iBAAA;AnB8iIJ;;AmB1iIA;EACE,mBAAA;EACA,uBAAA;EACA,0BAAA;EACA,mBAAA;EACA,mBAAA;AnB6iIF;AmB3iIE;EACE,UAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;AnB6iIJ;AmB1iIE;EACE,aAAA;EACA,sBAAA;EACA,MAAA;AnB4iIJ;AmBziIE;EACE,mBAAA;AnB2iIJ;AmBxiIE;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AnB0iIJ;AmBviIE;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,6BAAA;AnByiIJ;;AmBriIA;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;AnBwiIF;AmBtiIE;EACE,iBAAA;EACA,8BAAA;AnBwiIJ;AmBriIE;EACE,cAAA;EACA,gBAAA;AnBuiIJ;AmBpiIE;EACE,mBAAA;EACA,qBAAA;AnBsiIJ;AmBpiII;EACE,cAAA;EACA,gBAAA;AnBsiIN;AmBliIE;EACE,iBAAA;EACA,6BAAA;EACA,mBAAA;AnBoiIJ;AmBliII;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;AnBoiIN;AmBhiIE;EACE,iBAAA;EACA,gBAAA;AnBkiIJ;AmB/hIE;EACE,aAAA;EACA,uBAAA;EACA,QAAA;AnBiiIJ;AmB9hIE;EACE,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AnBgiIJ;AmB9hII;EACE,mBAAA;EACA,qBAAA;AnBgiIN;AmB5hIE;EACE,cAAA;EACA,UAAA;EACA,WAAA;EACA,oCAAA;EACA,qCAAA;EACA,yBAAA;EACA,gCAAA;EACA,gBAAA;AnB8hIJ;AmB5hII;EACE,wBAAA;EACA,eAAA;AnB8hIN;AmB1hIE;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AnB4hIJ;AmBzhIE;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,YAAA;AnB2hIJ;AmBxhIE;EACE,SAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AnB0hIJ;AmBvhIE;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AnByhIJ;AmBthIE;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;AnBwhIJ;AmBrhIE;EAEE,qBAAA;EACA,6BAAA;EACA,eAAA;AnBshIJ;AmBphII;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;AnBshIN;AmBlhIE;EAEE,gBAAA;EACA,aAAA;EACA,cAAA;AnBmhIJ;;AmB9gIA;EACE,aAAA;AnBihIF;AmB/gIE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AnBihIJ;AmB/gII;EACE,eAAA;EACA,gBAAA;EACA,SAAA;AnBihIN;AmB7gIE;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AnB+gIJ;AmB7gII;EACE,gBAAA;EACA,cAAA;AnB+gIN;AmB3gIE;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,kBAAA;AnB6gIJ;AmB1gIE;EACE,aAAA;EACA,4DAAA;EACA,SAAA;AnB4gIJ;AmBzgIE;EACE,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,6CAAA;AnB2gIJ;AmBzgII;EACE,0CAAA;EACA,2BAAA;AnB2gIN;AmBvgIE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AnBygIJ;AmBvgII;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AnBygIN;AmBrgIE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AnBugIJ;AmBngII;EACE,aAAA;EACA,eAAA;EACA,cAAA;AnBqgIN;AmBjgIE;EACE,aAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;AnBmgIJ;AmBhgIE;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;AnBkgIJ;;AmB7/HA;EACE,aAAA;AnBggIF;AmB9/HE;EACE,mBAAA;AnBggIJ;AmB9/HI;EACE,eAAA;EACA,gBAAA;EACA,SAAA;AnBggIN;AmB5/HE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AnB8/HJ;AmB3/HE;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AnB6/HJ;AmB1/HE;EACE,eAAA;EACA,cAAA;EACA,eAAA;AnB4/HJ;AmBz/HE;EACE,mBAAA;AnB2/HJ;AmBx/HE;EACE,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AnB0/HJ;AmBv/HE;EACE,YAAA;EACA,mBjB97BY;EiB+7BZ,kBAAA;EACA,2BAAA;AnBy/HJ;AmBt/HE;EACE,eAAA;EACA,cAAA;AnBw/HJ;AmBr/HE;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,mBAAA;EACA,mBAAA;AnBu/HJ;AmBp/HE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AnBs/HJ;AmBn/HE;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AnBq/HJ;AmBl/HE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,4BAAA;AnBo/HJ;AmBl/HI;EACE,mBAAA;AnBo/HN;AmBh/HE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AnBk/HJ;AmBh/HI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AnBk/HN;AmB9+HE;EACE,kBAAA;EACA,6BAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AnBg/HJ;AmB7+HE;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;AnB++HJ;AmB7+HI;EACE,0BAAA;EACA,mBAAA;EACA,8CAAA;AnB++HN;AmB3+HE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,4BAAA;AnB6+HJ;AmB3+HI;EACE,mBAAA;AnB6+HN;AmBz+HE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,SAAA;EACA,cAAA;AnB2+HJ;AmBx+HE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,kEAAA;AnB0+HJ;AmBx+HI;EACE,mBAAA;EACA,qBAAA;EACA,6CAAA;AnB0+HN;AmBv+HI;EACE,0BAAA;EACA,mBAAA;AnBy+HN;AmBr+HE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,6DAAA;EACA,yBAAA;EACA,mBAAA;EACA,4CAAA;AnBu+HJ;AmBr+HI;EAXF;IAYI,mBAAA;IACA,mBAAA;IACA,8BAAA;EnBw+HJ;AACF;AmBr+HE;EACE,SAAA;EACA,YAAA;AnBu+HJ;AmBr+HI;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AnBu+HN;AmBp+HI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AnBs+HN;AmBl+HE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;AnBo+HJ;AmBl+HI;EACE,mBAAA;AnBo+HN;AmBj+HI;EACE,sBAAA;AnBm+HN;AmBh+HI;EACE,0BAAA;EACA,mBAAA;AnBk+HN;AmB99HE;EACE,aAAA;EACA,gBAAA;AnBg+HJ;AmB79HE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AnB+9HJ;AmB59HE;EACE,gBAAA;EACA,cAAA;AnB89HJ;AmB39HE;EACE,aAAA;EACA,6BAAA;EACA,mBAAA;AnB69HJ;AmB19HE;EACE,aAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;AnB49HJ;AmBz9HE;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AnB29HJ;AmBx9HE;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AnB09HJ;AmBx9HI;EACE,gBAAA;AnB09HN;AmBt9HE;EACE,eAAA;EACA,kBAAA;EACA,cAAA;AnBw9HJ;AmBr9HE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,8BAAA;AnBu9HJ;AmBp9HE;EACE,mBAAA;AnBs9HJ;AmBn9HE;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;AnBq9HJ;AmBl9HE;EACE,SAAA;EACA,mBAAA;EACA,mBAAA;AnBo9HJ;AmBj9HE;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;AnBm9HJ;AmBj9HI;EACE,qBAAA;EACA,mBAAA;AnBm9HN;AmB/8HE;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;AnBi9HJ;AmB98HE;EACE,SAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AnBg9HJ;;AmB38HA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AnB88HF;AmB58HE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AnB88HJ;AmB38HE;EACE,qBAAA;EACA,gCAAA;AnB68HJ;AmB38HI;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;EACA,SAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,iCAAA;AnB68HN;AmB38HM;EACE,mBAAA;AnB68HR;AmB18HM;EACE,0BAAA;EACA,mBAAA;AnB48HR;AmBv8HE;EACE,eAAA;EACA,cAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;AnBy8HJ;AmBt8HE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;EACA,SAAA;AnBw8HJ;AmBr8HE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;AnBu8HJ;AmBp8HE;EACE,SAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AnBs8HJ;AmBn8HE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,qBAAA;EACA,8BAAA;AnBq8HJ;AmBl8HE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;AnBo8HJ;AmBj8HE;EACE,oBAAA;AnBm8HJ;AmBj8HI;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,iCAAA;AnBm8HN;AmBj8HM;EACE,mBAAA;AnBm8HR;AmBh8HM;EACE,0BAAA;EACA,mBAAA;AnBk8HR;AmB77HE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AnB+7HJ;AmB57HE;EACE,SAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AnB87HJ;AmB37HE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,qBAAA;EACA,8BAAA;AnB67HJ;AmB17HE;EACE,uBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AnB47HJ;AmB17HI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AnB47HN;AmBx7HE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AnB07HJ;AmBv7HE;EACE,cAAA;EACA,gBAAA;AnBy7HJ;AmBt7HE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AnBw7HJ;;AmBp7HA;EACE,aAAA;EACA,gDAAA;EACA,QAAA;AnBu7HF;AmBr7HE;EALF;IAMI,0BAAA;EnBw7HF;AACF;AmBt7HE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;AnBw7HJ;AmBr7HE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,SAAA;EACA,YAAA;AnBu7HJ;AmBr7HI;EACE,WAAA;EACA,YAAA;EACA,cAAA;AnBu7HN;AmBn7HE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;AnBq7HJ;AmBl7HE;EACE,gBAAA;AnBo7HJ;AmBj7HE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AnBm7HJ;;AmB/6HA;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,0CAAA;EACA,gBAAA;EACA,8CAAA;AnBk7HF;;AmB/6HA;EACE,eAAA;AnBk7HF;;AmB/6HA;EACE,aAAA;EACA,MAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AnBk7HF;AmBh7HE;EACE,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;AnBk7HJ;AmBh7HI;EACE,+BAAA;AnBk7HN;AmB/6HI;EACE,mBAAA;EACA,cAAA;AnBi7HN;AmB96HI;EACE,mBAAA;EACA,cAAA;AnBg7HN;;AmB36HA;EACE,aAAA;EACA,QAAA;EACA,eAAA;AnB86HF;AmB56HE;EACE,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;AnB86HJ;AmB56HI;EACE,mBAAA;AnB86HN;;AmBx6HE;EACE,kBAAA;AnB26HJ;AmBx6HE;EACE,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,cjBviDY;EiBwiDZ,gBAAA;AnB06HJ;AmBv6HE;EACE,aAAA;EACA,6CAAA;EACA,mBAAA;EACA,6DAAA;AnBy6HJ;AmBt6HE;EACE,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AnBw6HJ;AmBr6HE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,0CAAA;EACA,kBAAA;AnBu6HJ;AmBp6HE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AnBs6HJ;AmBn6HE;EACE,iBAAA;AnBq6HJ;AmBl6HE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AnBo6HJ;AmBl6HI;EACE,cAAA;EACA,gBAAA;AnBo6HN;AmBh6HE;EACE,oBAAA;EACA,eAAA;AnBk6HJ;AmBh6HI;EACE,mBAAA;EACA,sCAAA;EACA,cAAA;EACA,gBAAA;AnBk6HN;AmBh6HM;EACE,mBAAA;EACA,qBjBzmDQ;EiB0mDR,cAAA;AnBk6HR;AmB95HI;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AnBg6HN;AmB55HE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,6CAAA;EACA,mBAAA;EACA,6DAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,8CAAA;EACA,0DAAA;AnB85HJ;AmB55HI;EACE,6DAAA;EACA,qBjB3oDU;AFyiLhB;AmB15HE;EACE,oBAAA;EACA,kBAAA;AnB45HJ;;AmBx5HA;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AnB25HF;AmBz5HE;EACE,aAAA;EACA,+BAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gCAAA;AnB25HJ;AmBz5HI;EACE,mBAAA;AnB25HN;AmBv5HE;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AnBy5HJ;AmBt5HE;EACE,iBAAA;EACA,aAAA;EACA,gDAAA;EACA,cAAA;AnBw5HJ;AmBt5HI;EANF;IAOI,0BAAA;EnBy5HJ;AACF;AmBv5HI;EACE,0BAAA;AnBy5HN;AmBt5HI;EACE,2DAAA;EACA,aAAA;AnBw5HN;AmBp5HE;EACE,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AnBs5HJ;AmBp5HI;EACE,0DAAA;EACA,aAAA;EACA,gBAAA;AnBs5HN;AmBl5HE;EACE,iBAAA;AnBo5HJ;AmBl5HI;EACE,0DAAA;EACA,aAAA;AnBo5HN;AmBh5HE;EACE,gBAAA;EACA,iBAAA;EACA,8BAAA;EACA,aAAA;EACA,gDAAA;EACA,aAAA;AnBk5HJ;AmBh5HI;EARF;IASI,0BAAA;EnBm5HJ;AACF;AmBj5HI;EACE,0BAAA;AnBm5HN;AmBh5HI;EACE,YAAA;AnBk5HN;AmB/4HI;EACE,eAAA;EACA,iBAAA;AnBi5HN;AmB74HE;EACE,cAAA;AnB+4HJ;AmB54HE;EACE,cAAA;AnB84HJ;AmB54HI;EACE,cAAA;EACA,kBAAA;EACA,cAAA;AnB84HN;AmB34HI;EACE,kBAAA;AnB64HN;AmBz4HE;EACE,aAAA;EACA,gDAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,uBAAA;AnB24HJ;AmBz4HI;EARF;IASI,0BAAA;EnB44HJ;AACF;AmB14HI;EACE,0BAAA;AnB44HN;AmBx4HE;EACE,SAAA;EACA,YAAA;EACA,iBAAA;AnB04HJ;AmBv4HE;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;AnBy4HJ;AmBt4HE;EACE,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AnBw4HJ;AmBt4HI;EACE,mBAAA;AnBw4HN;AmBp4HE;EACE,iBAAA;EACA,mBAAA;EACA,0BAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;AnBs4HJ;AmBp4HI;EACE,mBAAA;AnBs4HN;;AmBj4HA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,kBAAA;AnBo4HF;AmBl4HE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AnBo4HJ;AmBl4HI;EACE,cAAA;AnBo4HN;AmBh4HE;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AnBk4HJ;;AmB73HA;EACE,aAAA;AnBg4HF;AmB93HE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AnBg4HJ;AmB93HI;EACE,eAAA;EACA,gBAAA;EACA,SAAA;AnBg4HN;AmB53HE;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;AnB83HJ;AmB33HE;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,mBAAA;AnB63HJ;AmB13HE;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AnB43HJ;AmBz3HE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cjBr5DY;AFgxLhB;AmBx3HE;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AnB03HJ;AmBv3HE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AnBy3HJ;AmBt3HE;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AnBw3HJ;AmBr3HE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,4BAAA;AnBu3HJ;AmBr3HI;EACE,mBAAA;AnBu3HN;AmBp3HI;EACE,SAAA;EACA,eAAA;AnBs3HN;AmBl3HE;EACE,UAAA;EACA,6BAAA;AnBo3HJ;AmBj3HE;EACE,WAAA;EACA,yBAAA;EACA,eAAA;AnBm3HJ;AmBj3HI;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;EACA,qBAAA;EACA,gCAAA;AnBm3HN;AmBh3HI;EACE,kBAAA;EACA,gCAAA;EACA,mBAAA;AnBk3HN;AmB92HE;EACE,mBAAA;AnBg3HJ;AmB72HE;EACE,kBAAA;EACA,mBAAA;AnB+2HJ;AmB52HE;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AnB82HJ;AmB52HI;EACE,gBAAA;AnB82HN;AmB12HE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;AnB42HJ;AmBz2HE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;AnB22HJ;AmBz2HI;EACE,cAAA;EACA,eAAA;AnB22HN;AmBv2HE;EACE,cAAA;EACA,eAAA;AnBy2HJ;AmBt2HE;EACE,cAAA;EACA,qBAAA;EACA,mBAAA;AnBw2HJ;AmBr2HE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AnBu2HJ;AmBp2HE;EACE,mBAAA;AnBs2HJ;AmBn2HE;EACE,SAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AnBq2HJ;AmBl2HE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AnBo2HJ;AmBl2HI;EACE,cAAA;AnBo2HN;AmBh2HE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;AnBk2HJ;AmBh2HI;EACE,kBAAA;AnBk2HN;AmB91HE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;AnBg2HJ;AmB91HI;EACE,cAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;AnBg2HN;AmB51HE;EACE,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AnB81HJ;AmB31HE;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AnB61HJ;AmB11HE;EACE,eAAA;EACA,eAAA;AnB41HJ;AmB11HI;EACE,cAAA;EACA,kBAAA;EACA,cAAA;AnB41HN;AmBx1HE;EACE,SAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AnB01HJ;AmBx1HI;EACE,kBAAA;AnB01HN;AmBt1HE;EACE,eAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;AnBw1HJ;;AmBl1HA;EACE,aAAA;EACA,MAAA;EACA,mBAAA;EACA,gCAAA;AnBq1HF;AmBn1HE;EACE,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,oCAAA;EACA,mBAAA;EACA,2CAAA;AnBq1HJ;AmBn1HI;EACE,cAAA;AnBq1HN;AmBl1HI;EACE,cjBtpEU;EiBupEV,4BjBvpEU;AF2+LhB;;AmB/0HA;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;AnBk1HF;;AmB/0HA;EACE,mBAAA;AnBk1HF;;AmB/0HA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;AnBk1HF;;AmB/0HA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AnBk1HF;;AmB/0HA;EACE,gBAAA;AnBk1HF;;AmB90HE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;AnBi1HJ;AmB90HE;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;AnBg1HJ;AmB70HE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gCAAA;EACA,eAAA;EACA,eAAA;AnB+0HJ;AmB70HI;EACE,WAAA;EACA,YAAA;AnB+0HN;;AmB10HA;EACE,aAAA;EACA,oDAAA;EACA,SAAA;EACA,kBAAA;AnB60HF;AmB30HE;EANF;IAOI,0BAAA;EnB80HF;AACF;AmB50HE;EACE,0BAAA;AnB80HJ;AmB30HE;EAEE,YAAA;AnB40HJ;;AmBx0HA;EACE,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AnB20HF;AmBz0HE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;AnB20HJ;AmBx0HE;EACE,aAAA;EACA,gDAAA;EACA,aAAA;AnB00HJ;AmBx0HI;EALF;IAMI,0BAAA;EnB20HJ;AACF;AmBx0HE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AnB00HJ;AmBv0HE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AnBy0HJ;AmBt0HE;EACE,eAAA;EACA,cAAA;EACA,sBAAA;EACA,iBAAA;AnBw0HJ;AmBr0HE;EACE,iBAAA;EACA,gBAAA;EACA,qBAAA;AnBu0HJ;AmBr0HI;EACE,eAAA;EACA,kBAAA;AnBu0HN;AmBp0HI;EACE,aAAA;AnBs0HN;AmBn0HI;EACE,eAAA;AnBq0HN;;AmB/zHE;EACE,aAAA;EACA,oDAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;AnBk0HJ;AmBh0HI;EAPF;IAQI,0BAAA;EnBm0HJ;AACF;AmBj0HI;EACE,0BAAA;EACA,gBAAA;AnBm0HN;AmB/zHE;EACE,YAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;AnBi0HJ;AmB9zHE;EACE,YAAA;AnBg0HJ;;AmB5zHA;EACE,aAAA;EACA,gDAAA;EACA,cAAA;AnB+zHF;AmB7zHE;EALF;IAMI,0BAAA;EnBg0HF;AACF;AmB9zHE;EACE,0BAAA;AnBg0HJ;AmB7zHE;EACE,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AnB+zHJ;;AmB3zHA;EACE,eAAA;EACA,cAAA;EACA,sBAAA;EACA,iBAAA;AnB8zHF;AmB5zHE;EACE,cAAA;AnB8zHJ;AmB3zHE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AnB6zHJ;AmB3zHI;EACE,0BAAA;AnB6zHN;;AmBxzHA;EACE,aAAA;EACA,gDAAA;EACA,aAAA;AnB2zHF;AmBzzHE;EALF;IAMI,0BAAA;EnB4zHF;AACF;AmB1zHE;EACE,aAAA;EACA,eAAA;EACA,QAAA;AnB4zHJ;AmBzzHE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AnB2zHJ;AmBxzHE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AnB0zHJ;AmBvzHE;EACE,eAAA;EACA,cAAA;EACA,sBAAA;AnByzHJ;;AmBpzHE;EACE,aAAA;EACA,gDAAA;EACA,cAAA;AnBuzHJ;AmBrzHI;EALF;IAMI,0BAAA;EnBwzHJ;AACF;AmBrzHE;EACE,YAAA;AnBuzHJ;AmBrzHI;EACE,iBAAA;AnBuzHN;AmBnzHE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;AnBqzHJ;AmBlzHE;EACE,eAAA;EACA,eAAA;EACA,cAAA;AnBozHJ;AmBjzHE;EACE,eAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;AnBmzHJ;AmBhzHE;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AnBkzHJ;;AmB9yHA;EACE,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;AnBizHF;AmB/yHE;EACE,mBAAA;EACA,cAAA;AnBizHJ;AmB9yHE;EACE,mBAAA;EACA,cAAA;AnBgzHJ;;AmB3yHE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;AnB8yHJ;AmB1yHI;EACE,yBAAA;EACA,kBAAA;AnB4yHN;AmBzyHI;EACE,eAAA;EACA,iBAAA;AnB2yHN;AmBvyHE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;AnByyHJ;AmBtyHE;EACE,eAAA;EACA,cAAA;EACA,sBAAA;AnBwyHJ;AmBryHE;EACE,gBAAA;EACA,iBAAA;EACA,8BAAA;AnBuyHJ;;AmBnyHA;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AnBsyHF;AmBpyHE;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;AnBsyHJ;AmBnyHE;EACE,SAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,MAAA;AnBqyHJ;AmBlyHE;EACE,aAAA;EACA,0DAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,gCAAA;AnBoyHJ;AmBlyHI;EACE,iBAAA;EACA,mBAAA;AnBoyHN;AmBjyHI;EACE,0BAAA;AnBmyHN;AmB/xHE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AnBiyHJ;AmB9xHE;EACE,YAAA;AnBgyHJ;AmB7xHE;EACE,eAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;AnB+xHJ;AmB5xHE;EACE,eAAA;EACA,cAAA;AnB8xHJ;;AmBzxHE;EACE,mBAAA;AnB4xHJ;AmBzxHE;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AnB2xHJ;AmBxxHE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AnB0xHJ;AmBxxHI;EACE,kBAAA;AnB0xHN;AmBtxHE;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AnBwxHJ;AmBtxHI;EACE,mBAAA;AnBwxHN;AmBpxHE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,gCAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AnBsxHJ;AmBpxHI;EACE,mBAAA;AnBsxHN;AmBnxHI;EACE,0BAAA;EACA,oBAAA;AnBqxHN;AmBjxHE;EACE,eAAA;EACA,cAAA;EACA,WAAA;EACA,cAAA;AnBmxHJ;AmBhxHE;EACE,SAAA;EACA,YAAA;AnBkxHJ;AmB/wHE;EACE,aAAA;EACA,mBAAA;AnBixHJ;AmB9wHE;EACE,mBAAA;AnBgxHJ;AmB9wHI;EACE,eAAA;EACA,eAAA;AnBgxHN;AmB5wHE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AnB8wHJ;AmB3wHE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;AnB6wHJ;AmB3wHI;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AnB6wHN;AmB1wHI;EACE,SAAA;EACA,cAAA;EACA,eAAA;AnB4wHN;AmBxwHE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AnB0wHJ;AmBvwHE;EACE,eAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AnBywHJ;AmBtwHE;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AnBwwHJ;AmBrwHE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,iFAAA;EACA,cAAA;AnBuwHJ;AmBrwHI;EACE,qBjBhvFU;EiBivFV,yCAAA;AnBuwHN;AmBpwHI;EACE,0BAAA;EACA,mBAAA;AnBswHN;AmBnwHI;EACE,qBjB1vFU;EiB2vFV,mBAAA;AnBqwHN;AmBjwHE;EACE,eAAA;EACA,gBAAA;AnBmwHJ;AmBhwHE;EACE,eAAA;EACA,cAAA;AnBkwHJ;AmB/vHE;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AnBiwHJ;AmB9vHE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,0DAAA;AnBgwHJ;AmB9vHI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AnBgwHN;AmB7vHI;EACE,SAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AnB+vHN;AmB5vHI;EACE,qBjB3yFU;EiB4yFV,yCAAA;AnB8vHN;AmB3vHI;EACE,0BAAA;EACA,mBAAA;AnB6vHN;AmBzvHE;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AnB2vHJ;AmBxvHE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,0DAAA;AnB0vHJ;AmBxvHI;EACE,qBjBz0FU;EiB00FV,yCAAA;AnB0vHN;AmBvvHI;EACE,0BAAA;EACA,mBAAA;AnByvHN;AmBtvHI;EACE,YAAA;EACA,mBAAA;AnBwvHN;AmBpvHE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AnBsvHJ;AmBnvHE;EACE,eAAA;EACA,gBAAA;AnBqvHJ;AmBnvHI;EACE,cAAA;AnBqvHN;AmBlvHI;EACE,cAAA;AnBovHN;AmBhvHE;EACE;IACE,gDAAA;EnBkvHJ;EmBhvHE;IACE,gDAAA;EnBkvHJ;AACF;AmB/uHE;EACE;IACE,gDAAA;EnBivHJ;EmB9uHE;IAEE,0BAAA;EnB+uHJ;AACF;;AmB1uHE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AnB6uHJ;AmB1uHE;EACE,SAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AnB4uHJ;AmB1uHI;EACE,qBAAA;EACA,mBAAA;AnB4uHN;AmBzuHI;EACE,qBAAA;EACA,mBAAA;AnB2uHN;AmBxuHI;EACE,qBAAA;EACA,mBAAA;AnB0uHN;AmBvuHI;EACE,qBAAA;EACA,cAAA;EACA,eAAA;EACA,0DAAA;AnByuHN;AmBvuHM;EACE,yCAAA;AnByuHR;AmBtuHM;EACE,0BAAA;EACA,mBAAA;AnBwuHR;AmBnuHE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AnBquHJ;AmBluHE;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;AnBouHJ;AmBjuHE;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AnBmuHJ;AmBhuHE;EACE,YAAA;EACA,mBjB58FY;EiB68FZ,kBAAA;EACA,2BAAA;AnBkuHJ;AmB/tHE;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AnBiuHJ;AmB9tHE;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,cAAA;AnBguHJ;AmB7tHE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;AnB+tHJ;AmB5tHE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;AnB8tHJ;AmB3tHE;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;AnB6tHJ;AmB1tHE;EACE,aAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;AnB4tHJ;AmBztHE;EACE,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AnB2tHJ;AmBxtHE;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AnB0tHJ;AmBxtHI;EACE,eAAA;EACA,cAAA;AnB0tHN;AmBttHE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AnBwtHJ;AmBrtHE;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AnButHJ;AmBptHE;EACE,eAAA;EACA,gBAAA;EACA,cjBviGY;EiBwiGZ,qBAAA;AnBstHJ;AmBptHI;EACE,0BAAA;AnBstHN;AmBltHE;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AnBotHJ;AmBjtHE;EACE,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AnBmtHJ;AmBjtHI;EACE,eAAA;AnBmtHN;AmBhtHI;EACE,cAAA;EACA,gBAAA;EACA,qBAAA;AnBktHN;AmBhtHM;EACE,cjBzkGQ;EiB0kGR,0BAAA;AnBktHR;AmB7sHE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AnB+sHJ;AmB5sHE;EACE,eAAA;AnB8sHJ;AmB3sHE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AnB6sHJ;AmB1sHE;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AnB4sHJ;AmBzsHE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,gCAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AnB2sHJ;AmBzsHI;EACE,mBAAA;AnB2sHN;AmBvsHE;EACE,eAAA;EACA,cAAA;EACA,WAAA;EACA,cAAA;AnBysHJ;AmBtsHE;EACE,SAAA;EACA,YAAA;AnBwsHJ;AmBrsHE;EACE,kBAAA;EACA,6BAAA;AnBusHJ;AmBpsHE;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AnBssHJ;AmBnsHE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AnBqsHJ;AmBlsHE;EACE,eAAA;EACA,gBAAA;EACA,cjBpqGY;EiBqqGZ,qBAAA;AnBosHJ;AmBlsHI;EACE,0BAAA;AnBosHN;;AmB9rHE;EACE,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,qBAAA;AnBisHJ;AmB/rHI;EACE,cjBtrGU;EiBurGV,0BAAA;AnBisHN;AmB7rHE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AnB+rHJ;AmB5rHE;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AnB8rHJ;AmB3rHE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AnB6rHJ;AmB3rHI;EACE,SAAA;EACA,eAAA;AnB6rHN;;AmBvrHA;EACE,eAAA;AnB0rHF;AmBxrHE;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AnB0rHJ;AmBvrHE;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,kBAAA;AnByrHJ;AmBvrHI;EACE,SAAA;EACA,YAAA;AnByrHN;AmBrrHE;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;EACA,2BAAA;AnBurHJ;AmBrrHI;EACE,kBAAA;AnBurHN;AmBlrHI;EACE,kBAAA;AnBorHN;;AmB/qHA;EACE,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AnBkrHF;AmBhrHE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;AnBkrHJ;AmB/qHE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AnBirHJ;AmB9qHE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AnBgrHJ;AmB7qHE;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AnB+qHJ;AmB5qHE;EACE,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AnB8qHJ;AmB3qHE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;AnB6qHJ;AmB1qHE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AnB4qHJ;AmBzqHE;EACE,eAAA;EACA,cAAA;AnB2qHJ;AmBxqHE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;AnB0qHJ;AmBvqHE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;AnByqHJ;AmBtqHE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;AnBwqHJ;AmBrqHE;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AnBuqHJ;AmBpqHE;EACE,kBAAA;EACA,gBAAA;AnBsqHJ;AmBnqHE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AnBqqHJ;AmBlqHE;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AnBoqHJ;AmBjqHE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AnBmqHJ;AmBhqHE;EACE,eAAA;EACA,eAAA;EACA,cAAA;AnBkqHJ;AmB/pHE;EACE,gBAAA;EACA,eAAA;EACA,UAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AnBiqHJ;AmB9pHE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,gCAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;AnBgqHJ;AmB9pHI;EACE,mBAAA;AnBgqHN;AmB7pHI;EACE,mBAAA;AnB+pHN;AmB5pHI;EACE,aAAA;EACA,mBAAA;AnB8pHN;AmB1pHE;EACE,iBAAA;EACA,eAAA;EACA,cAAA;AnB4pHJ;AmBzpHE;EACE,SAAA;EACA,eAAA;EACA,cAAA;AnB2pHJ;AmBxpHE;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;AnB0pHJ;AmBvpHE;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AnBypHJ;AmBtpHE;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AnBwpHJ;AmBrpHE;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AnBupHJ;AmBppHE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,0BAAA;EACA,kBAAA;EACA,aAAA;AnBspHJ;AmBnpHE;EACE,eAAA;EACA,cAAA;EACA,cAAA;AnBqpHJ;AmBlpHE;EACE,mBAAA;AnBopHJ;AmBjpHE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AnBmpHJ;;AmB9oHE;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,kCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AnBipHJ;AmB9oHE;EACE,uBAAA;EACA,4BAAA;EACA,gBAAA;EACA,mBAAA;EACA,0CAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AnBgpHJ;AmB7oHE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,uBAAA;EACA,gCAAA;AnB+oHJ;AmB5oHE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AnB8oHJ;AmB3oHE;EACE,eAAA;EACA,eAAA;EACA,cAAA;AnB6oHJ;AmB1oHE;EACE,YAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AnB4oHJ;AmBzoHE;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,SAAA;AnB2oHJ;AmBxoHE;EACE,cAAA;EACA,kBAAA;AnB0oHJ;AmBvoHE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,kBAAA;EACA,6BAAA;EACA,mBAAA;AnByoHJ;AmBtoHE;EACE,eAAA;EACA,kBAAA;AnBwoHJ;AmBroHE;EACE,mBAAA;EACA,oBAAA;EACA,gCAAA;AnBuoHJ;AmBpoHE;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AnBsoHJ;AmBnoHE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AnBqoHJ;AmBnoHI;EACE,YAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AnBqoHN;AmBjoHE;EACE,aAAA;AnBmoHJ;AmBhoHE;EACE,gBAAA;AnBkoHJ;AmB/nHE;EACE,mBAAA;EACA,gBAAA;AnBioHJ;;AmB5nHE;EACE,aAAA;EACA,gDAAA;EACA,cAAA;AnB+nHJ;AmB7nHI;EALF;IAMI,0BAAA;EnBgoHJ;AACF;AmB7nHE;EACE,iBAAA;AnB+nHJ;AmB5nHE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AnB8nHJ;AmB3nHE;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AnB6nHJ;AmB3nHI;EACE,mBAAA;EACA,cAAA;AnB6nHN;;AmBznHA;EACE,uBAAA;EACA,iBAAA;AnB4nHF;AmB1nHE;EACE,mBAAA;AnB4nHJ;AmBznHE;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AnB2nHJ;AmBxnHE;EACE,SAAA;EACA,cAAA;EACA,eAAA;AnB0nHJ;AmBvnHE;EACE,aAAA;EACA,4DAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AnBynHJ;AmBtnHE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;AnBwnHJ;AmBtnHI;;EAEE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AnBwnHN;AmBpnHE;EACE,aAAA;EACA,qBAAA;EACA,QAAA;EACA,iBAAA;AnBsnHJ;AmBnnHE;EACE,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AnBqnHJ;AmBlnHE;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,kBAAA;AnBonHJ;AmBjnHE;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;AnBmnHJ;AmBhnHE;EACE,WAAA;EACA,yBAAA;EACA,eAAA;AnBknHJ;AmBhnHI;;EAEE,kBAAA;EACA,gBAAA;EACA,gCAAA;EACA,mBAAA;AnBknHN;AmB/mHI;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AnBinHN;AmB9mHI;EACE,eAAA;AnBgnHN;AmB9mHM;EACE,mBAAA;AnBgnHR;AmB3mHE;EACE,8BAAA;AnB6mHJ;AmB1mHE;EACE,qBAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,mBAAA;EACA,cAAA;AnB4mHJ;AmB1mHI;EACE,mBAAA;EACA,cAAA;AnB4mHN;AmBzmHI;EACE,mBAAA;EACA,cAAA;AnB2mHN;AmBxmHI;EACE,mBAAA;EACA,cAAA;AnB0mHN;AmBvmHI;EAEE,mBAAA;EACA,cAAA;AnBwmHN;AmBpmHE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,cAAA;AnBsmHJ;AmBnmHE;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,8BAAA;EACA,cAAA;AnBqmHJ;AmBnmHI;EACE,gBAAA;EACA,eAAA;AnBqmHN;AmBlmHI;EACE,kBAAA;EACA,eAAA;EACA,cAAA;AnBomHN;AmBhmHE;EACE,SAAA;EACA,aAAA;EACA,SAAA;EACA,eAAA;AnBkmHJ;AmBhmHI;EACE,aAAA;EACA,QAAA;AnBkmHN;AmB/lHI;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;AnBimHN;AmB9lHI;EACE,SAAA;EACA,cAAA;AnBgmHN;AmB5lHE;EACE,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;EACA,iBAAA;EACA,cAAA;AnB8lHJ;AmB3lHE;EACE,SAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AnB6lHJ;AmB1lHE;EACE;IACE,0BAAA;EnB4lHJ;EmBzlHE;IACE,gBAAA;IACA,gBAAA;EnB2lHJ;AACF;;AoB59OA;EACE,aAAA;ApB+9OF;AoB79OE;EACE,iBAAA;EACA,cAAA;ApB+9OJ;AoB59OE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;ApB89OJ;AoB39OE;EACE,eAAA;EACA,gBAAA;EACA,SAAA;ApB69OJ;AoB19OE;EACE,eAAA;EACA,cAAA;EACA,eAAA;ApB49OJ;AoBz9OE;EACE,aAAA;EACA,SAAA;ApB29OJ;AoBx9OE;EACE,aAAA;EACA,wCAAA;EACA,SAAA;EACA,cAAA;ApB09OJ;AoBx9OI;EANF;IAOI,0BAAA;EpB29OJ;AACF;AoBx9OE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;ApB09OJ;AoBx9OI;EACE,gBAAA;ApB09ON;AoBt9OE;EACE,eAAA;EACA,cAAA;ApBw9OJ;AoBr9OE;EACE,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;ApBu9OJ;AoBp9OE;EACE,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;ApBs9OJ;AoBp9OI;EACE,YAAA;EACA,mBAAA;ApBs9ON;AoBn9OI;EACE,gBAAA;EACA,cAAA;ApBq9ON;AoBj9OE;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;ApBm9OJ;AoBh9OE;EACE,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;ApBk9OJ;AoB/8OE;EACE,WAAA;EACA,yBAAA;EACA,gBAAA;ApBi9OJ;AoB/8OI;;EAEE,kBAAA;EACA,gCAAA;EACA,eAAA;EACA,mBAAA;ApBi9ON;AoB98OI;EACE,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;ApBg9ON;AoB78OI;EACE,mBAAA;ApB+8ON;AoB38OE;EACE,kBAAA;EACA,cAAA;EACA,6BAAA;ApB68OJ;AoB18OE;EACE,+GAAA;ApB48OJ;AoBx8OE;EACE,uBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;ApB08OJ;AoBv8OE;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,6BAAA;ApBy8OJ;AoBv8OI;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;ApBy8ON;AoBt8OI;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;ApBw8ON;AoBr8OI;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;EACA,oBAAA;ApBu8ON;AoBp8OI;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;EACA,oBAAA;ApBs8ON;AoBn8OI;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;EACA,oBAAA;ApBq8ON;AoBl8OI;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;EACA,oBAAA;ApBo8ON;AoBh8OE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;ApBk8OJ;;AoB97OA;EACE,aAAA;ApBi8OF;AoB/7OE;EACE,iBAAA;EACA,cAAA;ApBi8OJ;AoB97OE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;ApBg8OJ;AoB77OE;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;ApB+7OJ;AoB57OE;EACE,cAAA;EACA,eAAA;ApB87OJ;AoB37OE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;ApB67OJ;AoB17OE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;ApB47OJ;AoBz7OE;EACE,aAAA;EACA,QAAA;EACA,eAAA;ApB27OJ;AoBx7OE;EACE,aAAA;EACA,gCAAA;EACA,SAAA;ApB07OJ;AoBx7OI;EALF;IAMI,0BAAA;EpB27OJ;AACF;AoBx7OE;EACE,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;ApB07OJ;AoBv7OE;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;ApBy7OJ;AoBt7OE;EACE,aAAA;EACA,0BAAA;EACA,SAAA;ApBw7OJ;AoBr7OE;EACE,aAAA;EACA,gCAAA;EACA,SAAA;EACA,kBAAA;ApBu7OJ;AoBr7OI;EANF;IAOI,0BAAA;IACA,QAAA;EpBw7OJ;AACF;AoBr7OE;EACE,eAAA;EACA,cAAA;ApBu7OJ;AoBp7OE;EACE,eAAA;EACA,cAAA;ApBs7OJ;AoBp7OI;EACE,+GAAA;ApBs7ON;AoBl7OI;EACE,qBAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;ApBo7ON;AqBtvPQ;EAAA,kBrBsvPR;EqBtvPQ;ArBsvPR","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n@import \"base/reset\";\n\n@import \"utils/variables\";\n\n@import \"base/fonts\";\n@import \"base/global\";\n\n@import \"shared/typography\";\n@import \"shared/fields\";\n@import \"shared/svgs\";\n@import \"shared/buttons\";\n\n@import 'components/team';\n@import 'components/admin/sidebar';\n\n\n\n@import \"pages/home\";\n@import \"pages/userId\";\n@import \"pages/fingerprint\";\n@import \"pages/meal\";\n@import \"pages/issue-report\";\n@import \"pages/qrcode-display\";\n@import \"pages/food-poll\";\n@import \"pages/admin/login\";\n@import \"pages/admin/users\";\n@import \"pages/admin/layout\";\n@import \"pages/admin/reporting\";\n@import \"pages/admin/issue-reports\";\n\n\n\n\n\n\n\n","html,\nbody,\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n}\n\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection {\n  display: block;\n}\n\nbody {\n  line-height: 1;\n}\n\nol,\nul {\n  list-style: none;\n}\n\nblockquote,\nq {\n  quotes: none;\n}\n\nblockquote:before,\nblockquote:after,\nq:before,\nq:after {\n  content: \"\";\n  content: none;\n}\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\n* {\n  box-sizing: border-box;\n\n  &::before,\n  &::after {\n    box-sizing: border-box;\n  }\n}\n\na {\n  color: inherit;\n  text-decoration: none;\n  cursor: pointer;\n}\n\nbutton {\n  cursor: pointer;\n}","\n\n\n$text-color: #000000;\n$color-primary: #FA9411;    \n$color-primary-dark: #FA9411; \n$color-success: #FA9411;     \n$color-success-dark: #FA9411;\n$color-danger: #ff0000;\n$color-gray-50: #f9fafb;\n$color-gray-200: #e5e7eb;\n$color-gray-300: #d1d5db;\n$color-gray-600: #4b5563;\n$color-gray-700: #374151;\n$color-gray-900: #111827;\n$color-white: #ffffff;\n\n\n$text-normal: 16px;\n\n/** Break Points **/\n$LGdesktop: 1920px;\n$desktop: 1366px;\n$tablet-pro: 1204px;\n$tablet: 769px;\n$phone: 565px;\n$sidebar-width: 250px;\n$sidebar-mobile-width: 80px;\n/** Break Points **/","\n\n\nhtml {\n  // font-size: 62.5%;\n  font-size: calc(100vw / 1440 * 10);\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n\n  @media (min-width: 1440px) {\n    font-size: 62.5%;\n  }\n\n  @media (max-width: $phone) {\n    font-size: calc(100vw / 550 * 10);\n}\n\n}\n:root {\n  --font-primary: Inter, sans-serif;\n}\nbody {\n  font-family: var(--font-primary);\n    font-size: $text-normal;\n    color: $text-color;\n\n  }\n\n  .main {\n    // padding-top: 8.4rem;\n    min-height: 100vh; \n    display: flex;\n    flex-direction: column;\n    justify-content: space-between; \n  }\n\n  .inner {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    max-width: 1440px;\n    width: 100%;\n    margin: auto;\n\n    @media (max-width: $phone) {\n      margin: 0 auto;\n  }\n\n  }\n\n  .hidden-scroll-bar {\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n\n  .pointer {\n    cursor: pointer;\n  }\n\n",".confetti {\n    // position: absolute;\n    // bottom: 0;\n    // right: 50%;\n    // transform: translateX(50%);\n    margin-top: 4rem;\n\n    @media (max-width: $phone) {\n        display: none;\n    }\n}",".team {\n  width: 100%;\n  padding: 80px 0 80px 200px;\n\n  &__title {\n    width: 100%;\n    max-width: 1440px;\n    margin: 0 auto;\n    padding-right: 20px;\n    font-size: 10vw;\n    margin-bottom: 20px;\n    font-weight: 800;\n  }\n\n  &__subtitle {\n    width: 100%;\n    max-width: 1440px;\n    margin: 0 auto;\n    padding-right: 20px;\n    font-size: 20px;\n    margin-bottom: 100px;\n    line-height: 140%;\n  }\n\n  &__slide {\n    display: flex;\n    align-items: start;\n    gap: 20px;\n    overflow-x: auto;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n\n    & > :nth-child(odd) {\n      .team__slide__card__bg {\n        background: rgb(186, 201, 154);\n      }\n    }\n\n    &__card {\n      min-width: 350px;\n\n      &__bg {\n        height: fit-content;\n        background: rgb(177, 154, 177);\n        margin-bottom: 20px;\n        padding: 64px;\n        border-radius: 12px;\n        height: 350px;\n\n        &__img {\n          word-wrap: 100%;\n          height: 100%;\n          border-radius: 8px;\n          position: relative;\n          overflow: hidden;\n        }\n      }\n\n      &__title {\n        font-size: 18px;\n        font-weight: 700;\n        margin-bottom: 18px;\n        line-height: 120%;\n      }\n      &__role {\n        font-weight: 400;\n        line-height: 120%;\n      }\n    }\n  }\n}\n",".sidebar {\n  width: 100%; // Full width on mobile\n  height: auto;\n  background-color: $color-white;\n  border-bottom: 1px solid $color-gray-200;\n  padding: 16px;\n  \n  @media (min-width: $tablet) {\n    width: $sidebar-width;\n    height: 100vh;\n    border-right: 1px solid $color-gray-200;\n    border-bottom: none;\n    padding: 24px;\n  }\n  \n  &__logo {\n    width: 100%;\n    height: auto;\n    padding-bottom: 16px;\n    border-bottom: 1px solid $color-gray-200;\n    text-align: center; // Center on mobile\n    \n    @media (min-width: $tablet) {\n      padding-bottom: 24px;\n      text-align: left;\n    }\n  }\n  \n  &__title {\n    color: $color-gray-900;\n    font-size: 20px; // Smaller on mobile\n    font-weight: 600;\n    \n    @media (min-width: $tablet) {\n      font-size: 24px;\n    }\n  }\n  \n  &__nav {\n    margin-top: 16px;\n    \n    @media (min-width: $tablet) {\n      margin-top: 24px;\n    }\n  }\n  \n  &__menu {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: flex; // Horizontal on mobile\n    flex-wrap: wrap;\n    gap: 8px;\n    \n    @media (min-width: $tablet) {\n      flex-direction: column;\n      gap: 8px;\n    }\n  }\n  \n  &__menu-item {\n    flex: 1; // Equal width items on mobile\n    min-width: 80px;\n    margin: 0;\n    \n    @media (min-width: $tablet) {\n      flex: none;\n      margin-bottom: 8px;\n    }\n    \n    &--active {\n      .sidebar__link {\n        background-color: $color-primary;\n        color: $color-white;\n        \n        .sidebar__icon {\n          stroke: $color-white;\n          min-width: 20px;\n        }\n        \n        &:hover {\n          background-color: $color-primary-dark;\n        }\n      }\n    }\n  }\n  \n  &__link {\n    display: flex;\n    flex-direction: column; // Stack icon and text on mobile\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    padding: 12px;\n    color: $color-gray-600;\n    text-decoration: none;\n    border-radius: 6px;\n    transition: all 0.2s;\n    text-align: center;\n    \n    @media (min-width: $tablet) {\n      flex-direction: row;\n      justify-content: flex-start;\n      gap: 12px;\n      padding: 12px 16px;\n      text-align: left;\n    }\n    \n    &:hover {\n      background-color: $color-gray-50;\n      color: $color-gray-900;\n      \n      .sidebar__icon {\n        stroke: $color-gray-900;\n      }\n    }\n    \n    span {\n      font-size: 10px; // Smaller text on mobile\n      \n      @media (min-width: $tablet) {\n        font-size: 16px;\n      }\n    }\n  }\n  \n  &__icon {\n    stroke: $color-gray-600;\n    transition: stroke 0.2s;\n    flex-shrink: 0;\n  }\n\n  // Collapsible Groups\n  &__group {\n    margin-bottom: 8px;\n    \n    @media (min-width: $tablet) {\n      margin-bottom: 12px;\n    }\n  }\n\n  &__group-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    padding: 12px 16px;\n    background-color: $color-gray-50;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: all 0.2s;\n    color: $color-gray-700;\n    font-size: 11px;\n    \n    @media (min-width: $tablet) {\n      padding: 10px 12px;\n      font-size: 12px;\n    }\n\n    &:hover {\n      background-color: $color-gray-200;\n      color: $color-gray-900;\n    }\n\n    &--expanded {\n      background-color: $color-gray-200;\n      color: $color-gray-900;\n    }\n\n    .sidebar__icon {\n      width: 14px;\n      height: 14px;\n      stroke: currentColor;\n      flex-shrink: 0;\n    }\n  }\n\n  &__group-items {\n    margin-top: 4px;\n    padding-left: 0;\n    list-style: none;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n\n    @media (min-width: $tablet) {\n      margin-top: 6px;\n      gap: 4px;\n    }\n\n    .sidebar__menu-item {\n      margin-bottom: 0;\n    }\n\n    .sidebar__link {\n      padding: 10px 16px;\n      font-size: 14px;\n      \n      @media (min-width: $tablet) {\n        padding: 10px 16px 10px 48px;\n      }\n    }\n  }\n}","\n\n.id-generator {\n  min-height: 100vh;\n  background-color: $color-gray-50;\n  padding: 48px 16px;\n\n  @media (max-width: $phone) {\n    padding: 0;\n  }\n\n  &__container {\n    max-width: 448px;\n    margin: 0 auto;\n    background-color: $color-white;\n    border-radius: 12px;\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);\n    padding: 32px;\n\n    @media (min-width: 768px) {\n      max-width: 900px;\n    }\n  }\n\n  &__header {\n    margin-bottom: 32px;\n    text-align: center;\n\n    &-title {\n      font-size: 24px;\n      font-weight: 700;\n      color: $color-gray-900;\n      text-transform: capitalize;\n\n      @media (max-width: $phone) {\n        font-size: 16px;\n      }\n    }\n\n    &-subtitle {\n      margin-top: 8px;\n      font-size: 14px;\n      color: $color-gray-600;\n    }\n\n    &-subtitle-container {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 12px;\n      margin-top: 8px;\n      flex-wrap: wrap;\n    }\n  }\n\n  &__generate-btn {\n    padding: 6px 16px;\n    background-color: $color-primary;\n    color: $color-white;\n    border: none;\n    border-radius: 6px;\n    font-size: 13px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background-color 0.2s;\n    white-space: nowrap;\n\n    &:hover:not(:disabled) {\n      background-color: $color-primary-dark;\n    }\n\n    &:disabled {\n      opacity: 0.6;\n      cursor: not-allowed;\n    }\n  }\n\n  &__content {\n    display: flex;\n    flex-direction: column;\n    gap: 32px;\n  }\n\n  &__photo {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 16px;\n\n    &-preview {\n      position: relative;\n      width: 160px;\n\n      &-container {\n        width: 160px;\n        height: 160px;\n        border-radius: 8px;\n        overflow: hidden;\n        border: 2px solid $color-gray-200;\n      }\n\n      &-image {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n      }\n\n      &-loading {\n        position: absolute;\n        inset: 0;\n        background-color: rgba($color-white, 0.75);\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n\n      &-loading-spinner {\n        width: 24px;\n        height: 24px;\n        border: 2px solid $color-gray-200;\n        border-top-color: $color-primary;\n        border-radius: 50%;\n        animation: spin 1s linear infinite;\n      }\n    }\n\n    &-remove {\n      position: absolute;\n      top: -8px;\n      right: -8px;\n      width: 24px;\n      height: 24px;\n      border-radius: 50%;\n      background-color: $color-white;\n      border: 1px solid $color-gray-200;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      cursor: pointer;\n      font-size: 12px;\n      color: $color-gray-600;\n\n      &:hover {\n        background-color: $color-gray-50;\n      }\n    }\n\n    &-button {\n      @include button($color-success, $color-success-dark);\n    }\n  }\n\n  &__form {\n    &-grid {\n      display: grid;\n      grid-template-columns: 1fr;\n      gap: 24px;\n\n      @media (min-width: 640px) {\n        grid-template-columns: repeat(2, 1fr);\n      }\n\n      @media (min-width: 1024px) {\n        grid-template-columns: repeat(3, 1fr);\n      }\n    }\n\n    &-group {\n\n      margin-bottom: 0;\n\n      &--full {\n        grid-column: 1 / -1;\n      }\n    }\n\n    &-info {\n      // display: flex;\n      // align-items: center;\n      // gap: 6px;\n    }\n\n    &__container {\n      @media (min-width: 768px) {\n        max-width: 900px;\n      }\n  \n      @media (min-width: 1024px) {\n        max-width: 1200px;\n      }\n    }\n\n    &-label {\n      font-size: 14px;\n      font-weight: 500;\n      color: $color-gray-600;\n      margin-bottom: 4px;\n      display: block;\n    }\n\n    &-value {\n      font-size: 16px;\n      color: $color-gray-900;\n    }\n\n    &-input {\n      width: 100%;\n      padding: 8px 12px;\n      background-color: $color-white;\n      border: 1px solid $color-gray-300;\n      border-radius: 6px;\n      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n\n      &:focus {\n        outline: none;\n        border-color: $color-primary;\n        ring: 2px;\n        ring-color: $color-primary;\n      }\n    }\n\n    &-header {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      margin-bottom: 16px;\n    }\n\n    &-prescription {\n      margin-bottom: 16px;\n      \n      &-inputs {\n        display: grid;\n        grid-template-columns: 2fr 1fr 1fr auto;\n        gap: 12px;\n        align-items: start;\n      }\n    }\n\n    &-group {\n      &--full {\n        grid-column: 1 / -1;\n      }\n    }\n\n  }\n\n  \n  &__past-appointments {\n    margin-top: 32px;\n  }\n\n  &__appointment {\n    &-card {\n      border: 1px solid $color-gray-200;\n      border-radius: 6px;\n      margin-bottom: 12px;\n    }\n\n    &-header {\n      width: 100%;\n      padding: 12px;\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      background: none;\n      border: none;\n      cursor: pointer;\n      text-align: left;\n\n      &:hover {\n        background-color: $color-gray-50;\n      }\n    }\n\n    &-content {\n      padding: 16px;\n      border-top: 1px solid $color-gray-200;\n    }\n\n    &-section {\n      margin-bottom: 16px;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n\n    &-prescription {\n      padding: 8px 0;\n      border-bottom: 1px solid $color-gray-200;\n\n      &:last-child {\n        border-bottom: none;\n      }\n    }\n\n    &-toggle {\n      font-size: 12px;\n      color: $color-gray-600;\n    }\n  }\n\n  &__actions {\n    margin-top: 32px;\n    display: flex;\n    justify-content: center;\n    gap: 16px;\n    \n    \n    &-register {\n      @include button($color-success, $color-success-dark);\n    }\n    &-register-big {\n      @include button($color-success, $color-success-dark);\n      padding-left: 70px;\n      padding-right: 70px;\n    }\n    &-download {\n      @include button($color-primary, $color-primary-dark);\n    }\n\n    &-remove {\n      padding: 8px 16px;\n      background-color: $color-gray-200;\n      color: $color-gray-700;\n      border-radius: 6px;\n      font-size: 14px;\n      cursor: pointer;\n\n      &:hover {\n        background-color: $color-gray-300;\n      }\n    }\n  }\n\n  &__credentials-form {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n\n    &__button {\n      white-space: nowrap;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}","@mixin button($bg-color, $hover-color) {\n  display: inline-flex;\n  align-items: center;\n  padding: 8px 16px;\n  border: 1px solid transparent;\n  font-size: 14px;\n  font-weight: 500;\n  border-radius: 6px;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  color: $color-white;\n  background-color: $bg-color;\n  transition: background-color 0.2s;\n\n  &:hover {\n    background-color: $hover-color;\n  }\n\n  &:focus {\n    outline: none;\n    ring: 2px;\n    ring-offset: 2px;\n    ring-color: $bg-color;\n  }\n\n  &:disabled {\n    background-color: $color-gray-300;\n    cursor: not-allowed;\n  }\n}","// _variables.scss\n$color-white: #ffffff;\n$color-blue-600: #2563eb;\n$color-gray-50: #f9fafb;\n$color-gray-200: #e5e7eb;\n$color-gray-500: #6b7280;\n$color-gray-800: #1f2937;\n\n.id-display {\n  &__container {\n    margin: 0 auto;\n    padding: 24px 16px;\n    max-width: 1200px;\n\n    @media (min-width: 768px) {\n      padding: 24px;\n    }\n\n    @media (min-width: 1024px) {\n      padding: 32px;\n    }\n  }\n\n  &__card {\n    max-width: 768px;\n    margin: 0 auto;\n    background-color: $color-white;\n    padding: 16px;\n    border-radius: 8px;\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n\n    @media (min-width: 768px) {\n      padding: 24px;\n    }\n  }\n\n  &__content {\n    background-color: $color-gray-50;\n    border-radius: 12px;\n    padding: 16px;\n    border: 2px solid $color-gray-200;\n\n    @media (min-width: 768px) {\n      padding: 32px;\n    }\n  }\n\n  &__header {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-between;\n    padding-bottom: 16px;\n    margin-bottom: 16px;\n    border-bottom: 2px solid $color-gray-200;\n\n    @media (min-width: 768px) {\n      flex-direction: row;\n      padding-bottom: 24px;\n      margin-bottom: 24px;\n    }\n\n    &-title {\n      font-size: 24px;\n      font-weight: 700;\n      color: $color-blue-600;\n      margin-bottom: 8px;\n      text-align: center;\n      width: 100%;\n\n      @media (min-width: 768px) {\n        font-size: 30px;\n        margin-bottom: 0;\n        text-align: left;\n      }\n    }\n  }\n\n  &__info {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    margin-bottom: 16px;\n\n    @media (min-width: 768px) {\n      flex-direction: row;\n      gap: 32px;\n      margin-bottom: 32px;\n    }\n  }\n\n  &__photo {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n\n    @media (min-width: 768px) {\n      width: 33.333%;\n      justify-content: flex-start;\n    }\n\n    &-image {\n      width: 144px;\n      height: 144px;\n      object-fit: cover;\n      border-radius: 8px;\n      border: 4px solid $color-gray-200;\n\n      @media (min-width: 768px) {\n        width: 192px;\n        height: 192px;\n      }\n    }\n  }\n\n  &__details {\n    width: 100%;\n    text-align: center;\n\n    @media (min-width: 768px) {\n      width: 66.666%;\n      text-align: left;\n    }\n\n    &-group {\n      margin-bottom: 12px;\n\n      @media (min-width: 768px) {\n        margin-bottom: 16px;\n      }\n    }\n\n    &-label {\n      display: block;\n      font-size: 12px;\n      color: $color-gray-500;\n\n      @media (min-width: 768px) {\n        font-size: 14px;\n      }\n    }\n\n    &-value {\n      font-size: 18px;\n      font-weight: 600;\n      color: $color-gray-800;\n      text-transform: capitalize;\n\n      @media (min-width: 768px) {\n        font-size: 20px;\n      }\n    }\n  }\n\n  &__footer {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-between;\n    padding-top: 16px;\n    border-top: 2px solid $color-gray-200;\n\n    @media (min-width: 768px) {\n      flex-direction: row;\n    }\n\n    &-text {\n      font-size: 12px;\n      color: $color-gray-500;\n      margin-bottom: 16px;\n      text-align: center;\n      width: 100%;\n\n      @media (min-width: 768px) {\n        font-size: 14px;\n        margin-bottom: 0;\n        text-align: left;\n      }\n    }\n\n    &-qr {\n      display: flex;\n      justify-content: center;\n      width: 100%;\n\n      @media (min-width: 768px) {\n        justify-content: flex-end;\n      }\n\n      &-code {\n        width: 96px;\n        height: 96px;\n      }\n    }\n  }\n}",".fingerprint-grid {\n        width: 100%;\n    display: flex;\n    gap: 20px;\n    align-items: center;\n    justify-content: center;\n}\n\n.fingerprint {\n    &__container {\n      width: 100%;\n      max-width: 1024px;\n      margin: 0 auto;\n      padding: 20px;\n    }\n  \n    &__nav {\n      background-color: #2c3e50;\n      padding: 15px;\n      margin-bottom: 20px;\n  \n      &-brand {\n        color: white;\n        font-weight: bold;\n        font-size: 1.2rem;\n      }\n  \n      &-tabs {\n        display: flex;\n        gap: 20px;\n        margin-top: 10px;\n      }\n  \n      &-tab {\n        color: white;\n        padding: 8px 16px;\n        cursor: pointer;\n        border: none;\n        background: none;\n  \n        &--active {\n          background-color: #34495e;\n          border-radius: 4px;\n        }\n      }\n    }\n  \n    &__quality {\n      margin-bottom: 20px;\n      \n      &-input {\n        background-color: #f5f5f5;\n        text-align: center;\n        padding: 5px;\n        border: 1px solid #ddd;\n      }\n    }\n  \n    &__status {\n      color: #e74c3c;\n      text-align: center;\n      margin-bottom: 15px;\n    }\n  \n    &__card {\n      border: 1px solid #ddd;\n      border-radius: 8px;\n      padding: 20px;\n      background-color: white;\n      box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  \n      &-title {\n        font-size: 1.5rem;\n        margin-bottom: 20px;\n        padding-bottom: 10px;\n        border-bottom: 1px solid #eee;\n      }\n    }\n  \n    &__image {\n      display: block;\n      margin: 0 auto 20px;\n      max-width: 100%;\n      height: auto;\n    }\n  \n    &__controls {\n      display: flex;\n      justify-content: center;\n      gap: 15px;\n      margin-bottom: 20px;\n    }\n  \n    &__button {\n      padding: 8px 16px;\n      border: none;\n      border-radius: 4px;\n      background-color: #3498db;\n      color: white;\n      cursor: pointer;\n  \n      &:hover {\n        background-color: #2980b9;\n      }\n  \n      &:disabled {\n        background-color: #bdc3c7;\n        cursor: not-allowed;\n      }\n    }\n  \n    &__gallery {\n      display: grid;\n      grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n      gap: 15px;\n      margin-top: 20px;\n  \n      &-image {\n        width: 100%;\n        height: auto;\n        border-radius: 4px;\n      }\n    }\n  \n    &__reader {\n      &-select {\n        width: 100%;\n        padding: 8px;\n        margin-bottom: 20px;\n        border: 1px solid #ddd;\n        border-radius: 4px;\n      }\n    }\n  }",".meal-status {\n    margin-top: 2rem;\n    padding: 1rem;\n    border-radius: 8px;\n    background-color: #f8f9fa;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  }\n  \n  .meal-status h2 {\n    margin-bottom: 1rem;\n    color: #333;\n    font-size: 1.25rem;\n  }\n  \n  .meal-records {\n    display: grid;\n    gap: 1rem;\n  }\n  \n  .meal-record {\n    display: flex;\n    justify-content: space-between;\n    padding: 0.5rem;\n    border-bottom: 1px solid #e9ecef;\n  }\n  \n  .recorded {\n    color: #28a745;\n    font-weight: bold;\n  }\n  \n  .not-recorded {\n    color: #dc3545;\n    font-weight: bold;\n  }\n  \n  .alert {\n    padding: 1rem;\n    margin-bottom: 1rem;\n    border-radius: 4px;\n  }\n  \n  .alert-success {\n    background-color: #d4edda;\n    color: #155724;\n    border: 1px solid #c3e6cb;\n  }\n  \n  .alert-error {\n    background-color: #f8d7da;\n    color: #721c24;\n    border: 1px solid #f5c6cb;\n  }\n  \n  .loading {\n    text-align: center;\n    padding: 2rem;\n    font-size: 1.25rem;\n    color: #666;\n  }\n\n  /* Add to your existing stylesheet */\n\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n  }\n  \n  .modal-content {\n    background: white;\n    padding: 2rem;\n    border-radius: 8px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    max-width: 400px;\n    width: 90%;\n    animation: slideIn 0.3s ease-out;\n  }\n  \n  .modal-status {\n    text-align: center;\n  }\n  \n  .modal-status.success .modal-icon {\n    background-color: #28a745;\n  }\n  \n  .modal-status.error .modal-icon {\n    background-color: #dc3545;\n  }\n  \n  .modal-icon {\n    width: 60px;\n    height: 60px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto 1rem;\n    color: white;\n    font-size: 2rem;\n  }\n  \n  .modal-title {\n    margin-bottom: 1rem;\n    color: #333;\n    font-size: 1.5rem;\n  }\n  .modal-title-big {\n    margin-bottom: 2.4rem;\n    color: #333;\n    font-size: 2.4rem;\n    font-weight: 700;\n  }\n  \n  .modal-message {\n    margin-bottom: 1.5rem;\n    color: #666;\n    line-height: 1.4;\n  }\n  \n  .modal-close {\n    background-color: #007bff;\n    color: white;\n    border: none;\n    padding: 0.5rem 1.5rem;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 1rem;\n    transition: background-color 0.2s;\n  }\n  \n  .modal-close:hover {\n    background-color: #0056b3;\n  }\n  \n  @keyframes slideIn {\n    from {\n      transform: translateY(-20px);\n      opacity: 0;\n    }\n    to {\n      transform: translateY(0);\n      opacity: 1;\n    }\n  }","@import '../utils/variables';\n\n.issue-report {\n  min-height: 100vh;\n  background-color: $color-gray-50;\n  padding: 48px 16px;\n\n  @media (max-width: $phone) {\n    padding: 24px 16px;\n  }\n\n  &__container {\n    max-width: 900px;\n    margin: 0 auto;\n    background-color: $color-white;\n    border-radius: 12px;\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);\n    padding: 32px;\n\n    @media (max-width: $phone) {\n      padding: 24px 16px;\n      border-radius: 8px;\n    }\n  }\n\n  &__header {\n    margin-bottom: 32px;\n    text-align: center;\n\n    &-title {\n      font-size: 28px;\n      font-weight: 700;\n      color: $color-gray-900;\n      margin-bottom: 16px;\n\n      @media (max-width: $phone) {\n        font-size: 20px;\n      }\n    }\n\n    &-subtitle {\n      font-size: 16px;\n      color: $color-gray-600;\n      line-height: 1.6;\n      margin-bottom: 16px;\n\n      @media (max-width: $phone) {\n        font-size: 14px;\n      }\n    }\n\n    &-warning {\n      background-color: #fff3cd;\n      border: 1px solid #ffc107;\n      border-radius: 8px;\n      padding: 16px;\n      font-size: 14px;\n      color: #856404;\n      text-align: left;\n      margin-top: 16px;\n\n      a {\n        color: #856404;\n        text-decoration: underline;\n        font-weight: 600;\n      }\n\n      strong {\n        font-weight: 700;\n      }\n    }\n  }\n\n  &__type-selection {\n    text-align: center;\n    padding: 32px 0;\n\n    &-title {\n      font-size: 20px;\n      font-weight: 600;\n      color: $color-gray-900;\n      margin-bottom: 24px;\n    }\n  }\n\n  &__type-buttons {\n    display: flex;\n    gap: 16px;\n    justify-content: center;\n    flex-wrap: wrap;\n\n    @media (max-width: $phone) {\n      flex-direction: column;\n    }\n  }\n\n  &__type-button {\n    padding: 16px 32px;\n    font-size: 16px;\n    font-weight: 600;\n    color: $color-white;\n    background-color: $color-primary;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    min-width: 200px;\n\n    &:hover {\n      background-color: $color-primary-dark;\n      transform: translateY(-2px);\n      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n    }\n\n    &:active {\n      transform: translateY(0);\n    }\n\n    @media (max-width: $phone) {\n      width: 100%;\n      min-width: unset;\n    }\n  }\n\n  &__back {\n    margin-bottom: 24px;\n  }\n\n  &__back-button {\n    background: none;\n    border: none;\n    color: $color-primary;\n    font-size: 14px;\n    cursor: pointer;\n    padding: 8px 0;\n    font-weight: 500;\n    transition: color 0.2s ease;\n\n    &:hover {\n      color: $color-primary-dark;\n      text-decoration: underline;\n    }\n  }\n\n  &__form {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n  }\n\n  &__form-section {\n    margin-bottom: 8px;\n    padding-bottom: 16px;\n    border-bottom: 2px solid $color-gray-200;\n\n    &:last-of-type {\n      border-bottom: none;\n      margin-top: 24px;\n    }\n  }\n\n  &__section-title {\n    font-size: 22px;\n    font-weight: 600;\n    color: $color-gray-900;\n    margin-bottom: 8px;\n  }\n\n  &__section-description {\n    font-size: 14px;\n    color: $color-gray-600;\n    line-height: 1.6;\n    margin-top: 8px;\n  }\n\n  &__form-group {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n\n    &--full {\n      grid-column: 1 / -1;\n    }\n  }\n\n  &__form-label {\n    font-size: 14px;\n    font-weight: 500;\n    color: $color-gray-700;\n    display: block;\n\n    .required {\n      color: $color-danger;\n      margin-left: 4px;\n    }\n  }\n\n  &__form-note {\n    font-size: 12px;\n    color: $color-gray-600;\n    font-style: italic;\n    margin-top: 4px;\n    line-height: 1.5;\n  }\n\n  &__form-input {\n    width: 100%;\n    padding: 10px 12px;\n    background-color: $color-white;\n    border: 1px solid $color-gray-300;\n    border-radius: 6px;\n    font-size: 14px;\n    color: $color-gray-900;\n    transition: border-color 0.2s ease;\n\n    &:focus {\n      outline: none;\n      border-color: $color-primary;\n      box-shadow: 0 0 0 3px rgba($color-primary, 0.1);\n    }\n\n    &:disabled {\n      background-color: $color-gray-50;\n      cursor: not-allowed;\n    }\n  }\n\n  &__form-textarea {\n    width: 100%;\n    padding: 10px 12px;\n    background-color: $color-white;\n    border: 1px solid $color-gray-300;\n    border-radius: 6px;\n    font-size: 14px;\n    color: $color-gray-900;\n    font-family: inherit;\n    resize: vertical;\n    transition: border-color 0.2s ease;\n\n    &:focus {\n      outline: none;\n      border-color: $color-primary;\n      box-shadow: 0 0 0 3px rgba($color-primary, 0.1);\n    }\n  }\n\n  &__form-radio-group {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    margin-top: 8px;\n  }\n\n  &__form-radio {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n    font-size: 14px;\n    color: $color-gray-700;\n\n    input[type=\"radio\"] {\n      width: 18px;\n      height: 18px;\n      cursor: pointer;\n      accent-color: $color-primary;\n    }\n\n    span {\n      user-select: none;\n    }\n\n    &:hover {\n      color: $color-gray-900;\n    }\n  }\n\n  &__form-checkbox-group {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    margin-top: 8px;\n    padding: 16px;\n    background-color: $color-gray-50;\n    border-radius: 6px;\n  }\n\n  &__form-checkbox {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n    font-size: 14px;\n    color: $color-gray-700;\n\n    input[type=\"checkbox\"] {\n      width: 18px;\n      height: 18px;\n      cursor: pointer;\n      accent-color: $color-primary;\n    }\n\n    span {\n      user-select: none;\n    }\n\n    &:hover {\n      color: $color-gray-900;\n    }\n  }\n\n  &__form-actions {\n    margin-top: 32px;\n    display: flex;\n    justify-content: center;\n    padding-top: 24px;\n    border-top: 1px solid $color-gray-200;\n  }\n\n  &__form-submit {\n    padding: 14px 48px;\n    font-size: 16px;\n    font-weight: 600;\n    color: $color-white;\n    background-color: $color-primary;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    min-width: 180px;\n\n    &:hover:not(:disabled) {\n      background-color: $color-primary-dark;\n      transform: translateY(-2px);\n      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n    }\n\n    &:active:not(:disabled) {\n      transform: translateY(0);\n    }\n\n    &:disabled {\n      opacity: 0.6;\n      cursor: not-allowed;\n    }\n  }\n}\n\n","@import '../utils/variables';\n\n.qrcode-display {\n  min-height: 100vh;\n  background-color: $color-gray-50;\n  padding: 48px 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  @media (max-width: $phone) {\n    padding: 24px 16px;\n  }\n\n  &__container {\n    max-width: 600px;\n    width: 100%;\n    background-color: $color-white;\n    border-radius: 12px;\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);\n    padding: 48px 32px;\n\n    @media (max-width: $phone) {\n      padding: 32px 24px;\n      border-radius: 8px;\n    }\n  }\n\n  &__header {\n    text-align: center;\n    margin-bottom: 40px;\n\n    &-title {\n      font-size: 28px;\n      font-weight: 700;\n      color: $color-gray-900;\n      margin-bottom: 12px;\n\n      @media (max-width: $phone) {\n        font-size: 22px;\n      }\n    }\n\n    &-subtitle {\n      font-size: 16px;\n      color: $color-gray-600;\n      line-height: 1.6;\n\n      @media (max-width: $phone) {\n        font-size: 14px;\n      }\n    }\n  }\n\n  &__content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 32px;\n  }\n\n  &__qr-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 24px;\n    background-color: $color-white;\n    border: 2px solid $color-gray-200;\n    border-radius: 12px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  }\n\n  &__qr-image {\n    width: 100%;\n    max-width: 400px;\n    height: auto;\n    display: block;\n  }\n\n  &__qr-loading {\n    padding: 40px;\n    color: $color-gray-600;\n    font-size: 16px;\n    text-align: center;\n  }\n\n  &__info {\n    text-align: center;\n    width: 100%;\n  }\n\n  &__info-text {\n    font-size: 14px;\n    color: $color-gray-700;\n    margin-bottom: 12px;\n    word-break: break-all;\n\n    strong {\n      font-weight: 600;\n      color: $color-gray-900;\n    }\n  }\n\n  &__info-link {\n    color: $color-primary;\n    text-decoration: none;\n    word-break: break-all;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  &__info-instruction {\n    font-size: 14px;\n    color: $color-gray-600;\n    font-style: italic;\n    margin-top: 8px;\n  }\n\n  &__actions {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n  }\n\n  &__actions-button {\n    padding: 14px 32px;\n    font-size: 16px;\n    font-weight: 600;\n    color: $color-white;\n    background-color: $color-primary;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    min-width: 200px;\n\n    &:hover {\n      background-color: $color-primary-dark;\n      transform: translateY(-2px);\n      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n    }\n\n    &:active {\n      transform: translateY(0);\n    }\n\n    @media (max-width: $phone) {\n      width: 100%;\n      min-width: unset;\n    }\n  }\n}\n\n","// Food Poll Management Styles\n.food-poll-management {\n  padding: 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n\n  &__header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 2rem;\n    padding-bottom: 1rem;\n    border-bottom: 2px solid #e9ecef;\n  }\n\n  &__title {\n    font-size: 1.75rem;\n    font-weight: 600;\n    color: #333;\n    margin: 0;\n  }\n\n  &__subtitle {\n    color: #666;\n    margin: 0.5rem 0 0;\n  }\n\n  &__create-btn {\n    background-color: #FA9411;\n    color: white;\n    border: none;\n    padding: 0.75rem 1.5rem;\n    border-radius: 6px;\n    font-size: 1rem;\n    cursor: pointer;\n    transition: background-color 0.2s;\n\n    &:hover {\n      background-color: #e8840f;\n    }\n  }\n\n  &__filters {\n    display: flex;\n    gap: 1rem;\n    margin-bottom: 2rem;\n  }\n\n  &__filter {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n\n    span {\n      font-weight: 500;\n      color: #333;\n    }\n\n    input,\n    select {\n      padding: 0.5rem;\n      border: 1px solid #ddd;\n      border-radius: 4px;\n      font-size: 1rem;\n    }\n  }\n\n  &__error {\n    background-color: #f8d7da;\n    color: #721c24;\n    padding: 1rem;\n    border-radius: 4px;\n    margin-bottom: 1rem;\n  }\n\n  &__loading {\n    text-align: center;\n    padding: 2rem;\n    color: #666;\n  }\n\n  &__empty {\n    text-align: center;\n    padding: 3rem;\n    color: #666;\n    background-color: #f8f9fa;\n    border-radius: 8px;\n  }\n\n  &__polls {\n    display: grid;\n    gap: 1.5rem;\n  }\n\n  &__poll-card {\n    background: white;\n    border: 1px solid #e9ecef;\n    border-radius: 8px;\n    padding: 1.5rem;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  }\n\n  &__poll-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 1rem;\n    padding-bottom: 1rem;\n    border-bottom: 1px solid #e9ecef;\n\n    h3 {\n      margin: 0;\n      font-size: 1.25rem;\n      color: #333;\n    }\n  }\n\n  &__status {\n    padding: 0.25rem 0.75rem;\n    border-radius: 12px;\n    font-size: 0.875rem;\n    font-weight: 500;\n\n    &.active {\n      background-color: #d4edda;\n      color: #155724;\n    }\n\n    &.inactive {\n      background-color: #f8d7da;\n      color: #721c24;\n    }\n  }\n\n  &__poll-actions {\n    display: flex;\n    gap: 0.5rem;\n  }\n\n  &__btn {\n    padding: 0.5rem 1rem;\n    border: none;\n    border-radius: 4px;\n    font-size: 0.875rem;\n    cursor: pointer;\n    transition: all 0.2s;\n\n    &.results {\n      background-color: #007bff;\n      color: white;\n\n      &:hover {\n        background-color: #0056b3;\n      }\n    }\n\n    &.toggle {\n      background-color: #6c757d;\n      color: white;\n\n      &:hover {\n        background-color: #5a6268;\n      }\n    }\n\n    &.delete {\n      background-color: #dc3545;\n      color: white;\n\n      &:hover {\n        background-color: #c82333;\n      }\n    }\n  }\n\n  &__poll-options {\n    h4 {\n      margin: 0 0 0.5rem;\n      font-size: 1rem;\n      color: #333;\n    }\n\n    ul {\n      list-style: none;\n      padding: 0;\n      margin: 0 0 1rem;\n\n      li {\n        padding: 0.5rem 0;\n        border-bottom: 1px solid #f0f0f0;\n        color: #666;\n      }\n    }\n  }\n\n  &__total-votes {\n    margin: 1rem 0 0;\n    font-weight: 600;\n    color: #333;\n  }\n\n  &__modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n  }\n\n  &__modal {\n    background: white;\n    padding: 2rem;\n    border-radius: 8px;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n    max-width: 600px;\n    width: 90%;\n    max-height: 90vh;\n    overflow-y: auto;\n\n    &.large {\n      max-width: 900px;\n    }\n\n    h3 {\n      margin: 0 0 1.5rem;\n      font-size: 1.5rem;\n      color: #333;\n    }\n\n    label {\n      display: block;\n      margin-bottom: 1rem;\n\n      span {\n        display: block;\n        margin-bottom: 0.5rem;\n        font-weight: 500;\n        color: #333;\n      }\n\n      input,\n      select {\n        width: 100%;\n        padding: 0.5rem;\n        border: 1px solid #ddd;\n        border-radius: 4px;\n        font-size: 1rem;\n      }\n    }\n  }\n\n  &__options-section {\n    margin: 1.5rem 0;\n  }\n\n  &__option-input {\n    display: flex;\n    gap: 0.5rem;\n    margin-bottom: 0.5rem;\n\n    input {\n      flex: 1;\n    }\n  }\n\n  &__add-option,\n  &__remove-option {\n    padding: 0.5rem 1rem;\n    border: 1px solid #ddd;\n    background-color: #f8f9fa;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 0.875rem;\n    transition: all 0.2s;\n\n    &:hover {\n      background-color: #e9ecef;\n    }\n  }\n\n  &__add-option {\n    margin-top: 0.5rem;\n    color: #007bff;\n    border-color: #007bff;\n  }\n\n  &__remove-option {\n    color: #dc3545;\n    border-color: #dc3545;\n  }\n\n  &__modal-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 1rem;\n    margin-top: 2rem;\n\n    button {\n      padding: 0.75rem 1.5rem;\n      border: none;\n      border-radius: 4px;\n      font-size: 1rem;\n      cursor: pointer;\n      transition: all 0.2s;\n\n      &[type=\"button\"] {\n        background-color: #6c757d;\n        color: white;\n\n        &:hover {\n          background-color: #5a6268;\n        }\n      }\n\n      &[type=\"submit\"] {\n        background-color: #FA9411;\n        color: white;\n\n        &:hover:not(:disabled) {\n          background-color: #e8840f;\n        }\n\n        &:disabled {\n          opacity: 0.6;\n          cursor: not-allowed;\n        }\n      }\n    }\n  }\n\n  &__results {\n    margin-top: 1.5rem;\n  }\n\n  &__results-summary {\n    margin-bottom: 2rem;\n\n    h4 {\n      margin: 0 0 1rem;\n      font-size: 1.125rem;\n      color: #333;\n    }\n\n    ul {\n      list-style: none;\n      padding: 0;\n      margin: 0 0 1rem;\n\n      li {\n        padding: 0.5rem 0;\n        border-bottom: 1px solid #f0f0f0;\n      }\n    }\n  }\n\n  &__results-votes {\n    table {\n      width: 100%;\n      border-collapse: collapse;\n      margin-top: 1rem;\n\n      th,\n      td {\n        padding: 0.75rem;\n        text-align: left;\n        border-bottom: 1px solid #e9ecef;\n      }\n\n      th {\n        background-color: #f8f9fa;\n        font-weight: 600;\n        color: #333;\n      }\n\n      td {\n        color: #666;\n      }\n    }\n  }\n}\n\n// Food Poll Voting Styles\n.food-poll-voting {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  padding: 2rem 1rem;\n\n  &__container {\n    max-width: 800px;\n    margin: 0 auto;\n    background: white;\n    border-radius: 12px;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n    padding: 2rem;\n  }\n\n  &__header {\n    text-align: center;\n    margin-bottom: 2rem;\n    padding-bottom: 1.5rem;\n    border-bottom: 2px solid #e9ecef;\n  }\n\n  &__title {\n    font-size: 2rem;\n    font-weight: 700;\n    color: #333;\n    margin: 0 0 0.5rem;\n  }\n\n  &__subtitle {\n    color: #666;\n    font-size: 1.125rem;\n    margin: 0;\n  }\n\n  &__filters {\n    display: flex;\n    gap: 1rem;\n    margin-bottom: 2rem;\n    flex-wrap: wrap;\n  }\n\n  &__filter {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    flex: 1;\n    min-width: 150px;\n\n    span {\n      font-weight: 500;\n      color: #333;\n    }\n\n    input,\n    select {\n      padding: 0.75rem;\n      border: 2px solid #e9ecef;\n      border-radius: 6px;\n      font-size: 1rem;\n      transition: border-color 0.2s;\n\n      &:focus {\n        outline: none;\n        border-color: #FA9411;\n      }\n    }\n  }\n\n  &__user-input {\n    margin-bottom: 2rem;\n  }\n\n  &__user-label {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n\n    span {\n      font-weight: 500;\n      color: #333;\n    }\n\n    input {\n      padding: 0.75rem;\n      border: 2px solid #e9ecef;\n      border-radius: 6px;\n      font-size: 1rem;\n      transition: border-color 0.2s;\n\n      &:focus {\n        outline: none;\n        border-color: #FA9411;\n      }\n\n      &:disabled {\n        background-color: #f8f9fa;\n        cursor: not-allowed;\n      }\n    }\n  }\n\n  &__error {\n    background-color: #f8d7da;\n    color: #721c24;\n    padding: 1rem;\n    border-radius: 6px;\n    margin-bottom: 1rem;\n  }\n\n  &__loading {\n    text-align: center;\n    padding: 3rem;\n    color: #666;\n    font-size: 1.125rem;\n  }\n\n  &__no-poll {\n    text-align: center;\n    padding: 3rem;\n    color: #666;\n    background-color: #f8f9fa;\n    border-radius: 8px;\n  }\n\n  &__poll {\n    margin-top: 2rem;\n  }\n\n  &__poll-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 2rem;\n    padding-bottom: 1rem;\n    border-bottom: 2px solid #e9ecef;\n\n    h2 {\n      margin: 0;\n      font-size: 1.5rem;\n      color: #333;\n    }\n  }\n\n  &__total-votes {\n    color: #666;\n    font-size: 0.875rem;\n  }\n\n  &__voted-message {\n    background-color: #d4edda;\n    color: #155724;\n    padding: 1.5rem;\n    border-radius: 8px;\n    margin-bottom: 2rem;\n    text-align: center;\n\n    p {\n      margin: 0.5rem 0;\n      font-size: 1.125rem;\n\n      strong {\n        color: #0f5132;\n      }\n    }\n  }\n\n  &__options {\n    margin-bottom: 2rem;\n  }\n\n  &__options h3 {\n    margin: 0 0 1.5rem;\n    font-size: 1.25rem;\n    color: #333;\n  }\n\n  &__options-list {\n    display: grid;\n    gap: 1rem;\n    margin-bottom: 2rem;\n  }\n\n  &__option {\n    display: flex;\n    align-items: center;\n    padding: 1.25rem;\n    border: 2px solid #e9ecef;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.2s;\n    background-color: white;\n\n    &:hover:not(.selected) {\n      border-color: #FA9411;\n      background-color: #fff9f0;\n    }\n\n    &.selected {\n      border-color: #FA9411;\n      background-color: #fff9f0;\n    }\n\n    input[type=\"radio\"] {\n      margin-right: 1rem;\n      width: 20px;\n      height: 20px;\n      cursor: pointer;\n    }\n  }\n\n  &__option-content {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex: 1;\n  }\n\n  &__option-name {\n    font-size: 1.125rem;\n    font-weight: 500;\n    color: #333;\n  }\n\n  &__option-votes {\n    font-size: 0.875rem;\n    color: #666;\n  }\n\n  &__submit-btn {\n    width: 100%;\n    padding: 1rem;\n    background-color: #FA9411;\n    color: white;\n    border: none;\n    border-radius: 8px;\n    font-size: 1.125rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background-color 0.2s;\n\n    &:hover:not(:disabled) {\n      background-color: #e8840f;\n    }\n\n    &:disabled {\n      opacity: 0.6;\n      cursor: not-allowed;\n    }\n  }\n\n  &__results {\n    margin-top: 2rem;\n    padding-top: 2rem;\n    border-top: 2px solid #e9ecef;\n\n    h3 {\n      margin: 0 0 1.5rem;\n      font-size: 1.25rem;\n      color: #333;\n    }\n  }\n\n  &__results-list {\n    display: grid;\n    gap: 1rem;\n  }\n\n  &__result-item {\n    margin-bottom: 1rem;\n  }\n\n  &__result-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 0.5rem;\n  }\n\n  &__result-name {\n    font-weight: 500;\n    color: #333;\n  }\n\n  &__result-count {\n    font-size: 0.875rem;\n    color: #666;\n  }\n\n  &__result-bar {\n    height: 24px;\n    background-color: #e9ecef;\n    border-radius: 12px;\n    overflow: hidden;\n  }\n\n  &__result-fill {\n    height: 100%;\n    background: linear-gradient(90deg, #FA9411 0%, #e8840f 100%);\n    transition: width 0.3s ease;\n  }\n}\n\n// Food Page Tabs\n.food-page__tabs {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 2rem;\n  border-bottom: 2px solid #e9ecef;\n}\n\n.food-page__tab {\n  padding: 0.75rem 1.5rem;\n  background: none;\n  border: none;\n  border-bottom: 3px solid transparent;\n  font-size: 1rem;\n  font-weight: 500;\n  color: #666;\n  cursor: pointer;\n  transition: all 0.2s;\n\n  &:hover {\n    color: #FA9411;\n  }\n\n  &.active {\n    color: #FA9411;\n    border-bottom-color: #FA9411;\n  }\n}\n\n","\n\n\n.admin-login {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: $color-gray-50;\n  padding: 16px;\n\n  &__container {\n    width: 100%;\n    max-width: 400px;\n    background-color: $color-white;\n    border-radius: 8px;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n  }\n\n  &__header {\n    padding: 32px 24px;\n    text-align: center;\n    border-bottom: 1px solid $color-gray-200;\n\n    &-logo {\n      width: 48px;\n      height: 48px;\n      margin: 0 auto 16px;\n      color: $color-primary;\n    }\n\n    &-title {\n      font-size: 24px;\n      font-weight: 700;\n      color: $color-gray-900;\n      margin-bottom: 8px;\n    }\n\n    &-subtitle {\n      font-size: 14px;\n      color: $color-gray-600;\n    }\n  }\n\n  &__form {\n    padding: 24px;\n\n    &-group {\n      margin-bottom: 20px;\n    }\n\n    &-label {\n      display: block;\n      font-size: 14px;\n      font-weight: 500;\n      color: $color-gray-700;\n      margin-bottom: 8px;\n    }\n\n    &-input {\n      width: 100%;\n      padding: 10px 12px;\n      font-size: 14px;\n      border: 1px solid $color-gray-300;\n      border-radius: 6px;\n      background-color: $color-white;\n      transition: all 0.2s;\n\n      &:focus {\n        @include input-focus;\n      }\n\n      &::placeholder {\n        color: $color-gray-600;\n      }\n\n      &--error {\n        border-color: $color-danger;\n        background-color: rgba($color-danger, 0.05);\n      }\n    }\n\n    &-error {\n      color: $color-danger;\n      font-size: 12px;\n      margin-top: 4px;\n    }\n\n    &-forgot {\n      display: block;\n      text-align: right;\n      font-size: 14px;\n      color: $color-primary;\n      text-decoration: none;\n      margin-bottom: 24px;\n\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n\n    &-submit {\n      width: 100%;\n      padding: 12px;\n      background-color: $color-primary;\n      color: $color-white;\n      font-size: 16px;\n      font-weight: 500;\n      border: none;\n      border-radius: 6px;\n      cursor: pointer;\n      transition: background-color 0.2s;\n\n      &:hover {\n        background-color: $color-primary-dark;\n      }\n\n      &:disabled {\n        background-color: $color-gray-300;\n        cursor: not-allowed;\n      }\n    }\n  }\n\n  &__alert {\n    margin: 0 24px 16px;\n    padding: 12px;\n    border-radius: 6px;\n    font-size: 14px;\n\n    &--error {\n      background-color: rgba($color-danger, 0.1);\n      color: $color-danger;\n    }\n\n    &--success {\n      background-color: rgba($color-success, 0.1);\n      color: $color-success;\n    }\n  }\n}","@mixin input-focus {\n  outline: none;\n  border-color: $color-primary;\n  box-shadow: 0 0 0 2px rgba($color-primary, 0.1);\n}",".users-list {\n  padding: 32px;\n  @media (max-width: $phone) {\n    padding: 32px 0;\n  }\n\n  &__header {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    margin-bottom: 32px;\n  }\n\n  &__title {\n    font-size: 24px;\n    font-weight: 600;\n    color: #2d3748;\n  }\n\n  &__subtitle {\n    margin-top: 4px;\n    font-size: 14px;\n    color: #718096;\n  }\n\n  &__error {\n    margin-bottom: 16px;\n    padding: 12px 16px;\n    background-color: rgba(229, 62, 62, 0.08);\n    border: 1px solid rgba(229, 62, 62, 0.24);\n    border-radius: 6px;\n    color: #c53030;\n  }\n  &__registered {\n    font-size: 20px;\n    font-weight: 600;\n    color: #2d3748;\n\n    & > span {\n      color: $color-success;\n    }\n  }\n\n  &__search-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 16px;\n    flex-wrap: wrap;\n  }\n\n  &__search-wrapper {\n    width: 100%;\n    display: flex;\n    gap: 8px;\n    flex: 1;\n    max-width: 600px;\n    align-items: center;\n    flex-wrap: wrap;\n  }\n  &__search-wrapper-filters {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;\n    max-width: 100%;\n  }\n\n  &__search-input {\n    flex: 1;\n    padding: 8px 16px;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    font-size: 14px;\n    transition: border-color 0.15s ease-in-out;\n\n    &:focus {\n      outline: none;\n      border-color: #FA9411;\n      box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.15);\n    }\n  }\n\n  &__search-type {\n    padding: 8px 32px 8px 16px;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    background-color: white;\n    font-size: 14px;\n    cursor: pointer;\n    transition: border-color 0.15s ease-in-out;\n\n    &:focus {\n      outline: none;\n      border-color: #FA9411;\n      box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.15);\n    }\n  }\n\n  &__add-button {\n    padding: 8px 16px;\n    background-color: $color-primary;\n    color: white;\n    border: none;\n    border-radius: 6px;\n    font-size: 14px;\n    cursor: pointer;\n    transition: background-color 0.15s ease-in-out;\n\n    &:hover {\n      background-color: darken($color-primary, 8%);\n    }\n  }\n\n  &__table-container {\n    background-color: white;\n    border-radius: 8px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    overflow-x: auto;\n    height: 600px;\n    overflow-y: auto;\n  }\n\n  &__table {\n    width: 100%;\n    border-collapse: collapse;\n\n    th, td {\n      padding: 16px;\n      text-align: left;\n      border-bottom: 1px solid #e2e8f0;\n    }\n\n    th {\n      background-color: #f7fafc;\n      font-weight: 600;\n      color: #4a5568;\n    }\n\n    tr:hover {\n      background-color: #f7fafc;\n    }\n  }\n\n  &__loading {\n    padding: 32px;\n    text-align: center;\n    color: #4a5568;\n  }\n\n  &__dropdown {\n    position: relative;\n  }\n\n  &__dropdown-trigger {\n    padding: 4px 8px;\n    background: none;\n    border: none;\n    cursor: pointer;\n    font-size: 20px;\n    color: #4a5568;\n    transition: color 0.15s ease-in-out;\n\n    &:hover {\n      color: #2d3748;\n    }\n  }\n\n  &__dropdown-menu {\n    position: absolute;\n    right: 0;\n    top: 100%;\n    width: 200px;\n    background-color: white;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n    z-index: 10;\n  }\n\n  &__dropdown-item {\n    display: block;\n    padding: 12px 16px;\n    color: #4a5568;\n    text-decoration: none;\n    transition: background-color 0.15s ease-in-out;\n\n    &:hover {\n      background-color: #f7fafc;\n      color: #2d3748;\n    }\n\n    &:not(:last-child) {\n      border-bottom: 1px solid #e2e8f0;\n    }\n  }\n\n  &__pagination {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 16px;\n    border-top: 1px solid #e2e8f0;\n    background-color: #f7fafc;\n    border-radius: 0 0 8px 8px;\n  }\n\n  &__pagination-button {\n    padding: 8px 16px;\n    background-color: white;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    font-size: 14px;\n    color: #4a5568;\n    cursor: pointer;\n    transition: all 0.15s ease-in-out;\n\n    &:hover:not(:disabled) {\n      background-color: #f7fafc;\n      border-color: #FA9411;\n      color: #FA9411;\n    }\n\n    &:focus {\n      outline: none;\n      box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.15);\n    }\n\n    &:disabled {\n      background-color: #edf2f7;\n      color: #a0aec0;\n      cursor: not-allowed;\n    }\n\n    &:not(:last-child) {\n      margin-right: 8px;\n    }\n  }\n\n  &__pagination-info {\n    display: flex;\n    align-items: center;\n    font-size: 14px;\n    color: #4a5568;\n    margin: 0 16px;\n  }\n\n  &__pagination-total {\n    font-size: 14px;\n    color: #718096;\n  }\n\n  &__meals {\n    display: flex;\n    gap: 20px;\n    font-weight: 500;\n\n    & > div {\n      & > span {\n        color: #FA9411;\n        font-weight: 700;\n      }\n    }\n  }\n}\n\n.camp-status-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 6px 12px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border: 1px solid transparent;\n  margin-bottom: 14px;\n\n  &--in {\n    background-color: rgba(56, 161, 105, 0.15);\n    color: #22543d;\n    border-color: rgba(56, 161, 105, 0.3);\n  }\n\n  &--out {\n    background-color: rgba(229, 62, 62, 0.15);\n    color: #742a2a;\n    border-color: rgba(229, 62, 62, 0.3);\n  }\n}\n\n.users-list__camp-summary {\n  margin-bottom: 32px;\n  padding: 24px;\n  background-color: #ffffff;\n  border-radius: 12px;\n  border: 1px solid #edf2f7;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n\n  &-header {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: center;\n    gap: 16px;\n    margin-bottom: 20px;\n  }\n\n  &-date {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    font-size: 13px;\n    color: #4a5568;\n\n    input {\n      padding: 8px 12px;\n      border: 1px solid #e2e8f0;\n      border-radius: 8px;\n      font-size: 14px;\n      transition: border-color 0.15s ease-in-out;\n\n      &:focus {\n        outline: none;\n        border-color: #fa9411;\n        box-shadow: 0 0 0 3px rgba(250, 148, 17, 0.15);\n      }\n    }\n  }\n\n  &-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 16px;\n  }\n\n  &-card {\n    padding: 16px;\n    background-color: #f7fafc;\n    border-radius: 10px;\n    border: 1px solid #e2e8f0;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  &-label {\n    font-size: 12px;\n    font-weight: 600;\n    text-transform: uppercase;\n    color: #718096;\n    letter-spacing: 0.4px;\n  }\n\n  &-value {\n    font-size: 24px;\n    font-weight: 700;\n    color: #2d3748;\n\n    &--in {\n      color: #22543d;\n    }\n\n    &--out {\n      color: #9b2c2c;\n    }\n  }\n}\n\n.camp-status-summary {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 16px;\n  padding: 16px;\n  background-color: #f7fafc;\n  border-radius: 8px;\n  border: 1px solid #edf2f7;\n  margin-bottom: 20px;\n\n  &__item {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  &__label {\n    font-size: 12px;\n    font-weight: 600;\n    text-transform: uppercase;\n    color: #718096;\n    letter-spacing: 0.4px;\n  }\n\n  &__value {\n    font-size: 14px;\n    font-weight: 500;\n    color: #2d3748;\n\n    &--in {\n      color: #22543d;\n    }\n\n    &--out {\n      color: #742a2a;\n    }\n  }\n}\n\n.camp-timeline {\n  margin-top: 24px;\n  padding: 16px;\n  background-color: #fff;\n  border: 1px solid #edf2f7;\n  border-radius: 8px;\n\n  &__title {\n    font-size: 14px;\n    font-weight: 600;\n    color: #2d3748;\n    margin-bottom: 12px;\n  }\n\n  &__list {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  &__item {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 12px;\n    border: 1px solid #edf2f7;\n    border-radius: 8px;\n\n    &--checkin {\n      background-color: rgba(56, 161, 105, 0.08);\n      border-color: rgba(56, 161, 105, 0.2);\n    }\n\n    &--checkout {\n      background-color: rgba(66, 153, 225, 0.08);\n      border-color: rgba(66, 153, 225, 0.2);\n    }\n  }\n\n  &__icon {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    background-color: #fff;\n    border: 1px solid currentColor;\n  }\n\n  &__label {\n    font-size: 13px;\n    font-weight: 600;\n    color: #2d3748;\n  }\n\n  &__type {\n    font-size: 12px;\n    font-weight: 500;\n    color: #4a5568;\n  }\n}\n\n.camp-daily-checkins {\n  margin-top: 16px;\n}\n\n.meal-history-modal {\n  max-height: 400px;\n  overflow-y: auto;\n\n  p {\n    margin: 0;\n    color: #4a5568;\n  }\n\n  &__table {\n    width: 100%;\n    border-collapse: collapse;\n\n    th,\n    td {\n      padding: 8px 12px;\n      border-bottom: 1px solid #e2e8f0;\n      text-align: left;\n      font-size: 13px;\n    }\n\n    th {\n      background-color: #f7fafc;\n      font-weight: 600;\n      color: #2d3748;\n    }\n\n    tr:nth-child(even) {\n      background-color: #ffffff;\n    }\n  }\n}\n\n.modal-message--custom {\n  width: 100%;\n}\n\n.accommodation {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n\n  &__header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 16px;\n  }\n\n  &__title {\n    font-size: 24px;\n    font-weight: 600;\n    color: #2d3748;\n  }\n\n  &__subtitle {\n    font-size: 14px;\n    color: #718096;\n    margin-top: 4px;\n  }\n\n  &__notice {\n    padding: 20px;\n    border-radius: 12px;\n    background-color: rgba(237, 137, 54, 0.12);\n    border: 1px solid rgba(237, 137, 54, 0.3);\n    color: #b45309;\n  }\n\n  &__overview {\n    background-color: #fff;\n    border: 1px solid #edf2f7;\n    border-radius: 12px;\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  &__overview-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 16px;\n    flex-wrap: wrap;\n\n    h3 {\n      margin: 0;\n      font-size: 18px;\n      font-weight: 600;\n      color: #2d3748;\n    }\n\n    p {\n      margin: 4px 0 0;\n      font-size: 13px;\n      color: #4a5568;\n    }\n  }\n\n  &__overview-refresh {\n    padding: 8px 14px;\n    border-radius: 8px;\n    border: 1px solid #cbd5f5;\n    background-color: #fff;\n    cursor: pointer;\n    font-size: 13px;\n    color: #2d3748;\n    transition: background-color 0.15s ease;\n\n    &:hover:not(:disabled) {\n      background-color: #edf2f7;\n    }\n\n    &:disabled {\n      opacity: 0.6;\n      cursor: not-allowed;\n    }\n  }\n\n  &__overview-error {\n    padding: 12px;\n    border-radius: 10px;\n    background-color: rgba(229, 62, 62, 0.12);\n    border: 1px solid rgba(229, 62, 62, 0.3);\n    color: #9b2c2c;\n    font-size: 13px;\n  }\n\n  &__overview-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n    gap: 16px;\n  }\n\n  &__overview-card {\n    padding: 18px;\n    border-radius: 12px;\n    border: 1px solid #e2e8f0;\n    background-color: #f7fafc;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n\n    strong {\n      font-size: 24px;\n      font-weight: 700;\n      color: #2d3748;\n    }\n  }\n\n  &__overview-label {\n    font-size: 12px;\n    text-transform: uppercase;\n    letter-spacing: 0.08em;\n    color: #718096;\n  }\n\n  &__rooms-section {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    background-color: #fff;\n    border: 1px solid #edf2f7;\n    border-radius: 12px;\n    padding: 20px;\n  }\n\n  &__rooms-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 12px;\n    font-size: 14px;\n    color: #4a5568;\n\n    h3 {\n      font-size: 16px;\n      font-weight: 600;\n      margin: 0;\n    }\n  }\n\n  &__rooms-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));\n    gap: 16px;\n  }\n\n  &__room-seat {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    padding: 18px;\n    border-radius: 16px;\n    border: 1px solid rgba(203, 213, 224, 0.7);\n    background: linear-gradient(145deg, #f8fafc 0%, #ffffff 100%);\n    box-shadow: 0 6px 18px rgba(15, 23, 42, 0.08);\n    cursor: pointer;\n    transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n\n    &:hover {\n      transform: translateY(-4px);\n      box-shadow: 0 12px 24px rgba(15, 23, 42, 0.12);\n      border-color: $color-primary;\n    }\n\n    &--active {\n      border-color: $color-primary;\n      box-shadow: 0 12px 28px rgba($color-primary, 0.25);\n      background: linear-gradient(\n        150deg,\n        rgba($color-primary, 0.18),\n        rgba(255, 255, 255, 0.95)\n      );\n    }\n\n    &--empty {\n      border-color: rgba(56, 161, 105, 0.35);\n    }\n\n    &--partial {\n      border-color: rgba(237, 137, 54, 0.35);\n    }\n\n    &--full {\n      border-color: rgba(229, 62, 62, 0.4);\n      background: linear-gradient(150deg, rgba(254, 215, 215, 0.5), rgba(255, 255, 255, 0.95));\n    }\n  }\n\n  &__room-seat-top {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 8px;\n  }\n\n  &__room-seat-name {\n    font-size: 16px;\n    font-weight: 600;\n    color: #1a202c;\n  }\n\n  &__room-seat-delete {\n    background: none;\n    border: none;\n    color: #c53030;\n    font-size: 18px;\n    line-height: 1;\n    cursor: pointer;\n    padding: 0 4px;\n    border-radius: 6px;\n\n    &:hover {\n      background-color: rgba(229, 62, 62, 0.12);\n    }\n  }\n\n  &__room-seat-meta {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 8px;\n    font-size: 13px;\n    color: #4a5568;\n  }\n\n  &__room-seat-description {\n    font-size: 12px;\n    color: #718096;\n  }\n\n  &__content {\n    display: grid;\n    grid-template-columns: minmax(0, 2.5fr) minmax(260px, 1fr);\n    gap: 24px;\n\n    @media (max-width: 1024px) {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  &__detail {\n    background-color: #fff;\n    border: 1px solid #edf2f7;\n    border-radius: 12px;\n    padding: 24px;\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n  }\n\n  &__detail-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 8px;\n\n    h3 {\n      margin: 0;\n      font-size: 18px;\n      font-weight: 600;\n      color: #2d3748;\n    }\n\n    span {\n      font-size: 14px;\n      color: #4a5568;\n    }\n  }\n\n  &__loading,\n  &__empty {\n    padding: 16px;\n    border-radius: 10px;\n    background-color: #f8fafc;\n    color: #4a5568;\n    text-align: center;\n  }\n\n  &__assignment {\n    margin-top: 0;\n    padding: 20px;\n    border-radius: 12px;\n    border: 1px solid #e2e8f0;\n    background-color: #f8fafc;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  &__assignment-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 12px;\n\n    h4 {\n      margin: 0;\n      font-size: 16px;\n      font-weight: 600;\n      color: #2d3748;\n    }\n\n    p {\n      margin: 4px 0 0;\n      font-size: 13px;\n      color: #4a5568;\n    }\n  }\n\n  &__assignment-search {\n    display: flex;\n    gap: 12px;\n\n    input {\n      flex: 1;\n      padding: 10px 12px;\n      border-radius: 8px;\n      border: 1px solid #cbd5f5;\n      font-size: 14px;\n    }\n\n    button {\n      padding: 10px 16px;\n      border-radius: 8px;\n      border: none;\n      background-color: $color-primary;\n      color: #fff;\n      font-weight: 600;\n      cursor: pointer;\n\n      &:disabled {\n        opacity: 0.6;\n        cursor: not-allowed;\n      }\n    }\n  }\n\n  &__assignment-error {\n    padding: 10px 12px;\n    border-radius: 8px;\n    background-color: rgba(229, 62, 62, 0.1);\n    border: 1px solid rgba(229, 62, 62, 0.4);\n    color: #9b2c2c;\n    font-size: 13px;\n  }\n\n  &__assignment-results {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n\n    li {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      gap: 12px;\n      padding: 12px;\n      border-radius: 10px;\n      border: 1px solid #e2e8f0;\n      background-color: #fff;\n\n      div {\n        display: flex;\n        flex-direction: column;\n        gap: 2px;\n\n        strong {\n          font-size: 14px;\n          color: #2d3748;\n        }\n\n        span {\n          font-size: 12px;\n          color: #4a5568;\n        }\n      }\n\n      button {\n        padding: 8px 12px;\n        border-radius: 8px;\n        border: none;\n        background-color: #2f855a;\n        color: #fff;\n        font-size: 13px;\n        cursor: pointer;\n\n        &:hover {\n          background-color: #276749;\n        }\n      }\n    }\n  }\n\n  &__current-assignments {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    padding: 20px;\n    border-radius: 12px;\n    border: 1px solid #e2e8f0;\n    background-color: #fff;\n  }\n\n  &__current-assignments-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 12px;\n\n    h4 {\n      margin: 0;\n      font-size: 16px;\n      font-weight: 600;\n      color: #2d3748;\n    }\n\n    p {\n      margin: 0;\n      font-size: 13px;\n      color: #4a5568;\n    }\n  }\n\n  &__assignment-status {\n    padding: 6px 12px;\n    border-radius: 999px;\n    font-size: 12px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n\n    &--available {\n      background-color: rgba(56, 161, 105, 0.12);\n      color: #276749;\n      border: 1px solid rgba(56, 161, 105, 0.4);\n    }\n\n    &--full {\n      background-color: rgba(229, 62, 62, 0.12);\n      color: #9b2c2c;\n      border: 1px solid rgba(229, 62, 62, 0.4);\n    }\n  }\n\n  &__assignment-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n    gap: 16px;\n  }\n\n  &__assignment-card {\n    display: flex;\n    align-items: flex-start;\n    flex-wrap: wrap;\n    gap: 14px;\n    padding: 16px;\n    border-radius: 12px;\n    border: 1px solid #e2e8f0;\n    background-color: #fefefe;\n    box-shadow: 0 4px 12px rgba(15, 23, 42, 0.05);\n  }\n\n  &__assignment-avatar {\n    width: 44px;\n    height: 44px;\n    border-radius: 50%;\n    background: linear-gradient(\n      135deg,\n      lighten($color-primary, 8%),\n      lighten($color-primary, 28%)\n    );\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 700;\n    color: #fff;\n    font-size: 16px;\n    flex-shrink: 0;\n  }\n\n  &__assignment-info {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n  }\n\n  &__assignment-name {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 8px;\n\n    span:first-child {\n      font-size: 16px;\n      font-weight: 600;\n      color: #1a202c;\n    }\n  }\n\n  &__assignment-tag {\n    padding: 4px 8px;\n    border-radius: 6px;\n    background-color: rgba(49, 130, 206, 0.12);\n    color: #2b6cb0;\n    font-size: 11px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n  }\n\n  &__assignment-meta {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    font-size: 12px;\n    color: #4a5568;\n  }\n\n  &__assignment-remove {\n    align-self: flex-start;\n    background: none;\n    border: 1px solid rgba(229, 62, 62, 0.4);\n    color: #c53030;\n    padding: 6px 12px;\n    border-radius: 8px;\n    font-size: 12px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background-color 0.15s ease, color 0.15s ease;\n\n    &:hover {\n      background-color: rgba(229, 62, 62, 0.08);\n      color: #9b2c2c;\n    }\n  }\n\n  &__assignment-empty {\n    padding: 18px;\n    border-radius: 12px;\n    border: 1px dashed #cbd5f5;\n    background-color: #f8fafc;\n    color: #4a5568;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n\n    strong {\n      font-size: 14px;\n      color: #2d3748;\n    }\n  }\n\n  &__form {\n    padding: 20px;\n    border-radius: 12px;\n    border: 1px solid #e2e8f0;\n    background-color: #f8fafc;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n\n    h3 {\n      margin: 0;\n      font-size: 16px;\n      font-weight: 600;\n      color: #2d3748;\n    }\n\n    form {\n      display: flex;\n      flex-direction: column;\n      gap: 12px;\n    }\n\n    label {\n      display: flex;\n      flex-direction: column;\n      gap: 6px;\n      font-size: 13px;\n      color: #4a5568;\n\n      input,\n      textarea {\n        border: 1px solid #cbd5f5;\n        border-radius: 8px;\n        padding: 8px 12px;\n        font-size: 14px;\n      }\n\n      textarea {\n        resize: vertical;\n      }\n    }\n  }\n\n  &__create-button {\n    padding: 10px 16px;\n    border: none;\n    border-radius: 8px;\n    background-color: $color-primary;\n    color: #fff;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background-color 0.15s ease;\n\n    &:hover:not(:disabled) {\n      background-color: darken($color-primary, 8%);\n    }\n\n    &:disabled {\n      opacity: 0.6;\n      cursor: not-allowed;\n    }\n  }\n}\n\n.food-page {\n  &__controls {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 16px;\n  }\n\n  &__date {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    font-size: 14px;\n    color: #4a5568;\n\n    input {\n      padding: 8px 12px;\n      border: 1px solid #e2e8f0;\n      border-radius: 6px;\n      font-size: 14px;\n\n      &:focus {\n        outline: none;\n        border-color: #FA9411;\n        box-shadow: 0 0 0 3px rgba(250, 148, 17, 0.15);\n      }\n    }\n  }\n\n  &__total {\n    font-size: 14px;\n    color: #4a5568;\n  }\n}\n\n.user-accommodation {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  background-color: #ffffff;\n  border: 1px solid #edf2f7;\n  border-radius: 12px;\n  padding: 20px;\n\n  &__summary {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 16px;\n    flex-wrap: wrap;\n  }\n\n  &__label {\n    display: block;\n    font-size: 12px;\n    text-transform: uppercase;\n    letter-spacing: 0.08em;\n    color: #718096;\n    margin-bottom: 4px;\n  }\n\n  &__room-name {\n    margin: 0;\n    font-size: 20px;\n    font-weight: 700;\n    color: #2d3748;\n  }\n\n  &__metrics {\n    display: flex;\n    gap: 16px;\n\n    > div {\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n      align-items: flex-end;\n    }\n  }\n\n  &__metric-label {\n    font-size: 12px;\n    color: #718096;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n  }\n\n  &__metric-value {\n    font-size: 18px;\n    font-weight: 600;\n    color: #2d3748;\n  }\n\n  &__metric-chip {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 48px;\n    padding: 4px 10px;\n    border-radius: 999px;\n    font-size: 12px;\n    font-weight: 600;\n\n    &--available {\n      background-color: rgba(56, 161, 105, 0.12);\n      color: #276749;\n      border: 1px solid rgba(56, 161, 105, 0.3);\n    }\n\n    &--full {\n      background-color: rgba(229, 62, 62, 0.12);\n      color: #c53030;\n      border: 1px solid rgba(229, 62, 62, 0.3);\n    }\n  }\n\n  &__assigned-at,\n  &__description,\n  &__note {\n    font-size: 14px;\n    color: #4a5568;\n  }\n\n  &__passengers {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n    gap: 14px;\n  }\n\n  &__passenger {\n    display: flex;\n    gap: 12px;\n    align-items: flex-start;\n    padding: 12px;\n    border-radius: 12px;\n    border: 1px solid #e2e8f0;\n    background-color: #f7fafc;\n\n    &--current {\n      border-color: $color-primary;\n      background-color: rgba($color-primary, 0.12);\n    }\n  }\n\n  &__passenger-avatar {\n    width: 44px;\n    height: 44px;\n    border-radius: 50%;\n    background: linear-gradient(\n      135deg,\n      lighten($color-primary, 8%),\n      lighten($color-primary, 28%)\n    );\n    color: #fff;\n    font-weight: 700;\n    font-size: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  &__passenger-info {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  &__passenger-name {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n\n    span:first-child {\n      font-size: 15px;\n      font-weight: 600;\n      color: #1a202c;\n    }\n  }\n\n  &__assignment-tag {\n    padding: 2px 8px;\n    border-radius: 6px;\n    background-color: rgba(49, 130, 206, 0.12);\n    color: #2b6cb0;\n    font-size: 11px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n  }\n\n  &__badge {\n    padding: 2px 8px;\n    border-radius: 6px;\n    background-color: rgba(246, 173, 85, 0.2);\n    color: #b7791f;\n    font-size: 11px;\n    font-weight: 600;\n    text-transform: uppercase;\n  }\n\n  &__passenger-contact,\n  &__passenger-time {\n    font-size: 12px;\n    color: #4a5568;\n  }\n\n  &__actions {\n    display: flex;\n    gap: 12px;\n    flex-wrap: wrap;\n  }\n\n  &__button {\n    padding: 10px 16px;\n    border-radius: 8px;\n    border: none;\n    background-color: $color-primary;\n    color: #fff;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background-color 0.15s ease;\n\n    &:hover:not(:disabled) {\n      background-color: darken($color-primary, 8%);\n    }\n\n    &:disabled {\n      opacity: 0.65;\n      cursor: not-allowed;\n    }\n\n    &--secondary {\n      background-color: #e53e3e;\n\n      &:hover:not(:disabled) {\n        background-color: #c53030;\n      }\n    }\n  }\n\n  &__empty {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    align-items: flex-start;\n    color: #4a5568;\n\n    strong {\n      font-size: 15px;\n      color: #2d3748;\n    }\n  }\n}\n\n.user-accommodation-modal {\n  background-color: #fff;\n  border-radius: 16px;\n  padding: 24px;\n  width: min(720px, 90vw);\n  max-height: 82vh;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  overflow: hidden;\n}\n\n.user-accommodation-modal__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n\n  h3 {\n    margin: 0;\n    font-size: 18px;\n    font-weight: 600;\n    color: #2d3748;\n  }\n}\n\n.user-accommodation-modal__close {\n  background: none;\n  border: none;\n  font-size: 24px;\n  line-height: 1;\n  cursor: pointer;\n  color: #4a5568;\n\n  &:hover {\n    color: #1a202c;\n  }\n}\n\n.user-accommodation-modal__loading,\n.user-accommodation-modal__empty,\n.user-accommodation-modal__error {\n  padding: 16px;\n  border-radius: 12px;\n  font-size: 14px;\n  text-align: center;\n}\n\n.user-accommodation-modal__error {\n  background-color: rgba(229, 62, 62, 0.1);\n  color: #9b2c2c;\n  border: 1px solid rgba(229, 62, 62, 0.3);\n}\n\n.user-accommodation-modal__empty {\n  background-color: #f8fafc;\n  color: #4a5568;\n}\n\n.user-accommodation-modal__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n  overflow-y: auto;\n  padding-right: 4px;\n}\n\n.user-accommodation-modal__card {\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  background-color: #fefefe;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n\n  &--empty {\n    border-color: rgba(56, 161, 105, 0.3);\n  }\n\n  &--partial {\n    border-color: rgba(237, 137, 54, 0.3);\n  }\n\n  &--full {\n    border-color: rgba(229, 62, 62, 0.3);\n    background-color: rgba(254, 215, 215, 0.35);\n  }\n\n  &--current {\n    border-color: $color-primary;\n    box-shadow: 0 8px 20px rgba($color-primary, 0.25);\n    background-color: rgba($color-primary, 0.18);\n  }\n}\n\n.user-accommodation-modal__card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 8px;\n\n  h4 {\n    margin: 0;\n    font-size: 16px;\n    font-weight: 600;\n    color: #2d3748;\n  }\n\n  span {\n    font-size: 13px;\n    color: #4a5568;\n  }\n}\n\n.user-accommodation-modal__card-description {\n  font-size: 12px;\n  color: #4a5568;\n}\n\n.user-accommodation-modal__card-meta {\n  font-size: 12px;\n  color: #2f855a;\n  font-weight: 600;\n}\n\n.user-accommodation-modal__card-actions button {\n  width: 100%;\n  padding: 10px 14px;\n  border-radius: 8px;\n  border: none;\n  background-color: $color-primary;\n  color: #fff;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n\n  &:disabled {\n    background-color: #a0aec0;\n    cursor: not-allowed;\n  }\n\n  &:hover:not(:disabled) {\n    background-color: darken($color-primary, 8%);\n  }\n}\n\n.camp-status {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n\n  &__header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    flex-wrap: wrap;\n    gap: 16px;\n\n    h2 {\n      margin: 0;\n      font-size: 24px;\n      font-weight: 600;\n      color: #2d3748;\n    }\n\n    p {\n      margin: 6px 0 0;\n      font-size: 14px;\n      color: #4a5568;\n      max-width: 420px;\n    }\n  }\n\n  &__controls {\n    display: flex;\n    gap: 12px;\n    align-items: end;\n    flex-wrap: wrap;\n\n    button {\n      padding: 10px 16px;\n      border-radius: 8px;\n      border: 1px solid #cbd5f5;\n      background-color: $color-primary;\n      color: #fff;\n      font-weight: 600;\n      cursor: pointer;\n\n      &:disabled {\n        opacity: 0.6;\n        cursor: not-allowed;\n      }\n\n      &:hover:not(:disabled) {\n        background-color: darken($color-primary, 8%);\n      }\n    }\n  }\n\n  &__date-picker {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    font-size: 12px;\n    color: #4a5568;\n    text-transform: uppercase;\n    letter-spacing: 0.08em;\n\n    input {\n      padding: 8px 12px;\n      border-radius: 8px;\n      border: 1px solid #cbd5f5;\n      font-size: 14px;\n    }\n  }\n\n  &__error {\n    padding: 12px;\n    border-radius: 10px;\n    background-color: rgba(229, 62, 62, 0.12);\n    border: 1px solid rgba(229, 62, 62, 0.3);\n    color: #9b2c2c;\n    font-size: 13px;\n  }\n\n  &__summary {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n    gap: 16px;\n  }\n\n  &__summary-card {\n    padding: 18px;\n    border-radius: 12px;\n    border: 1px solid #e2e8f0;\n    background-color: #f8fafc;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n\n    strong {\n      font-size: 24px;\n      font-weight: 700;\n      color: #2d3748;\n    }\n  }\n\n  &__summary-label {\n    font-size: 12px;\n    color: #718096;\n    text-transform: uppercase;\n    letter-spacing: 0.08em;\n  }\n\n  &__lists {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n    gap: 20px;\n  }\n\n  &__list {\n    background-color: #fff;\n    border: 1px solid #edf2f7;\n    border-radius: 12px;\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n\n    h3 {\n      margin: 0;\n      font-size: 18px;\n      font-weight: 600;\n      color: #2d3748;\n    }\n  }\n\n  &__list-loading,\n  &__list-empty {\n    padding: 16px;\n    border-radius: 10px;\n    background-color: #f8fafc;\n    text-align: center;\n    font-size: 14px;\n    color: #4a5568;\n  }\n\n  &__list-items {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  &__list-card {\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    padding: 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    background-color: #fefefe;\n  }\n\n  &__list-header {\n    display: flex;\n    justify-content: space-between;\n    gap: 12px;\n\n    h4 {\n      margin: 0;\n      font-size: 16px;\n      font-weight: 600;\n      color: #1a202c;\n    }\n  }\n\n  &__list-tag {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 2px 8px;\n    border-radius: 6px;\n    background-color: rgba(49, 130, 206, 0.12);\n    color: #2b6cb0;\n    font-size: 11px;\n    font-weight: 600;\n    letter-spacing: 0.04em;\n  }\n\n  &__list-time {\n    font-size: 12px;\n    color: #4a5568;\n  }\n\n  &__list-meta {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    font-size: 13px;\n    color: #4a5568;\n  }\n\n  &__list-footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 12px;\n  }\n\n  &__badge {\n    padding: 4px 10px;\n    border-radius: 999px;\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n\n    &--in {\n      background-color: rgba(56, 161, 105, 0.12);\n      color: #276749;\n      border: 1px solid rgba(56, 161, 105, 0.3);\n    }\n\n    &--out {\n      background-color: rgba(237, 137, 54, 0.12);\n      color: #b7791f;\n      border: 1px solid rgba(237, 137, 54, 0.3);\n    }\n\n    &--decamp {\n      background-color: rgba(197, 48, 48, 0.12);\n      color: #c53030;\n      border: 1px solid rgba(197, 48, 48, 0.3);\n    }\n  }\n\n  &__list-role {\n    font-size: 12px;\n    color: #4a5568;\n    font-weight: 600;\n  }\n\n  &--restricted {\n    padding: 24px;\n    border-radius: 12px;\n    background-color: #f8fafc;\n    color: #4a5568;\n    text-align: center;\n  }\n}\n\n.audit-trail {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n\n  &__header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    flex-wrap: wrap;\n    gap: 12px;\n\n    h2 {\n      margin: 0;\n      font-size: 24px;\n      font-weight: 600;\n      color: #2d3748;\n    }\n\n    p {\n      margin: 6px 0 0;\n      font-size: 14px;\n      color: #4a5568;\n      max-width: 420px;\n    }\n  }\n\n  &__filters {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    padding: 20px;\n    border-radius: 12px;\n    border: 1px solid #edf2f7;\n    background-color: #fff;\n\n    label {\n      display: flex;\n      flex-direction: column;\n      gap: 6px;\n      font-size: 12px;\n      text-transform: uppercase;\n      letter-spacing: 0.08em;\n      color: #4a5568;\n\n      input,\n      select {\n        padding: 8px 12px;\n        border-radius: 8px;\n        border: 1px solid #cbd5f5;\n        font-size: 14px;\n        background-color: #fff;\n      }\n    }\n\n    button {\n      align-self: flex-start;\n      padding: 10px 16px;\n      border-radius: 8px;\n      border: none;\n      background-color: $color-primary;\n      color: #fff;\n      font-weight: 600;\n      cursor: pointer;\n\n      &:disabled {\n        opacity: 0.6;\n        cursor: not-allowed;\n      }\n    }\n  }\n\n  &__filters-row {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 16px;\n    justify-content: space-between;\n    align-items: flex-end;\n  }\n\n  &__filters-dates {\n    display: flex;\n    gap: 16px;\n    flex-wrap: wrap;\n  }\n\n  &__filters-actions {\n    display: flex;\n    gap: 10px;\n  }\n\n  &__clear {\n    background-color: rgba(45, 55, 72, 0.08);\n    color: #2d3748;\n    border: none;\n  }\n\n  &__filters-selects {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n    gap: 16px;\n  }\n\n  &__select-wrapper {\n    position: relative;\n\n    select {\n      width: 100%;\n      appearance: none;\n      background-image: linear-gradient(45deg, transparent 50%, #4a5568 50%),\n        linear-gradient(135deg, #4a5568 50%, transparent 50%);\n      background-position: calc(100% - 18px) calc(1.1em),\n        calc(100% - 13px) calc(1.1em);\n      background-size: 5px 5px;\n      background-repeat: no-repeat;\n    }\n  }\n\n  &__table-wrapper {\n    background-color: #fff;\n    border-radius: 12px;\n    border: 1px solid #edf2f7;\n    overflow-x: auto;\n  }\n\n  &__table {\n    width: 100%;\n    border-collapse: collapse;\n\n    th,\n    td {\n      padding: 12px 16px;\n      border-bottom: 1px solid #e2e8f0;\n      text-align: left;\n      font-size: 14px;\n      color: #2d3748;\n    }\n\n    th {\n      background-color: #f7fafc;\n      font-weight: 600;\n      color: #2d3748;\n      text-transform: uppercase;\n      font-size: 12px;\n    }\n\n    tbody tr:hover {\n      background-color: #f8fafc;\n    }\n  }\n\n  &__loading,\n  &__empty,\n  &__error {\n    padding: 16px;\n    border-radius: 12px;\n    text-align: center;\n    font-size: 14px;\n  }\n\n  &__error {\n    background-color: rgba(229, 62, 62, 0.12);\n    color: #9b2c2c;\n    border: 1px solid rgba(229, 62, 62, 0.3);\n  }\n\n  &__pagination {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 12px;\n\n    button {\n      padding: 8px 14px;\n      border-radius: 8px;\n      border: 1px solid #cbd5f5;\n      background-color: #fff;\n      cursor: pointer;\n\n      &:disabled {\n        opacity: 0.6;\n        cursor: not-allowed;\n      }\n    }\n  }\n\n  &--restricted {\n    padding: 24px;\n    border-radius: 12px;\n    background-color: #f8fafc;\n    color: #4a5568;\n    text-align: center;\n  }\n}",".admin-layout {\n  display: flex;\n  min-height: 100vh;\n  flex-direction: column; // Stack on mobile\n  \n  @media (min-width: $tablet) {\n    flex-direction: row;\n  }\n  \n  \n  &__content {\n    flex: 1;\n    background-color: $color-gray-50;\n    padding: 16px; // Smaller padding on mobile\n    \n    @media (min-width: $tablet) {\n      padding: 32px;\n    }\n  }\n}","// Shared reporting styles\n\n.form-flash-toast-container {\n  width: min(560px, calc(100vw - 32px));\n  top: 16px !important;\n  z-index: 11000;\n\n  .form-flash-toast {\n    border-radius: 8px;\n    font-size: 14px;\n    line-height: 1.45;\n    min-height: auto;\n    padding: 12px 16px;\n    box-shadow: 0 10px 25px rgba(15, 23, 42, 0.12);\n  }\n\n  .Toastify__toast--error {\n    background: #fef2f2;\n    color: #b91c1c;\n    border: 1px solid #fecaca;\n  }\n\n  .Toastify__toast--success {\n    background: #f0fdf4;\n    color: #15803d;\n    border: 1px solid #bbf7d0;\n  }\n\n  .Toastify__close-button {\n    color: inherit;\n    opacity: 0.65;\n  }\n}\n\n.report-alert {\n  padding: 12px 16px;\n  border-radius: 6px;\n  margin-bottom: 16px;\n  font-size: 14px;\n\n  &--error {\n    background: #fef2f2;\n    color: #b91c1c;\n    border: 1px solid #fecaca;\n  }\n\n  &--success {\n    background: #f0fdf4;\n    color: #15803d;\n    border: 1px solid #bbf7d0;\n  }\n}\n\n.report-share-feedback {\n  padding: 12px 16px;\n  margin-bottom: 16px;\n  border-radius: 8px;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #166534;\n  background: #f0fdf4;\n  border: 1px solid #bbf7d0;\n}\n\n.report-share-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n\n  &__icon {\n    width: 16px;\n    height: 16px;\n    flex-shrink: 0;\n    stroke-width: 2px;\n  }\n\n  &--compact {\n    gap: 4px;\n  }\n}\n\n.report-badge {\n  display: inline-block;\n  padding: 2px 10px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n  text-transform: capitalize;\n\n  &--active {\n    background: #dcfce7;\n    color: #15803d;\n  }\n\n  &--completed {\n    background: #dcfce7;\n    color: #15803d;\n  }\n\n  &--upcoming {\n    background: #dbeafe;\n    color: #1d4ed8;\n  }\n\n  &--draft {\n    background: #fef3c7;\n    color: #92400e;\n  }\n\n  &--inactive {\n    background: #f3f4f6;\n    color: #6b7280;\n  }\n\n  &--count {\n    background: #f3f4f6;\n    color: #374151;\n  }\n\n  &--field {\n    background: #ede9fe;\n    color: #5b21b6;\n    font-size: 11px;\n    margin: 2px 4px 2px 0;\n  }\n\n  &--assignees {\n    background: #e0f2fe;\n    color: #0369a1;\n  }\n\n  &--rejected {\n    background: #fef2f2;\n    color: #b91c1c;\n  }\n\n  &--evidence {\n    background: #fef3c7;\n    color: #92400e;\n    font-size: 11px;\n    margin: 2px 4px 2px 0;\n  }\n}\n\n.btn {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: opacity 0.15s;\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  &--primary {\n    background: $color-primary;\n    color: #fff;\n\n    &:hover:not(:disabled) {\n      opacity: 0.9;\n    }\n  }\n\n  &--secondary {\n    background: #f3f4f6;\n    color: #374151;\n    border: 1px solid #d1d5db;\n\n    &:hover:not(:disabled) {\n      background: #e5e7eb;\n    }\n  }\n\n  &--danger {\n    background: #fef2f2;\n    color: #b91c1c;\n    border: 1px solid #fecaca;\n\n    &:hover:not(:disabled) {\n      background: #fee2e2;\n    }\n  }\n\n  &--sm {\n    padding: 4px 10px;\n    font-size: 12px;\n  }\n}\n\n// Modal overlay\n.report-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n\n  // Stacked on top of another report modal (e.g. confirm override while section editor is open)\n  &--nested {\n    z-index: 2000;\n  }\n}\n\n.report-modal {\n  background: #fff;\n  border-radius: 12px;\n  padding: 24px;\n  width: 100%;\n  max-width: 500px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);\n\n  &--wide {\n    max-width: 700px;\n  }\n\n  h2 {\n    margin: 0 0 20px;\n    font-size: 20px;\n  }\n\n  h3 {\n    font-size: 16px;\n    font-weight: 600;\n  }\n\n  &__field {\n    margin-bottom: 14px;\n\n    label {\n      display: block;\n      font-size: 13px;\n      font-weight: 500;\n      color: #374151;\n      margin-bottom: 4px;\n    }\n  }\n\n  &__row {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 12px;\n  }\n\n  &__actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 8px;\n    margin-top: 20px;\n    padding-top: 16px;\n    border-top: 1px solid #e5e7eb;\n  }\n}\n\n.report-staff-picker {\n  &__hint {\n    font-size: 12px;\n    color: #6b7280;\n    margin: 0 0 8px;\n    line-height: 1.4;\n  }\n\n  &__chips {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-bottom: 10px;\n\n    &--inline {\n      margin-bottom: 6px;\n      gap: 6px;\n    }\n  }\n\n  &__chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 4px 4px 4px 10px;\n    background: #f3f4f6;\n    border-radius: 20px;\n    font-size: 13px;\n    color: #374151;\n  }\n\n  &__chip-remove {\n    border: none;\n    background: #e5e7eb;\n    width: 22px;\n    height: 22px;\n    border-radius: 50%;\n    cursor: pointer;\n    font-size: 16px;\n    line-height: 1;\n    color: #4b5563;\n\n    &:hover {\n      background: #d1d5db;\n    }\n  }\n\n  &__status {\n    font-size: 12px;\n    color: #6b7280;\n    margin: 6px 0 0;\n  }\n\n  &__results {\n    list-style: none;\n    margin: 8px 0 0;\n    padding: 0;\n    max-height: 200px;\n    overflow-y: auto;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    background: #fafafa;\n  }\n\n  &__results-empty {\n    padding: 10px 12px;\n    font-size: 13px;\n    color: #6b7280;\n  }\n\n  &__result-btn {\n    display: block;\n    width: 100%;\n    text-align: left;\n    padding: 10px 12px;\n    border: none;\n    border-bottom: 1px solid #e5e7eb;\n    background: transparent;\n    cursor: pointer;\n    font-size: 14px;\n\n    &:last-child {\n      border-bottom: none;\n    }\n\n    &:hover:not(:disabled) {\n      background: #f3f4f6;\n    }\n\n    &:disabled {\n      opacity: 0.45;\n      cursor: default;\n    }\n  }\n\n  &__result-phone {\n    font-weight: 400;\n    color: #6b7280;\n  }\n}\n\n// Form input override\n.form-input {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 14px;\n  outline: none;\n  transition: border-color 0.15s;\n  box-sizing: border-box;\n\n  &:focus {\n    border-color: $color-primary;\n    box-shadow: 0 0 0 2px rgba(250, 148, 17, 0.15);\n  }\n\n  &--textarea {\n    resize: vertical;\n    min-height: 70px;\n  }\n}\n\n.report-modal-overlay--fullscreen {\n  padding: 0;\n  align-items: stretch;\n  justify-content: stretch;\n}\n\n.report-modal--fullscreen {\n  max-width: none;\n  max-height: none;\n  width: 100%;\n  height: 100%;\n  border-radius: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  padding: 0;\n\n  &__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    padding: 16px 24px;\n    border-bottom: 1px solid #e5e7eb;\n    flex-shrink: 0;\n    background: #fff;\n\n    h2 {\n      margin: 0;\n      font-size: 20px;\n    }\n  }\n\n  &__header-actions {\n    display: flex;\n    gap: 8px;\n    flex-shrink: 0;\n  }\n\n  &__body {\n    flex: 1;\n    overflow-y: auto;\n    padding: 24px 32px 48px;\n  }\n}\n\n// ---- Report Config Page ----\n.report-config {\n  padding: 24px;\n\n  &__header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 24px;\n\n    h1 {\n      font-size: 24px;\n      font-weight: 700;\n      margin: 0;\n    }\n  }\n\n  &__sections {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  &__section {\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n    overflow: hidden;\n    background: #fff;\n\n    &--inactive {\n      opacity: 0.6;\n    }\n  }\n\n  &__section-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 14px 18px;\n    cursor: pointer;\n    background: #f9fafb;\n    transition: background 0.15s;\n\n    &:hover {\n      background: #f3f4f6;\n    }\n  }\n\n  &__section-info {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n\n    h3 {\n      margin: 0;\n      font-size: 16px;\n    }\n  }\n\n  &__section-order {\n    font-weight: 700;\n    color: #6b7280;\n    min-width: 20px;\n  }\n\n  &__section-actions {\n    display: flex;\n    gap: 6px;\n  }\n\n  &__tasks {\n    padding: 16px 18px;\n    border-top: 1px solid #e5e7eb;\n  }\n\n  &__tasks-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 12px;\n\n    h4 {\n      margin: 0;\n      font-size: 14px;\n      text-transform: uppercase;\n      color: #6b7280;\n      letter-spacing: 0.5px;\n    }\n  }\n\n  &__task {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    padding: 12px;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    margin-bottom: 8px;\n    background: #fff;\n  }\n\n  &__task-info {\n    display: flex;\n    gap: 10px;\n    flex: 1;\n  }\n\n  &__task-order {\n    font-weight: 600;\n    color: #6b7280;\n    min-width: 24px;\n  }\n\n  &__task-fields {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 4px;\n    margin-top: 6px;\n  }\n\n  &__task-staff {\n    margin-top: 8px;\n  }\n\n  &__task-staff-note {\n    display: block;\n    font-size: 12px;\n    color: #9ca3af;\n    font-style: italic;\n    line-height: 1.4;\n  }\n\n  &__task-staff-search {\n    margin-top: 6px;\n    max-width: 360px;\n  }\n\n  &__task-actions {\n    display: flex;\n    gap: 6px;\n    margin-left: 12px;\n    flex-shrink: 0;\n    align-self: flex-start;\n  }\n\n  &__empty {\n    text-align: center;\n    color: #9ca3af;\n    padding: 20px;\n    font-size: 14px;\n  }\n}\n\n// Field builder in task modal\n.report-field-builder-section {\n  margin-top: 16px;\n  margin-bottom: 12px;\n\n  &__head {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 16px;\n    flex-wrap: wrap;\n  }\n\n  &__actions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: wrap;\n  }\n\n  &__count {\n    font-size: 12px;\n    color: #6b7280;\n    margin-right: 4px;\n  }\n}\n\n.report-field-builder-group {\n  margin-bottom: 16px;\n  padding: 10px 12px 12px;\n  border: 1px dashed #d1d5db;\n  border-radius: 10px;\n  background: #f9fafb;\n\n  &--ungrouped {\n    padding: 0;\n    border: none;\n    background: transparent;\n    margin-bottom: 8px;\n  }\n\n  &__questions {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n  }\n\n  &--section-collapsed {\n    padding-bottom: 8px;\n  }\n\n  &__hint {\n    margin: 8px 0 0;\n    font-size: 12px;\n    color: #9ca3af;\n    font-style: italic;\n  }\n\n  &__ungrouped-label {\n    margin: 0 0 8px;\n    padding-top: 8px;\n    font-size: 13px;\n    font-weight: 600;\n    color: #6b7280;\n    border-top: 2px solid #e5e7eb;\n  }\n}\n\n.report-field-builder {\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 10px;\n  margin-bottom: 8px;\n  background: #fafafa;\n\n  &--in-section {\n    margin-left: 12px;\n    border-left: 3px solid #bae6fd;\n  }\n\n  &__section-tag {\n    color: #0369a1;\n    font-weight: 500;\n  }\n\n  &--section {\n    background: #f0f9ff;\n    border-color: #bae6fd;\n\n    .report-field-builder__index {\n      color: #0369a1;\n      font-weight: 700;\n    }\n  }\n\n  &--subsection {\n    margin-left: 18px;\n    border-top: 4px solid #9aa3b2;\n    background: #fafbfc;\n\n    .report-field-builder__index {\n      color: #8b93a1;\n      font-weight: 700;\n      font-size: 11px;\n      letter-spacing: 0.02em;\n    }\n  }\n\n  &--collapsed {\n    padding: 8px 10px;\n    background: #fff;\n  }\n\n  &__header {\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  &__collapse {\n    flex-shrink: 0;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    height: 28px;\n    margin-top: 2px;\n    border: 1px solid #e5e7eb;\n    border-radius: 6px;\n    background: #fff;\n    color: #374151;\n    cursor: pointer;\n\n    &:hover {\n      background: #f3f4f6;\n      border-color: #d1d5db;\n    }\n  }\n\n  &__chevron {\n    display: block;\n    width: 8px;\n    height: 8px;\n    border-right: 2px solid currentColor;\n    border-bottom: 2px solid currentColor;\n    transform: rotate(-45deg);\n    transition: transform 0.15s ease;\n    margin-top: -2px;\n\n    &--open {\n      transform: rotate(45deg);\n      margin-top: 2px;\n    }\n  }\n\n  &__index {\n    flex-shrink: 0;\n    min-width: 28px;\n    margin-top: 6px;\n    font-size: 12px;\n    font-weight: 700;\n    color: #6b7280;\n  }\n\n  &__row {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n    margin-bottom: 0;\n    flex: 1;\n    min-width: 0;\n  }\n\n  &__title {\n    flex: 1;\n    min-width: 0;\n    font-size: 14px;\n    font-weight: 600;\n    color: #111827;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  &__summary-meta {\n    flex-shrink: 0;\n    font-size: 11px;\n    color: #6b7280;\n    white-space: nowrap;\n  }\n\n  &__body {\n    margin-top: 8px;\n    padding-top: 8px;\n    border-top: 1px solid #e5e7eb;\n  }\n\n  &__options,\n  &__subfields {\n    padding: 8px 0 0 16px;\n    border-top: 1px solid #e5e7eb;\n    margin-top: 8px;\n\n    label {\n      font-size: 12px;\n      font-weight: 500;\n      color: #6b7280;\n      margin-bottom: 4px;\n      display: block;\n    }\n  }\n\n  &__body > &__options:first-child,\n  &__body > &__subfields:first-child {\n    border-top: none;\n    margin-top: 0;\n    padding-top: 0;\n  }\n}\n\n// ---- Report Events Page ----\n.report-events {\n  padding: 24px;\n\n  &__header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: 24px;\n    flex-wrap: wrap;\n    gap: 12px;\n\n    h1 {\n      font-size: 24px;\n      font-weight: 700;\n      margin: 0;\n    }\n  }\n\n  &__share-hint {\n    margin: 8px 0 0;\n    max-width: 520px;\n    font-size: 13px;\n    line-height: 1.45;\n    color: #6b7280;\n\n    strong {\n      font-weight: 600;\n      color: #4b5563;\n    }\n  }\n\n  &__header-actions {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n    align-self: center;\n  }\n\n  &__grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n    gap: 16px;\n  }\n\n  &__card {\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n    padding: 18px;\n    background: #fff;\n    cursor: pointer;\n    transition: box-shadow 0.15s, transform 0.15s;\n\n    &:hover {\n      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\n      transform: translateY(-1px);\n    }\n  }\n\n  &__card-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: 12px;\n    gap: 10px;\n\n    h3 {\n      margin: 0;\n      font-size: 16px;\n      font-weight: 600;\n      min-width: 0;\n    }\n  }\n\n  &__card-header-right {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-shrink: 0;\n  }\n\n  &__card-body {\n    p {\n      margin: 4px 0;\n      font-size: 13px;\n      color: #4b5563;\n    }\n  }\n\n  &__card-actions {\n    display: flex;\n    gap: 6px;\n    margin-top: 14px;\n    padding-top: 12px;\n    border-top: 1px solid #f3f4f6;\n  }\n\n  &__empty {\n    text-align: center;\n    padding: 60px 20px;\n    color: #9ca3af;\n  }\n}\n\n// ---- Event Reporting Page ----\n.event-reporting {\n  padding: 24px;\n\n  &__header {\n    margin-bottom: 20px;\n\n    h1 {\n      font-size: 24px;\n      font-weight: 700;\n      margin: 0;\n    }\n  }\n\n  &__toolbar {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 8px;\n  }\n\n  &__share-hint {\n    margin: 0 0 12px;\n    max-width: 560px;\n    font-size: 13px;\n    line-height: 1.45;\n    color: #6b7280;\n  }\n\n  &__meta {\n    font-size: 14px;\n    color: #6b7280;\n    margin: 4px 0 0;\n  }\n\n  &__progress {\n    margin-bottom: 20px;\n  }\n\n  &__progress-bar {\n    height: 10px;\n    background: #e5e7eb;\n    border-radius: 5px;\n    overflow: hidden;\n    margin-bottom: 6px;\n  }\n\n  &__progress-fill {\n    height: 100%;\n    background: $color-primary;\n    border-radius: 5px;\n    transition: width 0.4s ease;\n  }\n\n  &__progress-text {\n    font-size: 13px;\n    color: #6b7280;\n  }\n\n  &__empty {\n    text-align: center;\n    padding: 28px 16px;\n    color: #6b7280;\n    font-size: 14px;\n    line-height: 1.5;\n    border: 1px dashed #e5e7eb;\n    border-radius: 10px;\n    background: #fafafa;\n  }\n\n  &__sections {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  &__section {\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n    overflow: hidden;\n    background: #fff;\n  }\n\n  &__section-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 14px 18px;\n    cursor: pointer;\n    background: #f9fafb;\n    transition: background 0.15s;\n\n    &:hover {\n      background: #f3f4f6;\n    }\n  }\n\n  &__section-title {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n\n    h2 {\n      margin: 0;\n      font-size: 17px;\n      font-weight: 600;\n    }\n  }\n\n  &__task-list {\n    padding: 12px 18px;\n    border-top: 1px solid #e5e7eb;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  &__task {\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    overflow: hidden;\n    scroll-margin-top: 88px;\n\n    &:focus {\n      outline: 2px solid $color-primary;\n      outline-offset: 2px;\n      box-shadow: 0 0 0 4px rgba($color-primary, 0.15);\n    }\n  }\n\n  &__task-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 12px;\n    padding: 12px 14px;\n    cursor: pointer;\n    transition: background 0.15s;\n\n    &:hover {\n      background: #f9fafb;\n    }\n  }\n\n  &__task-header-right {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n    gap: 10px;\n    flex-shrink: 0;\n  }\n\n  &__reject-quick {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 14px;\n    font-size: 13px;\n    font-weight: 600;\n    color: #b91c1c;\n    background: #fef2f2;\n    border: 1px solid #fecaca;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: background 0.15s, border-color 0.15s, box-shadow 0.15s;\n\n    &:hover {\n      background: #fee2e2;\n      border-color: #f87171;\n      box-shadow: 0 1px 3px rgba(185, 28, 28, 0.12);\n    }\n\n    &:focus-visible {\n      outline: 2px solid #dc2626;\n      outline-offset: 2px;\n    }\n  }\n\n  &__admin-review-cta {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n    padding: 16px 18px;\n    margin-bottom: 16px;\n    background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);\n    border: 1px solid #fcd34d;\n    border-radius: 10px;\n    box-shadow: 0 1px 2px rgba(180, 83, 9, 0.08);\n\n    @media (min-width: 560px) {\n      flex-direction: row;\n      align-items: center;\n      justify-content: space-between;\n    }\n  }\n\n  &__admin-review-cta-text {\n    flex: 1;\n    min-width: 0;\n\n    strong {\n      display: block;\n      font-size: 15px;\n      color: #92400e;\n      margin-bottom: 4px;\n    }\n\n    p {\n      margin: 0;\n      font-size: 13px;\n      line-height: 1.5;\n      color: #78350f;\n    }\n  }\n\n  &__reject-cta-btn {\n    flex-shrink: 0;\n    padding: 12px 20px;\n    font-size: 15px;\n    font-weight: 600;\n    color: #fff;\n    background: #dc2626;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    box-shadow: 0 2px 6px rgba(220, 38, 38, 0.35);\n    transition: background 0.15s, transform 0.1s;\n\n    &:hover {\n      background: #b91c1c;\n    }\n\n    &:active {\n      transform: scale(0.98);\n    }\n\n    &:focus-visible {\n      outline: 2px solid #dc2626;\n      outline-offset: 2px;\n    }\n  }\n\n  &__submitted-note--admin {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n\n  &__task-title {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 14px;\n  }\n\n  &__task-order {\n    font-weight: 600;\n    color: #6b7280;\n  }\n\n  &__task-body {\n    padding: 16px;\n    border-top: 1px solid #e5e7eb;\n    background: #fafafa;\n  }\n\n  &__task-actions {\n    display: flex;\n    gap: 8px;\n    margin-top: 16px;\n    padding-top: 12px;\n    border-top: 1px solid #e5e7eb;\n  }\n\n  &__submitted-note {\n    margin-top: 12px;\n    font-size: 13px;\n    color: #15803d;\n    font-style: italic;\n  }\n\n  &__rejection-banner {\n    background: #fef2f2;\n    border: 1px solid #fecaca;\n    border-radius: 8px;\n    padding: 12px 16px;\n    margin-bottom: 14px;\n    font-size: 14px;\n    color: #b91c1c;\n    line-height: 1.5;\n\n    strong {\n      font-weight: 600;\n    }\n  }\n\n  &__rejection-reason {\n    margin: 6px 0 0;\n    font-style: italic;\n    color: #991b1b;\n  }\n\n  &__admin-readonly-hint {\n    font-size: 13px;\n    color: #6b7280;\n    margin: 0 0 14px;\n    padding: 10px 12px;\n    background: #f3f4f6;\n    border-radius: 8px;\n    border-left: 3px solid #9ca3af;\n  }\n\n  &__rejection-history {\n    margin-bottom: 16px;\n  }\n\n  &__rejection-history-title {\n    margin: 0 0 8px;\n    font-size: 13px;\n    font-weight: 600;\n    color: #374151;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n  }\n\n  &__rejection-history-list {\n    margin: 0;\n    padding: 0 0 0 18px;\n    list-style: decimal;\n  }\n\n  &__rejection-history-item {\n    margin-bottom: 10px;\n    padding: 10px 12px;\n    background: #fff;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n\n    &--current {\n      border-color: #fecaca;\n      background: #fef2f2;\n    }\n  }\n\n  &__rejection-history-meta {\n    font-size: 12px;\n    color: #6b7280;\n    margin-bottom: 4px;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 6px;\n  }\n\n  &__rejection-history-reason {\n    margin: 0;\n    font-size: 14px;\n    color: #991b1b;\n    line-height: 1.45;\n  }\n}\n\n// ---- Dynamic Report Form ----\n.dynamic-report-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n\n  &__section-group {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  &__section-header {\n    padding: 12px 4px 4px;\n    border-bottom: 2px solid #e5e7eb;\n\n    &--toggle {\n      display: flex;\n      align-items: flex-start;\n      gap: 10px;\n      width: 100%;\n      margin: 0;\n      padding: 12px 8px 10px;\n      text-align: left;\n      background: #f9fafb;\n      border: 1px solid #e5e7eb;\n      border-radius: 10px;\n      cursor: pointer;\n      transition: background 0.15s ease;\n\n      &:hover {\n        background: #f3f4f6;\n      }\n\n      &:focus-visible {\n        outline: 2px solid $color-primary;\n        outline-offset: 2px;\n      }\n    }\n  }\n\n  &__section-chevron {\n    font-size: 12px;\n    color: #6b7280;\n    width: 18px;\n    flex-shrink: 0;\n    line-height: 1.6;\n  }\n\n  &__section-header-text {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    min-width: 0;\n    flex: 1;\n  }\n\n  &__section-title {\n    margin: 0;\n    font-size: 16px;\n    font-weight: 700;\n    color: #111827;\n    letter-spacing: -0.01em;\n  }\n\n  &__section-desc {\n    margin: 0;\n    font-size: 13px;\n    color: #6b7280;\n    line-height: 1.45;\n  }\n\n  &__section-fields {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n    padding: 4px 0 0 12px;\n    border-left: 3px solid #e5e7eb;\n  }\n\n  &__subsection-group {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    margin-top: 4px;\n  }\n\n  &__subsection-header {\n    padding: 8px 4px 2px;\n\n    &--toggle {\n      display: flex;\n      align-items: flex-start;\n      gap: 8px;\n      width: 100%;\n      margin: 0;\n      padding: 8px 10px;\n      text-align: left;\n      background: #f3f4f6;\n      border: 1px solid #e5e7eb;\n      border-radius: 8px;\n      cursor: pointer;\n      transition: background 0.15s ease;\n\n      &:hover {\n        background: #eceff3;\n      }\n\n      &:focus-visible {\n        outline: 2px solid $color-primary;\n        outline-offset: 2px;\n      }\n    }\n  }\n\n  &__subsection-title {\n    margin: 0;\n    font-size: 14px;\n    font-weight: 650;\n    color: #1f2937;\n  }\n\n  &__subsection-desc {\n    margin: 0;\n    font-size: 12px;\n    color: #6b7280;\n    line-height: 1.4;\n  }\n\n  &__subsection-fields {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n    padding: 2px 0 0 10px;\n    border-left: 2px solid #d1d5db;\n  }\n\n  &__field {\n    padding: 14px 14px 12px;\n    border: 1px solid #e5e7eb;\n    background: #ffffff;\n    border-radius: 12px;\n\n    label {\n      display: block;\n      font-size: 13px;\n      font-weight: 500;\n      color: #374151;\n      margin-bottom: 4px;\n    }\n  }\n\n  &__label {\n    display: block;\n    font-size: 13px;\n    font-weight: 500;\n    color: #374151;\n    margin-bottom: 4px;\n  }\n\n  &__required {\n    color: #ef4444;\n    margin-left: 2px;\n  }\n\n  &__accept-types {\n    font-size: 12px;\n    font-weight: 400;\n    color: #6b7280;\n  }\n}\n\n.report-checkbox-inputs {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px;\n\n  @media (max-width: 640px) {\n    grid-template-columns: 1fr;\n  }\n\n  &__row {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 10px;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    background: #fafafa;\n    min-width: 0;\n  }\n\n  &__check {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 13px;\n    color: #111827;\n    cursor: pointer;\n    flex: 1;\n    min-width: 0;\n\n    input {\n      width: 16px;\n      height: 16px;\n      flex-shrink: 0;\n    }\n  }\n\n  &__side {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    flex: 1;\n    min-width: 88px;\n  }\n\n  &__number {\n    max-width: 120px;\n  }\n\n  &__suffix {\n    font-size: 14px;\n    color: #6b7280;\n    font-weight: 500;\n  }\n}\n\n.report-upload__image-link {\n  display: inline-flex;\n  border-radius: 10px;\n  overflow: hidden;\n  border: 1px solid rgba($color-primary, 0.35);\n  background: #fff;\n  box-shadow: 0 1px 2px rgba($color-primary, 0.08);\n}\n\n.report-upload input[type=\"file\"] {\n  margin-top: 6px;\n}\n\n.report-toggle {\n  display: flex;\n  gap: 0;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  overflow: hidden;\n  width: fit-content;\n\n  &__btn {\n    padding: 8px 20px;\n    border: none;\n    background: #fff;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n    transition: all 0.15s;\n\n    &:first-child {\n      border-right: 1px solid #d1d5db;\n    }\n\n    &--active.report-toggle__btn--yes {\n      background: #dcfce7;\n      color: #15803d;\n    }\n\n    &--active.report-toggle__btn--no {\n      background: #fef2f2;\n      color: #b91c1c;\n    }\n  }\n}\n\n.report-gps {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n\n  &__btn {\n    padding: 8px 14px;\n    background: #f3f4f6;\n    border: 1px solid #d1d5db;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 13px;\n    white-space: nowrap;\n\n    &:hover {\n      background: #e5e7eb;\n    }\n  }\n}\n\n.report-upload {\n  &__preview {\n    margin-bottom: 8px;\n  }\n\n  &__status {\n    display: inline-block;\n    margin-left: 8px;\n    font-size: 13px;\n    color: $color-primary;\n    font-weight: 600;\n  }\n\n  &--multi {\n    padding: 14px;\n    border: 1.5px dashed rgba($color-primary, 0.55);\n    border-radius: 12px;\n    background: linear-gradient(180deg, #fff8ef 0%, #fff4e4 100%);\n  }\n\n  &__file-list {\n    list-style: none;\n    padding: 0;\n    margin: 0 0 10px;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  &__file-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: wrap;\n    padding: 8px 10px;\n    background: #fff;\n    border: 1px solid rgba($color-primary, 0.28);\n    border-radius: 8px;\n  }\n\n  &__file-index {\n    font-size: 13px;\n    font-weight: 700;\n    color: #9a5b08;\n    min-width: 52px;\n  }\n\n  &__remove {\n    margin-left: auto;\n  }\n\n  &__hint {\n    font-size: 12px;\n    color: #8a5a1a;\n    margin: 0 0 10px;\n    font-weight: 500;\n\n    &--warn {\n      color: #b45309;\n      font-weight: 700;\n    }\n  }\n\n  &__picker {\n    display: inline-flex;\n    cursor: pointer;\n\n    .btn--secondary {\n      background: #fff7eb;\n      border-color: rgba($color-primary, 0.55);\n      color: #9a5b08;\n      font-weight: 650;\n\n      &:hover:not(:disabled) {\n        background: #ffefd6;\n        border-color: $color-primary;\n        color: #7a4706;\n      }\n    }\n\n    input[type=\"file\"] {\n      position: absolute;\n      width: 1px;\n      height: 1px;\n      padding: 0;\n      margin: -1px;\n      overflow: hidden;\n      clip: rect(0, 0, 0, 0);\n      white-space: nowrap;\n      border: 0;\n    }\n  }\n\n  &__empty-cta {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 11px 14px;\n    border: 1.5px dashed rgba($color-primary, 0.65);\n    border-radius: 10px;\n    background: linear-gradient(180deg, #fff9f0 0%, #ffefd6 100%);\n    font-size: 13px;\n    color: #9a5b08;\n    font-weight: 650;\n    box-shadow: 0 1px 2px rgba($color-primary, 0.12);\n    transition: background 0.15s ease, border-color 0.15s ease;\n\n    &:hover {\n      background: linear-gradient(180deg, #fff3e0 0%, #ffe4bc 100%);\n      border-color: $color-primary;\n    }\n  }\n\n  &__picker--empty {\n    display: inline-flex;\n    width: fit-content;\n  }\n}\n\n.report-repeater {\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 12px;\n  background: #fff;\n\n  &__row {\n    display: grid;\n    grid-template-columns: auto 1fr;\n    gap: 10px 12px;\n    align-items: start;\n    flex-wrap: wrap;\n    padding: 12px 0;\n    border-bottom: 1px solid #f3f4f6;\n\n    &:last-of-type {\n      border-bottom: none;\n    }\n  }\n\n  &__index {\n    font-weight: 600;\n    font-size: 13px;\n    color: #6b7280;\n    min-width: 28px;\n    padding-top: 6px;\n  }\n\n  &__fields-grid {\n    grid-column: 1 / -1;\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 10px 16px;\n\n    @media (max-width: 720px) {\n      grid-template-columns: 1fr;\n    }\n\n    &--single {\n      grid-template-columns: 1fr;\n    }\n\n    &--entry {\n      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n      gap: 8px 12px;\n    }\n  }\n\n  &__field--answer-cell {\n    min-width: 0;\n    padding: 8px 10px;\n    background: #f8fafc;\n    border: 1px solid #f1f5f9;\n    border-radius: 6px;\n\n    .coop-lookup-answer-block__row:not(.coop-lookup-answer-block__row--answer-only) {\n      grid-template-columns: minmax(0, 0.85fr) minmax(0, 1.15fr);\n      gap: 8px 14px;\n      margin-bottom: 0;\n    }\n  }\n\n  &__field--with-lookup {\n    grid-column: 1 / -1;\n\n    .coop-lookup-answer-block__row:not(.coop-lookup-answer-block__row--answer-only) {\n      grid-template-columns: minmax(0, 0.85fr) minmax(0, 1.15fr);\n      gap: 8px 14px;\n    }\n  }\n\n  &__entry-histories {\n    margin-top: 10px;\n    padding-top: 10px;\n    border-top: 1px dashed #e2e8f0;\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 8px 12px;\n\n    @media (max-width: 640px) {\n      grid-template-columns: 1fr;\n    }\n\n    &--single {\n      grid-template-columns: 1fr;\n    }\n\n    &__item {\n      min-width: 0;\n    }\n\n    .coop-answer-history {\n      margin-top: 4px;\n      padding: 8px 10px;\n    }\n  }\n\n  &__row:not(.report-repeater__row--readonly) &__fields-grid {\n    grid-column: 2;\n  }\n\n  &__row--readonly {\n    display: block;\n\n    .report-repeater__index {\n      display: block;\n      margin-bottom: 8px;\n      padding-top: 0;\n    }\n\n    .report-repeater__fields-grid {\n      grid-column: unset;\n    }\n  }\n\n  &--sub-fields {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 12px 16px;\n    border: none;\n    padding: 0;\n    background: transparent;\n\n    @media (max-width: 720px) {\n      grid-template-columns: 1fr;\n    }\n\n    &.report-repeater--sub-fields-single {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  &__field {\n    flex: 1;\n    min-width: 0;\n    grid-column: auto;\n  }\n\n  &__label {\n    font-size: 11px;\n    color: #6b7280;\n    margin-bottom: 4px;\n    display: block;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n  }\n\n  &__remove {\n    grid-column: 1 / -1;\n    justify-self: end;\n    padding: 4px 10px;\n    background: #fef2f2;\n    color: #b91c1c;\n    border: 1px solid #fecaca;\n    border-radius: 4px;\n    font-size: 12px;\n    cursor: pointer;\n\n    &:hover {\n      background: #fee2e2;\n    }\n  }\n\n  &__add {\n    padding: 6px 14px;\n    background: #f3f4f6;\n    border: 1px dashed #d1d5db;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 13px;\n    margin-top: 8px;\n    width: 100%;\n    text-align: center;\n\n    &:hover {\n      background: #e5e7eb;\n    }\n  }\n}\n\n.report-evidence-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 8px;\n\n  &__item {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    background: #f3f4f6;\n    padding: 4px 10px;\n    border-radius: 4px;\n    font-size: 13px;\n\n    a {\n      color: #1d4ed8;\n    }\n  }\n\n  &__remove {\n    background: none;\n    border: none;\n    color: #b91c1c;\n    cursor: pointer;\n    font-size: 14px;\n    padding: 0 2px;\n  }\n}\n\n// ---- Report Dashboard Page ----\n.report-dashboard {\n  padding: 24px;\n\n  &__header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 24px;\n    flex-wrap: wrap;\n    gap: 12px;\n\n    h1 {\n      font-size: 24px;\n      font-weight: 700;\n      margin: 0;\n    }\n  }\n\n  &__filters {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n    flex-wrap: wrap;\n  }\n\n  &__overview {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n    gap: 16px;\n    margin-bottom: 24px;\n  }\n\n  &__stat {\n    background: #fff;\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n    padding: 20px;\n    text-align: center;\n  }\n\n  &__stat-value {\n    display: block;\n    font-size: 28px;\n    font-weight: 700;\n    color: $color-primary;\n  }\n\n  &__stat-label {\n    display: block;\n    font-size: 13px;\n    color: #6b7280;\n    margin-top: 4px;\n  }\n\n  &__sections {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  &__section {\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n    overflow: hidden;\n    background: #fff;\n  }\n\n  &__section-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 14px 18px;\n    cursor: pointer;\n    background: #f9fafb;\n    transition: background 0.15s;\n\n    &:hover {\n      background: #f3f4f6;\n    }\n\n    h3 {\n      margin: 0;\n      font-size: 16px;\n    }\n  }\n\n  &__tasks {\n    padding: 0;\n    border-top: 1px solid #e5e7eb;\n  }\n\n  &__table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 14px;\n\n    th {\n      background: #f9fafb;\n      padding: 10px 14px;\n      text-align: left;\n      font-weight: 600;\n      font-size: 12px;\n      text-transform: uppercase;\n      color: #6b7280;\n      letter-spacing: 0.5px;\n      border-bottom: 1px solid #e5e7eb;\n    }\n\n    td {\n      padding: 10px 14px;\n      border-bottom: 1px solid #f3f4f6;\n      vertical-align: top;\n    }\n  }\n\n  &__task-row:hover {\n    background: #f9fafb;\n  }\n\n  &__submission-detail {\n    padding: 14px 16px;\n    background: #f3f4f6;\n  }\n\n  &__submission-card {\n    background: #fff;\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n    overflow: hidden;\n    margin-bottom: 12px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  &__submission-head {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 12px 14px;\n    background: #fafafa;\n    border-bottom: 1px solid #e5e7eb;\n  }\n\n  &__submission-head-main {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 10px;\n    font-size: 13px;\n    color: #6b7280;\n\n    strong {\n      color: #111827;\n      font-size: 14px;\n    }\n  }\n\n  &__submission-dates {\n    color: #9ca3af;\n    font-size: 12px;\n  }\n\n  &__event-link {\n    flex-shrink: 0;\n    text-decoration: none;\n    white-space: nowrap;\n  }\n\n  &__submission-body {\n    padding: 16px;\n    background: #fafafa;\n    border-top: none;\n  }\n\n  &__rejection-banner--compact {\n    margin-bottom: 16px;\n  }\n\n  &__no-responses {\n    margin: 0;\n    font-size: 13px;\n    color: #9ca3af;\n    font-style: italic;\n  }\n\n  &__submission-meta {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 8px;\n    font-size: 13px;\n    color: #6b7280;\n\n    strong {\n      color: #111827;\n    }\n  }\n\n  &__submission-values {\n    font-size: 13px;\n    color: #374151;\n    line-height: 1.6;\n    padding: 8px 0;\n\n    div {\n      margin-bottom: 2px;\n    }\n  }\n\n  &__evidence {\n    font-size: 13px;\n    margin-top: 16px;\n    padding-top: 14px;\n    border-top: 1px solid #e5e7eb;\n\n    strong {\n      display: block;\n      margin-bottom: 8px;\n      color: #374151;\n      font-size: 12px;\n      text-transform: uppercase;\n      letter-spacing: 0.03em;\n    }\n  }\n\n  &__evidence-link {\n    display: inline-block;\n    margin-right: 12px;\n    margin-bottom: 4px;\n    color: #1d4ed8;\n    font-size: 13px;\n  }\n\n  &__rejection-info {\n    font-size: 13px;\n    color: #b91c1c;\n    background: #fef2f2;\n    border-radius: 6px;\n    padding: 8px 10px;\n    margin-top: 6px;\n  }\n\n  &__rejection-history {\n    font-size: 13px;\n    margin-top: 8px;\n\n    strong {\n      display: block;\n      margin-bottom: 6px;\n      color: #374151;\n    }\n  }\n\n  &__rejection-history-list {\n    margin: 0;\n    padding-left: 18px;\n    color: #374151;\n    line-height: 1.5;\n\n    li {\n      margin-bottom: 8px;\n    }\n  }\n\n  &__rejection-history-meta {\n    font-size: 12px;\n    color: #6b7280;\n    display: block;\n    margin-bottom: 2px;\n  }\n}\n\n// ---- Cooperative Feature Styles ----\n\n.coop-tabs {\n  display: flex;\n  gap: 0;\n  margin-bottom: 20px;\n  border-bottom: 2px solid #e5e7eb;\n\n  &__tab {\n    padding: 10px 24px;\n    border: none;\n    background: none;\n    font-size: 14px;\n    font-weight: 500;\n    color: #6b7280;\n    cursor: pointer;\n    border-bottom: 2px solid transparent;\n    margin-bottom: -2px;\n    transition: color 0.15s, border-color 0.15s;\n\n    &:hover {\n      color: #374151;\n    }\n\n    &--active {\n      color: $color-primary;\n      border-bottom-color: $color-primary;\n    }\n  }\n}\n\n.coop-management__toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.coop-management__cluster-filter-row {\n  margin-bottom: 16px;\n}\n\n.coop-management__cluster-filter {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 200px;\n}\n\n.coop-management__cluster-filter-label {\n  font-size: 13px;\n  font-weight: 500;\n  color: #374151;\n}\n\n.coop-management__cluster-filter-select {\n  max-width: 280px;\n}\n\n.coop-assignment {\n  &__search {\n    display: flex;\n    gap: 10px;\n    margin-bottom: 20px;\n    align-items: center;\n  }\n\n  &__checklist {\n    max-height: 350px;\n    overflow-y: auto;\n    margin-bottom: 16px;\n  }\n\n  &__check-item {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 10px 0;\n    border-bottom: 1px solid #f3f4f6;\n    cursor: pointer;\n    font-size: 14px;\n\n    input[type=\"checkbox\"] {\n      width: 18px;\n      height: 18px;\n    }\n  }\n}\n\n.coop-lookup-field-wrap {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  gap: 12px;\n  align-items: start;\n\n  @media (max-width: 720px) {\n    grid-template-columns: 1fr;\n  }\n\n  &--solo {\n    grid-template-columns: 1fr;\n  }\n\n  &__input,\n  &__details {\n    min-width: 0;\n  }\n}\n\n.coop-lookup-details {\n  padding: 10px 12px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  height: fit-content;\n\n  &__title {\n    font-size: 11px;\n    font-weight: 600;\n    color: #64748b;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    margin-bottom: 8px;\n  }\n\n  &__grid {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 6px 12px;\n\n    @media (max-width: 480px) {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  &__item {\n    display: flex;\n    flex-direction: column;\n    gap: 1px;\n    min-width: 0;\n  }\n\n  &__label {\n    font-size: 11px;\n    font-weight: 500;\n    color: #94a3b8;\n    line-height: 1.3;\n  }\n\n  &__value {\n    font-size: 13px;\n    color: #334155;\n    word-break: break-word;\n    line-height: 1.35;\n  }\n\n  &--compact {\n    padding: 8px 10px;\n    background: #fff;\n    border-color: #f1f5f9;\n\n    .coop-lookup-details__title {\n      font-size: 10px;\n      margin-bottom: 6px;\n    }\n\n    .coop-lookup-details__grid {\n      gap: 4px 10px;\n    }\n\n    .coop-lookup-details__value {\n      font-size: 12px;\n    }\n  }\n}\n\n.coop-lookup-answer-block {\n  &__row {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n    gap: 12px;\n    align-items: start;\n    margin-bottom: 10px;\n\n    @media (max-width: 720px) {\n      grid-template-columns: 1fr;\n    }\n\n    &--answer-only {\n      grid-template-columns: 1fr;\n      margin-bottom: 0;\n    }\n  }\n\n  &__answer {\n    min-width: 0;\n    font-size: 14px;\n    color: #374151;\n    line-height: 1.45;\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  &__details {\n    min-width: 0;\n  }\n}\n\n.coop-subfield-answers-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px 16px;\n\n  @media (max-width: 720px) {\n    grid-template-columns: 1fr;\n  }\n\n  &--single {\n    grid-template-columns: 1fr;\n  }\n\n  &__cell {\n    min-width: 0;\n    padding: 10px 12px;\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n  }\n}\n\n.coop-answer-value {\n  font-size: 14px;\n  color: #334155;\n  word-break: break-word;\n  line-height: 1.45;\n\n  &--empty {\n    color: #94a3b8;\n  }\n\n  &__link {\n    font-size: 13px;\n    font-weight: 500;\n    color: #1d4ed8;\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n}\n\n.coop-answer-value-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 6px 12px;\n\n  @media (max-width: 480px) {\n    grid-template-columns: 1fr;\n  }\n\n  &--inline {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  &__item {\n    display: flex;\n    flex-direction: column;\n    gap: 1px;\n    min-width: 0;\n  }\n\n  &__label {\n    font-size: 11px;\n    font-weight: 500;\n    color: #94a3b8;\n    line-height: 1.3;\n  }\n\n  &__value {\n    font-size: 13px;\n    color: #334155;\n    word-break: break-word;\n  }\n}\n\n.coop-bank-details {\n  &__grid {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 10px 14px;\n\n    @media (max-width: 640px) {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  &__field {\n    min-width: 0;\n\n    &--full {\n      grid-column: 1 / -1;\n    }\n  }\n\n  &__label {\n    display: block;\n    margin-bottom: 4px;\n    font-size: 12px;\n    font-weight: 600;\n    color: #64748b;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n  }\n\n  &__error {\n    margin: 0 0 8px;\n    font-size: 12px;\n    color: #b91c1c;\n  }\n\n  &__warning {\n    margin: 8px 0 0;\n    font-size: 12px;\n    line-height: 1.45;\n    color: #b45309;\n    background: #fffbeb;\n    border: 1px solid #fcd34d;\n    border-radius: 8px;\n    padding: 8px 10px;\n  }\n\n  &__member-flag {\n    display: inline-block;\n    margin-left: 8px;\n    padding: 2px 8px;\n    border-radius: 999px;\n    font-size: 11px;\n    font-weight: 600;\n    color: #b45309;\n    background: #fffbeb;\n    border: 1px solid #fcd34d;\n    vertical-align: middle;\n  }\n}\n\n.coop-answer-badge {\n  display: inline-block;\n  padding: 2px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n\n  &--yes {\n    background: #dcfce7;\n    color: #15803d;\n  }\n\n  &--no {\n    background: #fef2f2;\n    color: #b91c1c;\n  }\n}\n\n.coop-submitted-answer {\n  &__row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    flex-wrap: wrap;\n    margin-bottom: 6px;\n  }\n\n  &--compact {\n    .coop-submitted-answer__row {\n      justify-content: flex-end;\n      margin-bottom: 4px;\n    }\n\n    .coop-answer-history {\n      margin-top: 6px;\n      padding: 8px 10px;\n    }\n  }\n\n  &__label {\n    font-size: 12px;\n    font-weight: 600;\n    color: #6b7280;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n  }\n\n  &__value {\n    font-size: 15px;\n    color: #0f172a;\n    word-break: break-word;\n  }\n\n  &__correction {\n    margin-top: 12px;\n    padding-top: 12px;\n    border-top: 1px dashed #e5e7eb;\n  }\n}\n\n.coop-answer-history {\n  margin-top: 8px;\n  padding: 10px 12px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n\n  &__title {\n    margin: 0 0 8px;\n    font-size: 11px;\n    font-weight: 600;\n    color: #64748b;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n  }\n\n  &__list {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n  }\n\n  &__item {\n    display: grid;\n    grid-template-columns: minmax(0, 0.85fr) minmax(0, 1.15fr);\n    gap: 8px 14px;\n    align-items: start;\n    padding: 8px 0;\n    border-bottom: 1px solid #f1f5f9;\n\n    &:last-child {\n      padding-bottom: 0;\n      border-bottom: none;\n    }\n\n    &--no-details {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  &__main {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    min-width: 0;\n  }\n\n  &__details {\n    min-width: 0;\n  }\n\n  &__value {\n    font-size: 14px;\n    color: #334155;\n    word-break: break-word;\n    line-height: 1.4;\n    min-width: 0;\n  }\n\n  &__meta {\n    font-size: 11px;\n    color: #94a3b8;\n  }\n}\n\n.coop-form-fill {\n  &__month-panels {\n    margin-bottom: 24px;\n  }\n\n  &__month-panels-title {\n    margin: 0 0 12px;\n    font-size: 16px;\n    font-weight: 600;\n    color: #374151;\n  }\n\n  &__month-accordion {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n\n    &--current {\n      margin-bottom: 8px;\n    }\n  }\n\n  &__month-accordion-item {\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n    background: #fff;\n    overflow: hidden;\n\n    &--collapsed .coop-form-fill__month-accordion-head {\n      border-bottom: none;\n    }\n  }\n\n  &__month-accordion-head {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n    padding: 14px 16px;\n    text-align: left;\n    background: #f9fafb;\n    border: none;\n    border-bottom: 1px solid #e5e7eb;\n    cursor: pointer;\n    font-size: 15px;\n    font-weight: 600;\n    color: #111827;\n\n    &:hover {\n      background: #f3f4f6;\n    }\n\n    &:focus-visible {\n      outline: 2px solid $color-primary;\n      outline-offset: -2px;\n    }\n  }\n\n  &__month-accordion-chevron {\n    font-size: 12px;\n    color: #6b7280;\n    width: 18px;\n    flex-shrink: 0;\n  }\n\n  &__month-accordion-title {\n    flex: 1;\n    min-width: 0;\n  }\n\n  &__month-accordion-body {\n    padding: 16px;\n    background: #f9fafb;\n  }\n\n  &__header {\n    margin-bottom: 20px;\n\n    h2 {\n      margin: 0 0 4px;\n      font-size: 22px;\n    }\n  }\n\n  &__step {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  &__step-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 16px;\n    flex-wrap: wrap;\n\n    h2 {\n      margin: 0 0 4px;\n      font-size: 20px;\n      font-weight: 700;\n      color: #0f172a;\n    }\n\n    p {\n      margin: 0;\n      color: #6b7280;\n      font-size: 14px;\n    }\n  }\n\n  &__year-nav {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  &__year-label {\n    min-width: 56px;\n    text-align: center;\n    font-size: 16px;\n    font-weight: 600;\n    color: #0f172a;\n  }\n\n  &__month-grid {\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    gap: 12px;\n  }\n\n  &__month-card {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    padding: 20px 12px;\n    background: #fff;\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n    cursor: pointer;\n    transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;\n    color: #0f172a;\n\n    &:hover {\n      border-color: $color-primary;\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n    }\n\n    &:focus-visible {\n      outline: 2px solid $color-primary;\n      outline-offset: 2px;\n    }\n\n    &--current {\n      border-color: $color-primary;\n      background: #fff7ed;\n    }\n  }\n\n  &__month-short {\n    font-size: 18px;\n    font-weight: 700;\n  }\n\n  &__month-full {\n    font-size: 12px;\n    color: #6b7280;\n  }\n\n  &__year-type-grid {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 16px;\n  }\n\n  &__year-type-card {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n    padding: 24px;\n    background: #fff;\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n    cursor: pointer;\n    text-align: left;\n    transition: border-color 0.15s ease, box-shadow 0.15s ease;\n\n    h3 {\n      margin: 0;\n      font-size: 18px;\n      font-weight: 700;\n      color: #0f172a;\n    }\n\n    p {\n      margin: 0;\n      font-size: 14px;\n      color: #6b7280;\n      line-height: 1.5;\n    }\n\n    &:hover {\n      border-color: $color-primary;\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n    }\n\n    &:focus-visible {\n      outline: 2px solid $color-primary;\n      outline-offset: 2px;\n    }\n  }\n\n  &__coop-grid {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 12px;\n  }\n\n  &__coop-card {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n    padding: 16px 18px;\n    background: #fff;\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n    cursor: pointer;\n    text-align: left;\n    transition: border-color 0.15s ease, box-shadow 0.15s ease;\n\n    &:hover:not(:disabled) {\n      border-color: $color-primary;\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n    }\n\n    &:focus-visible {\n      outline: 2px solid $color-primary;\n      outline-offset: 2px;\n    }\n\n    &--disabled {\n      opacity: 0.5;\n      cursor: not-allowed;\n    }\n  }\n\n  &__coop-name {\n    font-size: 15px;\n    font-weight: 600;\n    color: #0f172a;\n    line-height: 1.4;\n  }\n\n  &__coop-status {\n    font-size: 12px;\n    font-weight: 500;\n\n    &--draft {\n      color: #d97706;\n    }\n\n    &--submitted {\n      color: #16a34a;\n    }\n  }\n\n  @media (max-width: 900px) {\n    &__coop-grid {\n      grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n    &__month-grid {\n      grid-template-columns: repeat(3, minmax(0, 1fr));\n    }\n  }\n\n  @media (max-width: 600px) {\n    &__month-grid {\n      grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n\n    &__year-type-grid,\n    &__coop-grid {\n      grid-template-columns: 1fr;\n    }\n  }\n}\n\n.coop-progress {\n  &__summary {\n    display: flex;\n    gap: 16px;\n    margin-bottom: 24px;\n    flex-wrap: wrap;\n  }\n\n  &__stat {\n    flex: 1;\n    min-width: 120px;\n    padding: 16px;\n    background: #fff;\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n    text-align: center;\n\n    &--success {\n      border-color: #86efac;\n      background: #f0fdf4;\n    }\n\n    &--warning {\n      border-color: #fcd34d;\n      background: #fffbeb;\n    }\n\n    &--muted {\n      border-color: #e5e7eb;\n      background: #f9fafb;\n    }\n\n    &--clickable {\n      text-decoration: none;\n      color: inherit;\n      cursor: pointer;\n      transition: box-shadow 0.15s ease, border-color 0.15s ease;\n\n      &:hover {\n        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n      }\n\n      &:focus-visible {\n        outline: 2px solid $color-primary;\n        outline-offset: 2px;\n      }\n    }\n  }\n\n  &__stat-value {\n    display: block;\n    font-size: 28px;\n    font-weight: 700;\n    color: #111827;\n  }\n\n  &__stat-label {\n    display: block;\n    font-size: 12px;\n    color: #6b7280;\n    margin-top: 4px;\n    text-transform: uppercase;\n    letter-spacing: 0.3px;\n  }\n\n  &__bar {\n    width: 100px;\n    height: 8px;\n    background: #e5e7eb;\n    border-radius: 4px;\n    overflow: hidden;\n  }\n\n  &__bar-fill {\n    height: 100%;\n    background: $color-primary;\n    border-radius: 4px;\n    transition: width 0.3s ease;\n  }\n\n  &__filters {\n    margin-bottom: 20px;\n    padding: 14px 16px;\n    background: #fff;\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n  }\n\n  &__filters-row {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-end;\n    gap: 12px 16px;\n  }\n\n  &__filter-field {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    min-width: 160px;\n  }\n\n  &__filter-label {\n    font-size: 12px;\n    font-weight: 600;\n    color: #374151;\n    text-transform: uppercase;\n    letter-spacing: 0.3px;\n  }\n\n  &__filters-coops {\n    margin-top: 14px;\n    padding-top: 14px;\n    border-top: 1px solid #e5e7eb;\n  }\n\n  &__filters-coops-actions {\n    display: flex;\n    gap: 8px;\n    margin: 8px 0 10px;\n    flex-wrap: wrap;\n  }\n\n  &__filters-coops-list {\n    max-height: 200px;\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    padding: 8px 10px;\n    background: #f9fafb;\n    border-radius: 8px;\n    border: 1px solid #e5e7eb;\n  }\n\n  &__filters-coop-item {\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n    font-size: 13px;\n    color: #1f2937;\n    cursor: pointer;\n\n    input {\n      margin-top: 2px;\n      flex-shrink: 0;\n    }\n  }\n\n  &__tree {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    margin-bottom: 24px;\n  }\n\n  &__cluster-block {\n    padding: 16px 18px;\n    background: #fff;\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n  }\n\n  &__cluster-link {\n    font-size: 17px;\n    font-weight: 700;\n    color: $color-primary;\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  &__cluster-meta {\n    display: block;\n    font-size: 12px;\n    color: #6b7280;\n    margin: 4px 0 12px;\n  }\n\n  &__coop-list {\n    list-style: none;\n    margin: 0;\n    padding: 0 0 0 12px;\n    border-left: 2px solid #e5e7eb;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n\n    li {\n      font-size: 14px;\n    }\n\n    a {\n      color: #1f2937;\n      font-weight: 600;\n      text-decoration: none;\n\n      &:hover {\n        color: $color-primary;\n        text-decoration: underline;\n      }\n    }\n  }\n\n  &__coop-hint {\n    font-size: 12px;\n    font-weight: 400;\n    color: #9ca3af;\n    margin-left: 4px;\n  }\n\n  &__inline-answers {\n    margin-top: 8px;\n  }\n\n  &__coop-accordion {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  &__coop-accordion-item {\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n    background: #fff;\n    overflow: hidden;\n  }\n\n  &__coop-accordion-head {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n    padding: 14px 16px;\n    text-align: left;\n    background: #f9fafb;\n    border: none;\n    border-bottom: 1px solid #e5e7eb;\n    cursor: pointer;\n    font-size: 15px;\n    font-weight: 600;\n    color: #111827;\n\n    &:hover {\n      background: #f3f4f6;\n    }\n  }\n\n  &__coop-accordion-chevron {\n    font-size: 12px;\n    color: #6b7280;\n    width: 18px;\n    flex-shrink: 0;\n  }\n\n  &__coop-accordion-title {\n    flex: 1;\n    min-width: 0;\n  }\n\n  &__coop-accordion-body {\n    padding: 16px 18px;\n    border-top: 1px solid #f3f4f6;\n  }\n\n  &__completed-coop-list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  &__completed-coop-row {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 10px;\n    padding: 14px 16px;\n    background: #fff;\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n  }\n\n  &__completed-coop-link {\n    font-size: 15px;\n    font-weight: 600;\n    color: $color-primary;\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n}\n\n.coop-progress-detail {\n  &__back {\n    display: inline-block;\n    margin-bottom: 12px;\n    font-size: 14px;\n    color: #4b5563;\n    text-decoration: none;\n\n    &:hover {\n      color: $color-primary;\n      text-decoration: underline;\n    }\n  }\n\n  &__sections {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n  }\n\n  &__card {\n    padding: 18px 20px;\n    background: #fff;\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n  }\n\n  &__card-head {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 14px;\n\n    h2 {\n      margin: 0;\n      font-size: 18px;\n    }\n  }\n}\n\n// Coop form builder: select choices (one per row; commas allowed)\n.coop-select-options {\n  margin-top: 8px;\n\n  &__hint {\n    margin: 0 0 10px;\n    font-size: 12px;\n    color: #6b7280;\n    line-height: 1.4;\n  }\n\n  &__row {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n    margin-bottom: 8px;\n\n    .form-input {\n      flex: 1;\n      min-width: 0;\n    }\n  }\n\n  &__glyph {\n    width: 16px;\n    height: 16px;\n    flex-shrink: 0;\n    display: inline-block;\n    border: 1.5px solid #d8dce3;\n\n    &--box {\n      border-radius: 4px;\n    }\n  }\n\n  &--inline {\n    .coop-select-options__row {\n      margin-bottom: 6px;\n    }\n  }\n}\n\n.coop-members-editor {\n  margin-bottom: 20px;\n  padding: 16px;\n  border: 1px solid #d1fae5;\n  border-radius: 10px;\n  background: #ecfdf5;\n\n  &__head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    margin-bottom: 6px;\n  }\n\n  &__title {\n    margin: 0;\n    font-size: 15px;\n    font-weight: 600;\n    color: #065f46;\n  }\n\n  &__count {\n    font-size: 13px;\n    font-weight: 600;\n    color: #047857;\n  }\n\n  &__hint {\n    margin: 0 0 12px;\n    font-size: 13px;\n    color: #047857;\n    line-height: 1.45;\n  }\n\n  &__list {\n    list-style: none;\n    margin: 0 0 12px;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  &__row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 10px 12px;\n    background: #fff;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n  }\n\n  &__info {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 8px;\n    min-width: 0;\n  }\n\n  &__meta {\n    font-size: 12px;\n    color: #6b7280;\n  }\n\n  &__role {\n    font-size: 11px;\n    font-weight: 600;\n    color: #7c3aed;\n    text-transform: capitalize;\n  }\n\n  &__role-field {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    width: 100%;\n    min-width: 180px;\n  }\n\n  &__role-label {\n    font-size: 11px;\n    font-weight: 600;\n    color: #6b7280;\n    text-transform: uppercase;\n    letter-spacing: 0.02em;\n  }\n\n  &__role-select {\n    min-width: 180px;\n    max-width: 240px;\n    padding: 6px 8px;\n    font-size: 13px;\n  }\n\n  &__add-role {\n    margin-bottom: 8px;\n    max-width: 280px;\n  }\n\n  &__remove {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    flex-shrink: 0;\n  }\n\n  &__empty {\n    padding: 10px 12px;\n    font-size: 13px;\n    color: #92400e;\n    background: #fffbeb;\n    border-radius: 8px;\n  }\n\n  &__add-label {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 13px;\n    font-weight: 600;\n    color: #374151;\n    margin-bottom: 6px;\n  }\n\n  &__lookup-status {\n    margin: 6px 0 0;\n    font-size: 12px;\n    color: #6b7280;\n  }\n\n  &__lookup {\n    list-style: none;\n    margin: 8px 0 0;\n    padding: 0;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    background: #fff;\n    max-height: 220px;\n    overflow-y: auto;\n  }\n\n  &__lookup-item {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 8px;\n    width: 100%;\n    padding: 10px 12px;\n    text-align: left;\n    border: none;\n    border-bottom: 1px solid #f3f4f6;\n    background: transparent;\n    cursor: pointer;\n    font-size: 13px;\n\n    &:last-child {\n      border-bottom: none;\n    }\n\n    &:hover:not(:disabled) {\n      background: #f9fafb;\n    }\n\n    &:disabled {\n      opacity: 0.55;\n      cursor: not-allowed;\n    }\n  }\n\n  &__already {\n    margin-left: auto;\n    font-size: 11px;\n    color: #6b7280;\n  }\n\n  &__max {\n    margin: 0;\n    font-size: 13px;\n    color: #92400e;\n  }\n\n  &__past {\n    margin-top: 16px;\n    padding-top: 14px;\n    border-top: 1px solid #d1d5db;\n  }\n\n  &__past-title {\n    margin: 0 0 4px;\n    font-size: 14px;\n    font-weight: 600;\n    color: #4b5563;\n  }\n\n  &__past-hint {\n    margin: 0 0 10px;\n    font-size: 12px;\n    color: #6b7280;\n    line-height: 1.45;\n  }\n\n  &__past-list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n  }\n\n  &__past-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 8px 10px;\n    background: #f9fafb;\n    border: 1px dashed #d1d5db;\n    border-radius: 8px;\n    opacity: 0.92;\n  }\n\n  &__past-date {\n    font-size: 11px;\n    color: #9ca3af;\n    flex-shrink: 0;\n  }\n\n  &__add-actions {\n    margin-bottom: 12px;\n  }\n\n  &__register-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n  }\n}\n\n.msp-reg-modal {\n  &__overlay {\n    position: fixed;\n    inset: 0;\n    z-index: 1200;\n    background: rgba(15, 23, 42, 0.55);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 20px;\n  }\n\n  &__content {\n    width: min(960px, 100%);\n    max-height: min(92vh, 900px);\n    background: #fff;\n    border-radius: 12px;\n    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.2);\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n  }\n\n  &__header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 16px;\n    padding: 20px 24px 12px;\n    border-bottom: 1px solid #e5e7eb;\n  }\n\n  &__title {\n    margin: 0;\n    font-size: 20px;\n    font-weight: 600;\n    color: #111827;\n  }\n\n  &__subtitle {\n    margin: 6px 0 0;\n    font-size: 13px;\n    color: #6b7280;\n  }\n\n  &__close {\n    border: none;\n    background: transparent;\n    font-size: 28px;\n    line-height: 1;\n    color: #6b7280;\n    cursor: pointer;\n    padding: 0 4px;\n  }\n\n  &__form {\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n    flex: 1;\n  }\n\n  &__body {\n    overflow: auto;\n    padding: 16px 24px;\n  }\n\n  &__footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n    padding: 16px 24px;\n    border-top: 1px solid #e5e7eb;\n    background: #f9fafb;\n  }\n\n  &__error-list {\n    margin: 8px 0 0;\n    padding-left: 18px;\n  }\n\n  &__photo {\n    margin-bottom: 20px;\n    padding-bottom: 16px;\n    border-bottom: 1px solid #e5e7eb;\n  }\n\n  &__photo-hint {\n    margin: 0 0 12px;\n    font-size: 12px;\n    color: #6b7280;\n  }\n\n  &__photo-preview {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n\n    img {\n      width: 120px;\n      height: 120px;\n      object-fit: cover;\n      border-radius: 8px;\n      border: 1px solid #d1d5db;\n    }\n  }\n\n  &__photo-upload input[type='file'] {\n    display: none;\n  }\n\n  &__photo-error {\n    margin-top: 10px;\n  }\n\n  &__role {\n    margin-bottom: 16px;\n    max-width: 320px;\n  }\n}\n\n.msp-reg-form {\n  &__grid {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 14px 16px;\n\n    @media (max-width: 768px) {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  &__group--full {\n    grid-column: 1 / -1;\n  }\n\n  &__label {\n    display: block;\n    margin-bottom: 6px;\n    font-size: 13px;\n    font-weight: 500;\n    color: #374151;\n  }\n\n  &__input {\n    width: 100%;\n    padding: 10px 12px;\n    border: 1px solid #d1d5db;\n    border-radius: 8px;\n    font-size: 14px;\n    background: #fff;\n\n    &:disabled {\n      background: #f3f4f6;\n      color: #6b7280;\n    }\n  }\n}\n.coop-audit-log {\n  padding: 24px 28px 40px;\n  max-width: 1600px;\n\n  &__header {\n    margin-bottom: 20px;\n  }\n\n  &__title {\n    margin: 0 0 6px;\n    font-size: 26px;\n    font-weight: 700;\n    color: #111827;\n    display: flex;\n    align-items: center;\n  }\n\n  &__subtitle {\n    margin: 0;\n    color: #6b7280;\n    font-size: 14px;\n  }\n\n  &__filters {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n    gap: 12px 16px;\n    padding: 16px;\n    background: #fff;\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n    margin-bottom: 20px;\n  }\n\n  &__field {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    font-size: 12px;\n    color: #6b7280;\n\n    select,\n    input {\n      padding: 8px 10px;\n      border: 1px solid #d1d5db;\n      border-radius: 8px;\n      font-size: 14px;\n      color: #111827;\n      background: #fff;\n    }\n  }\n\n  &__filter-actions {\n    display: flex;\n    align-items: flex-end;\n    gap: 8px;\n    grid-column: 1 / -1;\n  }\n\n  &__error {\n    margin-bottom: 16px;\n    padding: 10px 14px;\n    background: #fef2f2;\n    color: #b91c1c;\n    border-radius: 8px;\n    font-size: 14px;\n  }\n\n  &__layout {\n    display: grid;\n    grid-template-columns: minmax(0, 1.4fr) minmax(280px, 0.9fr);\n    gap: 20px;\n    align-items: start;\n  }\n\n  &__table-wrap {\n    background: #fff;\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n    overflow: auto;\n  }\n\n  &__table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 13px;\n\n    th,\n    td {\n      padding: 10px 12px;\n      text-align: left;\n      border-bottom: 1px solid #f3f4f6;\n      vertical-align: top;\n    }\n\n    th {\n      background: #f9fafb;\n      font-weight: 600;\n      color: #374151;\n      white-space: nowrap;\n    }\n\n    tbody tr {\n      cursor: pointer;\n\n      &:hover {\n        background: #f9fafb;\n      }\n    }\n  }\n\n  &__row--selected {\n    background: #fff7ed !important;\n  }\n\n  &__badge {\n    display: inline-block;\n    padding: 2px 8px;\n    border-radius: 999px;\n    font-size: 11px;\n    font-weight: 600;\n    text-transform: capitalize;\n    background: #f3f4f6;\n    color: #374151;\n\n    &--draft {\n      background: #fef3c7;\n      color: #92400e;\n    }\n\n    &--submit {\n      background: #dcfce7;\n      color: #166534;\n    }\n\n    &--correction {\n      background: #dbeafe;\n      color: #1e40af;\n    }\n\n    &--admin_clear,\n    &--admin_reopen {\n      background: #fce7f3;\n      color: #9d174d;\n    }\n  }\n\n  &__pagination {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 12px 14px;\n    border-top: 1px solid #e5e7eb;\n    font-size: 13px;\n    color: #6b7280;\n  }\n\n  &__detail {\n    background: #fff;\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n    padding: 16px 18px;\n    position: sticky;\n    top: 16px;\n    max-height: calc(100vh - 48px);\n    overflow: auto;\n\n    h2 {\n      margin: 0 0 12px;\n      font-size: 18px;\n    }\n\n    h3 {\n      margin: 16px 0 8px;\n      font-size: 13px;\n      color: #374151;\n    }\n  }\n\n  &__meta {\n    margin: 0;\n    display: grid;\n    gap: 10px;\n    font-size: 13px;\n\n    div {\n      display: grid;\n      gap: 2px;\n    }\n\n    dt {\n      margin: 0;\n      color: #9ca3af;\n      font-size: 11px;\n      text-transform: uppercase;\n      letter-spacing: 0.03em;\n    }\n\n    dd {\n      margin: 0;\n      color: #111827;\n    }\n  }\n\n  &__snapshot pre {\n    margin: 0;\n    padding: 10px 12px;\n    background: #f9fafb;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    font-size: 12px;\n    line-height: 1.45;\n    white-space: pre-wrap;\n    word-break: break-word;\n    max-height: 280px;\n    overflow: auto;\n  }\n\n  &__muted {\n    margin: 0;\n    padding: 24px 16px;\n    color: #9ca3af;\n    font-size: 14px;\n    text-align: center;\n  }\n\n  @media (max-width: 1100px) {\n    &__layout {\n      grid-template-columns: 1fr;\n    }\n\n    &__detail {\n      position: static;\n      max-height: none;\n    }\n  }\n}\n",".issue-reports {\n  padding: 20px;\n\n  &__container {\n    max-width: 1200px;\n    margin: 0 auto;\n  }\n\n  &__header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 16px;\n    margin-bottom: 16px;\n  }\n\n  &__title {\n    font-size: 24px;\n    font-weight: 700;\n    margin: 0;\n  }\n\n  &__subtitle {\n    margin: 6px 0 0;\n    color: #6b7280;\n    font-size: 14px;\n  }\n\n  &__header-actions {\n    display: flex;\n    gap: 10px;\n  }\n\n  &__filters {\n    display: grid;\n    grid-template-columns: 2fr 1fr 1fr 160px;\n    gap: 12px;\n    margin: 16px 0;\n\n    @media (max-width: 900px) {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  &__filter {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n\n    &--small {\n      max-width: 220px;\n    }\n  }\n\n  &__label {\n    font-size: 12px;\n    color: #6b7280;\n  }\n\n  &__input {\n    width: 100%;\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n    padding: 10px 12px;\n    background: #fff;\n    outline: none;\n  }\n\n  &__button {\n    border: 1px solid #111827;\n    background: #111827;\n    color: #fff;\n    border-radius: 10px;\n    padding: 10px 12px;\n    cursor: pointer;\n\n    &:disabled {\n      opacity: 0.6;\n      cursor: not-allowed;\n    }\n\n    &--secondary {\n      background: #fff;\n      color: #111827;\n    }\n  }\n\n  &__error {\n    background: #fef2f2;\n    border: 1px solid #fecaca;\n    color: #991b1b;\n    padding: 10px 12px;\n    border-radius: 12px;\n    margin: 12px 0;\n  }\n\n  &__table-wrap {\n    overflow: auto;\n    border: 1px solid #e5e7eb;\n    border-radius: 14px;\n    background: #fff;\n  }\n\n  &__table {\n    width: 100%;\n    border-collapse: collapse;\n    min-width: 900px;\n\n    th,\n    td {\n      padding: 12px 14px;\n      border-bottom: 1px solid #f3f4f6;\n      font-size: 14px;\n      vertical-align: top;\n    }\n\n    th {\n      text-align: left;\n      font-size: 12px;\n      letter-spacing: 0.02em;\n      text-transform: uppercase;\n      color: #6b7280;\n      background: #fafafa;\n      position: sticky;\n      top: 0;\n      z-index: 1;\n    }\n\n    tr:hover td {\n      background: #fcfcfd;\n    }\n  }\n\n  &__empty {\n    text-align: center;\n    color: #6b7280;\n    padding: 24px 14px !important;\n  }\n\n  &__mono {\n    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\",\n      \"Courier New\", monospace;\n  }\n\n  &__link {\n    background: transparent;\n    border: 0;\n    color: #2563eb;\n    cursor: pointer;\n    font-weight: 600;\n  }\n\n  &__pill {\n    display: inline-flex;\n    align-items: center;\n    padding: 4px 10px;\n    border-radius: 999px;\n    font-size: 12px;\n    font-weight: 700;\n    text-transform: capitalize;\n    border: 1px solid transparent;\n\n    &--whistleblowing {\n      background: #fff7ed;\n      color: #9a3412;\n      border-color: #fed7aa;\n    }\n\n    &--safety {\n      background: #eff6ff;\n      color: #1d4ed8;\n      border-color: #bfdbfe;\n    }\n\n    &--status-pending {\n      background: #fefce8;\n      color: #854d0e;\n      border-color: #fde68a;\n      text-transform: none;\n    }\n\n    &--status-under-review {\n      background: #eef2ff;\n      color: #3730a3;\n      border-color: #c7d2fe;\n      text-transform: none;\n    }\n\n    &--status-resolved {\n      background: #ecfdf5;\n      color: #065f46;\n      border-color: #a7f3d0;\n      text-transform: none;\n    }\n\n    &--status-dismissed {\n      background: #f3f4f6;\n      color: #374151;\n      border-color: #e5e7eb;\n      text-transform: none;\n    }\n  }\n\n  &__pagination {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px 0 2px;\n    color: #6b7280;\n    font-size: 13px;\n  }\n}\n\n.issue-report-detail {\n  padding: 20px;\n\n  &__container {\n    max-width: 1200px;\n    margin: 0 auto;\n  }\n\n  &__topbar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    margin-bottom: 14px;\n  }\n\n  &__back {\n    color: #2563eb;\n    text-decoration: none;\n    font-weight: 600;\n  }\n\n  &__loading {\n    color: #6b7280;\n    padding: 12px 0;\n  }\n\n  &__header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 12px;\n    margin: 12px 0 16px;\n  }\n\n  &__title {\n    margin: 0;\n    font-size: 22px;\n    font-weight: 800;\n  }\n\n  &__meta {\n    display: flex;\n    gap: 8px;\n    flex-wrap: wrap;\n  }\n\n  &__grid {\n    display: grid;\n    grid-template-columns: 420px 1fr;\n    gap: 14px;\n\n    @media (max-width: 1000px) {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  &__card {\n    border: 1px solid #e5e7eb;\n    background: #fff;\n    border-radius: 14px;\n    padding: 14px;\n  }\n\n  &__card-title {\n    margin: 0 0 10px;\n    font-size: 14px;\n    color: #111827;\n    font-weight: 800;\n  }\n\n  &__fields {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n\n  &__field {\n    display: grid;\n    grid-template-columns: 140px 1fr;\n    gap: 10px;\n    align-items: start;\n\n    @media (max-width: 520px) {\n      grid-template-columns: 1fr;\n      gap: 4px;\n    }\n  }\n\n  &__label {\n    font-size: 12px;\n    color: #6b7280;\n  }\n\n  &__value {\n    font-size: 14px;\n    color: #111827;\n\n    &--mono {\n      font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\",\n        \"Courier New\", monospace;\n    }\n\n    &--pre {\n      white-space: pre-wrap;\n      word-break: break-word;\n      background: #fafafa;\n      border: 1px solid #f3f4f6;\n      padding: 10px 12px;\n      border-radius: 12px;\n    }\n  }\n}\n\n","@import url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap');\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
